import React, { useState, useEffect, useRef } from 'react';
import { supabase } from './supabase';
import './App.css';
import InstallPrompt from './components/InstallPrompt'; // ✅ NEW: 홈 화면에 추가 배너
import Hero from './Hero'; // ✅ NEW(260826): 첫 화면 한 줄 소개

// ✅ NEW: 일별 방문자/신규회원/누적회원 요약 (어드민 최상단 위젯)
// get_daily_visitor_summary RPC를 호출함 — 서버(RPC 내부)에서 is_admin() 재검증하므로,
// 프론트의 isAdmin 플래그가 뚫려도 실제 데이터는 진짜 관리자 계정에만 내려감.
function DailyVisitorSummary() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase.rpc('get_daily_visitor_summary');
      if (cancelled) return;
      if (error) setErrorMsg(error.message);
      else setRows(data || []);
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  // ✅ NEW: RPC가 날짜 DESC로 내려주므로 첫 행이 오늘 데이터
  const today = rows[0];

  return (
    <div style={{ background: '#fff', padding: '15px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', marginBottom: '20px' }}>
      {/* ✅ NEW: 오늘 방문자수 요약 카드 — 아래 표를 접어놔도 항상 보임 */}
      {!loading && !errorMsg && today && (
        <div style={{ display: 'flex', gap: '10px', marginBottom: collapsed ? '0' : '14px' }}>
          <div style={{ flex: 1, background: '#f0f7ff', borderRadius: '8px', padding: '10px 14px' }}>
            <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>오늘 방문자수</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#1565c0' }}>{today.방문자수}명</div>
          </div>
          <div style={{ flex: 1, background: '#f6fff0', borderRadius: '8px', padding: '10px 14px' }}>
            <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>오늘 신규회원</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#2e7d32' }}>{today.신규회원수}명</div>
          </div>
        </div>
      )}

      <div
        onClick={() => setCollapsed(!collapsed)}
        style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: collapsed ? '0' : '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
      >
        <span>📊 일별 방문자·신규회원 추이 (최근 30일)</span>
        <span style={{ fontSize: '12px', color: '#999', fontWeight: 'normal' }}>{collapsed ? '▼ 펼치기' : '▲ 접기'}</span>
      </div>
      {!collapsed && (
        loading ? (
          <div style={{ fontSize: '12px', color: '#999' }}>불러오는 중...</div>
        ) : errorMsg ? (
          <div style={{ fontSize: '12px', color: '#d32f2f' }}>불러오기 실패: {errorMsg}</div>
        ) : rows.length === 0 ? (
          <div style={{ fontSize: '12px', color: '#999' }}>아직 쌓인 기록이 없어요.</div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #111' }}>
                  <th style={{ textAlign: 'left', padding: '6px 10px' }}>날짜</th>
                  <th style={{ textAlign: 'right', padding: '6px 10px' }}>방문자수</th>
                  <th style={{ textAlign: 'right', padding: '6px 10px' }}>신규회원수</th>
                  <th style={{ textAlign: 'right', padding: '6px 10px' }}>누적회원수</th>
                </tr>
              </thead>
              <tbody>
                {rows.map(r => (
                  <tr key={r.날짜} style={{ borderBottom: '1px solid #f1f1f1' }}>
                    <td style={{ padding: '6px 10px' }}>{r.날짜}</td>
                    <td style={{ padding: '6px 10px', textAlign: 'right' }}>{r.방문자수}</td>
                    <td style={{ padding: '6px 10px', textAlign: 'right' }}>{r.신규회원수}</td>
                    <td style={{ padding: '6px 10px', textAlign: 'right', fontWeight: 'bold' }}>{r.누적회원수}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}

// ⚡ PERF(이미지 리사이징): 네이버 이미지 CDN은 URL에 type 파라미터를 붙이면
// 서버에서 리사이즈된 이미지를 내려줌. 200px 썸네일 자리에 500kB짜리 원본을
// 그대로 받던 것을 줄이기 위함.
//
// 🐛 FIX(2026-08-17): 서브도메인마다 파라미터 형식이 다르고, 임의의 숫자를 넣으면
// 안 됨(지원하는 프리셋 값이 정해져 있음). ?type=w500로 요청했더니 신규 수집 상품
// 사진이 전부 안 뜨는 사고가 났음.
//   · shopping-phinf.pstatic.net (검색API 이미지, 옛 상품)   -> ?type=f{width}  (f500 등 검증됨)
//   · shop-phinf.pstatic.net     (스마트스토어 원본, 신규 상품) -> ?type=w{프리셋}
// shop-phinf는 실제로 관측된 프리셋(80/140/300/640/860)으로 '스냅'해서 요청한다.
//
// 그리고 무엇보다, 리사이즈가 실패해도 사진이 안 보이는 일이 없도록
// 아래 SmartImg가 onError 시 원본 URL로 자동 폴백한다(자가복구).
const NAVER_IMG_TYPE_PARAM = {
  'shopping-phinf.pstatic.net': 'f',
  'shop-phinf.pstatic.net': 'w',
};

// shop-phinf가 실제로 내려주는 것이 확인된 폭 프리셋
const SHOP_PHINF_PRESETS = [80, 140, 300, 640, 860];

function snapPreset(width) {
  for (const p of SHOP_PHINF_PRESETS) {
    if (width <= p) return p;
  }
  return SHOP_PHINF_PRESETS[SHOP_PHINF_PRESETS.length - 1];
}

function resizeImg(url, width) {
  if (!url || typeof url !== 'string') return url;
  try {
    const u = new URL(url);
    const prefix = NAVER_IMG_TYPE_PARAM[u.hostname];
    if (!prefix) return url;                     // 모르는 호스트는 원본 그대로
    if (u.searchParams.has('type')) return url;  // 이미 리사이즈 지정됨
    const w = prefix === 'w' ? snapPreset(width) : width;
    u.searchParams.set('type', prefix + w);
    return u.toString();
  } catch (e) {
    return url; // URL 파싱 실패 시 원본 유지
  }
}

// ✅ 자가복구 이미지: 리사이즈된 주소로 먼저 시도하고, 실패하면 원본으로 자동 전환.
// 네이버가 프리셋을 바꾸거나 외부 임베드를 막아도 사진이 안 보이는 일은 없게 만든다.
// referrerPolicy는 CDN 핫링크 차단(리퍼러 기반)을 피하기 위한 것.
function SmartImg({ src, width, ...rest }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => { setFailed(false); }, [src]);

  const finalSrc = failed ? src : resizeImg(src, width);

  return (
    <img
      src={finalSrc}
      referrerPolicy="no-referrer"
      onError={() => { if (!failed) setFailed(true); }}
      {...rest}
    />
  );
}

function App() {
  const [products, setProducts] = useState([]);
  const [recentClicks, setRecentClicks] = useState({});
  const [category, setCategory] = useState('전체');
  const [view, setView] = useState('NEWARRIVAL'); // ✅ CHANGE(2026-09-05): 첫 진입을 '신상'으로. 세일 탭은 4번째로 밀림 
  const [selectedProduct, setSelectedProduct] = useState(null); 
  // ===== LABEL_LEAN_FETCH 시작 =====
  // store_image / store_title 은 상세 모달과 어드민 표에서만 쓰는데,
  // 목록 조회에 섞여 있으면 링크 2,370건분(약 404kB)을 모든 방문자가 매번 받는다.
  // 그래서 목록에서 빼고, 필요한 시점에 product_id별로 받아 여기에 채운다.
  // 구조: { [product_id]: { [store_id]: { store_title, store_image } } }
  const [linkExtras, setLinkExtras] = useState({});
  const [adminExtrasDone, setAdminExtrasDone] = useState(false);
  // ===== LABEL_LEAN_FETCH 끝 =====
  const [showApplyModal, setShowApplyModal] = useState(false); // LABEL_APPLY
  const [applyType, setApplyType] = useState('daily');          // 'daily' | 'brand'
  const [applyStep, setApplyStep] = useState('guide');          // 'guide' | 'form'
  const [applyForm, setApplyForm] = useState({ name: '', phone: '', bizName: '', storeUrl: '', memo: '' });
  const [slotStats, setSlotStats] = useState({}); // LABEL_SLOT_STATS: 슬롯별 노출/클릭 집계 (slot_id -> 수치)
  const [slotOwnerEmail, setSlotOwnerEmail] = useState(''); // LABEL_OWNER_EMAIL: 소매상 이메일로 user_id 찾기
  const [promoSlot, setPromoSlot] = useState(null); // LABEL_PROMO_POPUP: 당일 슬롯 프로모 팝업 대상 (null이면 닫힘)
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminSearch, setAdminSearch] = useState('');
  const [adminLayout, setAdminLayout] = useState('TABLE'); 
  const [showMyStoreOnly, setShowMyStoreOnly] = useState(false); // ✅ NEW: 그로브(내 스토어)만 모아보기 필터
  const [showBizGuideModal, setShowBizGuideModal] = useState(false); // ✅ NEW: 도매 브랜드 입점 안내 모달 (8번)
  const [dailySlots, setDailySlots] = useState([]); // ✅ NEW: 당일(재고보유) 슬롯 목록
  const [showSlotManageModal, setShowSlotManageModal] = useState(false); // ✅ NEW: 소매상 본인 슬롯 상품 교체 모달
  const [showAdminSlotPanel, setShowAdminSlotPanel] = useState(false); // ✅ NEW: 어드민 슬롯 발급/관리 패널
  // ===== LABEL_APPLY_ADMIN 시작 =====
  const [slotApplications, setSlotApplications] = useState([]);
  const [slotApplyLoading, setSlotApplyLoading] = useState(false);
  const [showSlotApplyList, setShowSlotApplyList] = useState(true);
  // ===== LABEL_APPLY_ADMIN 끝 =====
  const [slotSwapForm, setSlotSwapForm] = useState({ title: '', image: '', url: '', price: '' }); // ✅ NEW: 소매상 슬롯 교체 폼
  const [newSlotForm, setNewSlotForm] = useState({ ownerId: '', storeName: '', title: '', image: '', url: '', price: '' }); // ✅ NEW: 어드민 신규 슬롯 발급 폼
  const [searchQuery, setSearchQuery] = useState(''); // ✅ NEW: 소비자용 검색어
  const [sortBy, setSortBy] = useState('latest'); // ✅ NEW: 'latest' | 'lowprice'
  const [visibleCount, setVisibleCount] = useState(30); // ✅ NEW: 무한스크롤 - 한 번에 렌더링할 상품 수
  const loadMoreRef = useRef(null); // ✅ NEW: 무한스크롤 감지용 sentinel

  // ✅ NEW: 필터/검색/탭이 바뀌면 무한스크롤 노출 개수를 처음으로 리셋
  useEffect(() => {
    setVisibleCount(30);
  }, [category, view, searchQuery, sortBy, adminSearch]);

  // ✅ NEW: 화면 하단 sentinel이 보이면 30개씩 더 노출 (모바일 무한 스크롤)
  useEffect(() => {
    const el = loadMoreRef.current;
    if (!el) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setVisibleCount(prev => prev + 30);
      }
    }, { rootMargin: '400px' });
    observer.observe(el);
    return () => observer.disconnect();
  });
  const deepLinkHandledRef = useRef(false); // ✅ NEW: 공유 링크로 들어왔을 때 모달 자동 오픈 1회만 처리
  const searchInputRef = useRef(null); // ✅ NEW: 레퍼런스 스타일 헤더 검색 아이콘 클릭 시 검색창 포커스
  
  // 유저 락인(Lock-in) 및 찜하기 관련 상태
  const [clickCount, setClickCount] = useState(parseInt(localStorage.getItem('label_nonmember_clicks') || '0'));
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [user, setUser] = useState(null); // ✅ NEW: 카카오 로그인 세션 (Supabase Auth user)
  const [dismissedSuggestions, setDismissedSuggestions] = useState([]); // ✅ NEW: 어드민이 "확인"한 병합 추천(더 이상 안 보여줄 것들)
  const [dismissedUncategorized, setDismissedUncategorized] = useState([]); // ✅ NEW: 어드민이 "확인"한 미분류 상품(더 이상 안 보여줄 것들)
  const [dismissedUncategorizedLoaded, setDismissedUncategorizedLoaded] = useState(false); // ✅ NEW: dismissed 목록 로딩 완료 여부 (깜빡임 방지)
  const [customKeywords, setCustomKeywords] = useState([]); // ✅ NEW: 어드민이 "기존 카테고리에 넣기/카테고리 만들기"로 추가한 키워드 [{category, keyword}]
  const [customKeywordsLoaded, setCustomKeywordsLoaded] = useState(false); // ✅ NEW: customKeywords 로딩 완료 여부 (깜빡임 방지)
  // ✅ NEW(2026-08-22): 카테고리 노출 순서. category_order 테이블에서 로드.
  // 비어 있으면(테이블 없음/로드 실패 포함) 기존 하드코딩 순서를 그대로 쓴다.
  const [categoryOrder, setCategoryOrder] = useState([]);
  const [catOrderDraft, setCatOrderDraft] = useState(null); // 어드민 순서편집 패널 (null이면 닫힘)
  const [catOrderSaving, setCatOrderSaving] = useState(false);
  const [showUncategorizedPanel, setShowUncategorizedPanel] = useState(false); // ✅ NEW: 미분류 상품 - 자동으로 안 열리고 버튼 눌러야만 펼쳐짐
  const [showSplitSuggestionsPanel, setShowSplitSuggestionsPanel] = useState(false); // ✅ NEW: 분리 추천 패널
  const [dismissedSplitUrls, setDismissedSplitUrls] = useState([]); // ✅ FIX: "확인"한 분리 추천을 product_url(불변)로 기억.
  // (link.id는 크롤링마다 store_links를 통째로 지우고 새로 넣어 id가 바뀌므로, 확인이 매번 무효가 되던 문제)
  const [showMergeSuggestionsPanel, setShowMergeSuggestionsPanel] = useState(false); // ✅ NEW: 병합 추천 - 자동으로 안 열리고 버튼 눌러야만 펼쳐짐

  const [mergeBaseKeys, setMergeBaseKeys] = useState({}); // ✅ NEW: 병합추천 그룹별 '기준 상품' 선택 인덱스 (key -> index). 없으면 0(첫번째).
  const [categoryOverrides, setCategoryOverrides] = useState({});
  const [singleProductMode, setSingleProductMode] = useState(false);
  const [categoryPickerProduct, setCategoryPickerProduct] = useState(null); // ✅ NEW: 카테고리 변경 모달 대상 상품 (null이면 닫힘)
  
  // ✅ 시즌에 따라 순서를 바꾼다(2026-08 가을 기준: 여름 아이템 뷔스티에를 뒤로).
  //    ⚠️ 이름은 절대 바꾸지 말 것 — category_keywords 등에서 이 문자열을 그대로 참조한다.
  //    순서만 재배치할 것. '전체'는 맨 앞 유지.
  const categories = ['전체', '블라우스', '셔츠', '니트', '가디건', '원피스', '티셔츠', '팬츠', '스커트', '자켓', '점퍼', '코트', '뷔스티에', '신발', '액세서리'];

  // ✅ FIX: 카테고리 필터가 제목에 카테고리명이 문자 그대로 포함된 경우만 매칭해서,
  // '액세서리'처럼 포괄적인 카테고리는 실제 품목명(스크런치, 헤어핀 등)을 못 잡던 문제 보완
  // ✅ FIX: '아우터' 하나로 뭉쳐있던 걸 자켓/점퍼/코트 3개로 세분화 (여름이라 뒤로 이동)
  // ✅ FIX: 패딩은 "패딩점퍼"라서 코트가 아니라 점퍼로 분류
  // ✅ FIX: 나시는 나시티(민소매 티셔츠)라서 별도 탭이 아니라 티셔츠 카테고리에 편입
  const CATEGORY_KEYWORDS = {
    '액세서리': ['액세서리', '스크런치', '헤어핀', '헤어끈', '헤어밴드', '목걸이', '팔찌', '반지', '귀걸이', '이어링', '브로치', '스카프', '벨트', '리본핀', '집게핀'],
    '자켓': ['자켓', '재킷', '블레이저', '야상'],
    '점퍼': ['점퍼', '바람막이', '블루종', '패딩'],
    '코트': ['코트', '무스탕'],
    '티셔츠': ['티셔츠', '나시', '탱크탑', '민소매'],
    // ✅ NEW: 상품명에 '뷔스티에'가 있으면 무조건 뷔스티에로. (기존엔 '뷔스티에 나시'가
    // 앞선 티셔츠 카테고리('나시' 키워드)에 먼저 걸려 티셔츠로 분류됐음)
    '뷔스티에': ['뷔스티에', '뷔스띠에'],
  };
  const getCategoryKeywords = (cat) => {
    const base = CATEGORY_KEYWORDS[cat] || [cat];
    const custom = customKeywords.filter(k => k.category === cat).map(k => k.keyword);
    return custom.length > 0 ? [...new Set([...base, ...custom])] : base;
  };  const getProductCategory = (p) => {
    const override = categoryOverrides[p.product_id];
    if (override) return override;
    const matchTitle = p.title || "";
    const matchClean = p.clean_title || "";
    const realCategories = allCategories.filter(c => c !== '전체' && c !== '기타');
    const matched = realCategories.find(cat => {
      const keywords = getCategoryKeywords(cat);
      const excludes = getCategoryExcludes(cat);
      const isMatch = keywords.some(k => matchTitle.includes(k) || matchClean.includes(k));
      const isExcluded = excludes.some(k => matchTitle.includes(k) || matchClean.includes(k));
      return isMatch && !isExcluded;
    });
    return matched || '미분류';
  };
  // ✅ FIX: '티셔츠'라는 글자 안에 '셔츠'가 포함돼있어서, 셔츠 카테고리에 티셔츠가 같이 섞여 나오던 문제 (3번)
  // ✅ FIX: 액세서리 키워드 '벨트'가 "벨트 팬츠"처럼 실제 옷 상품명에 섞여서
  // 팬츠가 액세서리 탭에도 같이 뜨던 문제 — 진짜 옷 카테고리 단어가 같이 있으면 액세서리에서 제외
  const CATEGORY_EXCLUDE = {
    // ✅ NEW: 뷔스티에가 들어간 상품은 다른 카테고리에서 제외 -> 항상 뷔스티에로 분류됨
    '티셔츠': ['뷔스티에', '뷔스띠에'],
    '블라우스': ['뷔스티에', '뷔스띠에'],
    '니트': ['뷔스티에', '뷔스띠에'],
    '셔츠': ['티셔츠', '나시', '탱크탑', '민소매', '뷔스티에', '뷔스띠에'],
    '액세서리': ['팬츠', '원피스', '니트', '가디건', '블라우스', '셔츠', '티셔츠', '스커트', '자켓', '점퍼', '코트'],
  };
  const getCategoryExcludes = (cat) => CATEGORY_EXCLUDE[cat] || [];

  // ✅ NEW: "카테고리 만들기"로 새로 추가된 카테고리명을 기존 목록 뒤에 자동으로 붙여서 탭/미분류 판정에 반영
  const customCategoryNames = [...new Set(customKeywords.map(k => k.category))].filter(c => !categories.includes(c));
  const baseAllCategories = [...categories, ...customCategoryNames, '기타'];

  // ✅ NEW(2026-08-22): category_order에 저장된 순서를 적용한다.
  // - '전체'는 항상 맨 앞, '기타'는 항상 맨 뒤로 강제(순서 사고 방지)
  // - 순서 정보에 없는 카테고리(새로 만든 것)는 기존 순서를 유지한 채 뒤에 붙는다
  // - categoryOrder가 비어 있으면 기존 동작과 완전히 동일
  const allCategories = (() => {
    const rest = baseAllCategories.filter(c => c !== '전체' && c !== '기타');
    if (categoryOrder.length > 0) {
      const rank = new Map(categoryOrder.map((c, i) => [c, i]));
      rest.sort((a, b) => {
        const ra = rank.has(a) ? rank.get(a) : 9999;
        const rb = rank.has(b) ? rank.get(b) : 9999;
        if (ra !== rb) return ra - rb;
        return baseAllCategories.indexOf(a) - baseAllCategories.indexOf(b);
      });
    }
    return ['전체', ...rest, '기타'];
  })();
  
  // 🔥 기본 타겟 도매 브랜드 목록 및 자동 정렬된 브랜드 상태 관리
  const baseBrands = ['파운더스', '언더슨', '드온도', '프리티영띵', '미엘', '리터', '온스', '브런치', '컴히얼'];
  const [sortedBrands, setSortedBrands] = useState(baseBrands);
  const [selectedBrand, setSelectedBrand] = useState(baseBrands[0]);

  // 뷰가 바뀌면 카테고리를 '전체'로 초기화하여 버그를 방지합니다.
  useEffect(() => {
    setCategory('전체');
  }, [view]);

  // ✅ NEW: 로그아웃했는데 '찜' 탭에 머물러 있으면 FEED로 되돌림 (탭 자체가 사라지므로)
  useEffect(() => {
    if (!user && view === 'MY') setView('NEWARRIVAL');
  }, [user, view]);

  // ⚡ PERF: 기존 의존성 [category, view, selectedBrand] 제거.
  // fetchProductsAndClicks는 서버에서 카테고리/탭/브랜드로 필터링하지 않고
  // products 전체를 통째로 받아온 뒤 화면단(displayProducts)에서 걸러 쓰는 구조임.
  // 그래서 탭을 옮길 때마다 똑같은 전체 데이터를 다시 받아오고 있었음(수천 행 × 매 클릭).
  // 최초 1회만 로드하도록 변경 — 탭 전환이 즉시 반응하고 서버 부하도 크게 줄어듦.
  useEffect(() => {
    fetchProductsAndClicks();
  }, []);

  // ✅ NEW: 당일 슬롯은 최초 1회 로드 (탭 이동과 무관하게 헤더의 '내 슬롯 관리' 버튼 표시에도 필요)
  useEffect(() => {
    fetchDailySlots();
  }, []);

  // ✅ NEW: 방문 기록 남기기 (page_views) - 최초 마운트 시 1회만 기록.
  // utm_source를 채널로 사용 (Short.io에서 채널마다 붙여주는 태그 그대로 재사용).
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const channel = params.get('utm_source') || 'direct';
    const campaign = params.get('utm_campaign') || null;

    let sessionId = localStorage.getItem('lbl_session_id');
    if (!sessionId) {
      sessionId = crypto.randomUUID();
      localStorage.setItem('lbl_session_id', sessionId);
    }

    // ===== LABEL_TRACK_IDS (page_views user_id) =====
    supabase.auth.getSession().then(({ data }) => supabase.from('page_views').insert({
      session_id: sessionId,
      channel,
      campaign,
      path: window.location.pathname,
      user_id: (data && data.session && data.session.user && data.session.user.id) || null, // LABEL_TRACK_IDS
    })).then(({ error }) => {
      // ✅ FIX: 기존엔 에러를 아예 체크 안 해서 RLS 등에 막혀도 조용히 실패했음 — 콘솔에 남기도록 수정
      if (error) console.error('[page_views] 방문 기록 저장 실패:', error.message);
    });
  }, []);

  // ✅ NEW: 카카오톡 공유(Kakao Share) SDK 로드 + 초기화 (공유하기 버튼에서 사용)
  useEffect(() => {
    const initKakao = () => {
      if (window.Kakao && !window.Kakao.isInitialized() && process.env.REACT_APP_KAKAO_JS_KEY) {
        window.Kakao.init(process.env.REACT_APP_KAKAO_JS_KEY);
      }
    };
    if (window.Kakao) { initKakao(); return; }
    const script = document.createElement('script');
    script.src = 'https://t1.kakaocdn.net/kakao_js_sdk/2.7.2/kakao.min.js';
    script.async = true;
    script.onload = initKakao;
    document.head.appendChild(script);
  }, []);

  // ✅ NEW: 레퍼런스 디자인 폰트(Hanken Grotesk + Nanum Gothic) 로드
  useEffect(() => {
    if (document.getElementById('lb-font-link')) return;
    const link = document.createElement('link');
    link.id = 'lb-font-link';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Hanken+Grotesk:ital,wght@0,300..800;1,300..800&family=Nanum+Gothic:wght@400;700;800&display=swap';
    document.head.appendChild(link);
  }, []);

  // ✅ NEW: 카카오 로그인 세션 감지 — 최초 로드 시 세션 확인 + 로그인/로그아웃 실시간 반영
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) setShowLoginModal(false); // 로그인 성공하면 락인 팝업 자동으로 닫기
    });
    return () => subscription.unsubscribe();
  }, []);

  // ✅ NEW: 로그인 상태가 바뀌면 내 찜 목록을 다시 불러옴 (로그아웃 시 초기화)
  useEffect(() => {
    if (!user) { setFavorites([]); return; }
    supabase.from('favorites').select('product_id').eq('user_id', user.id).then(({ data, error }) => {
      if (error) { console.error('찜 목록 불러오기 실패:', error); return; }
      if (data) setFavorites(data.map(f => f.product_id));
    });
  }, [user]);

  // ✅ NEW: 어드민이면 "확인"한 병합 추천 목록을 불러와서 다시 안 뜨게 함
  useEffect(() => {
    if (!isAdmin) { setDismissedSuggestions([]); setDismissedUncategorized([]); setDismissedUncategorizedLoaded(true); return; }
    setDismissedUncategorizedLoaded(false);
    setDismissedUncategorizedLoaded(false);
    supabase.from('dismissed_merge_suggestions').select('cluster_key').then(({ data, error }) => {
      if (error) { console.error('확인된 병합 추천 목록 불러오기 실패:', error); return; }
      if (data) setDismissedSuggestions(data.map(d => d.cluster_key));
    });
    supabase.from('dismissed_split_suggestions').select('product_url').then(({ data, error }) => {
      if (error) { console.error('확인된 분리 추천 목록 불러오기 실패:', error); return; }
      if (data) setDismissedSplitUrls(data.map(d => d.product_url).filter(Boolean));
    });
    supabase.from('dismissed_uncategorized').select('product_id').then(({ data, error }) => {
      if (error) { console.error('확인된 미분류 상품 목록 불러오기 실패:', error); setDismissedUncategorizedLoaded(true); return; }
      if (data) setDismissedUncategorized(data.map(d => d.product_id));
      setDismissedUncategorizedLoaded(true);
    });
  }, [isAdmin]);

  // ✅ NEW(2026-08-22): 카테고리 노출 순서 로드.
  // 테이블이 아직 없거나 조회에 실패해도 기본 순서로 정상 동작해야 하므로 조용히 넘어간다.
  useEffect(() => {
    supabase.from('category_order').select('category, sort_order').order('sort_order').then(({ data, error }) => {
      if (error) { console.warn('카테고리 순서 불러오기 실패(기본 순서 사용):', error.message); return; }
      if (data && data.length) setCategoryOrder(data.map(r => r.category));
    });
  }, []);

  // ✅ NEW: 순서편집 패널에서 한 칸 위/아래로 이동
  const moveCategory = (idx, dir) => {
    setCatOrderDraft(prev => {
      if (!prev) return prev;
      const j = idx + dir;
      if (j < 0 || j >= prev.length) return prev;
      const next = [...prev];
      const tmp = next[idx];
      next[idx] = next[j];
      next[j] = tmp;
      return next;
    });
  };

  // ✅ NEW: 순서 저장 — 화면에 보이는 순서를 그대로 sort_order 0,1,2...로 기록
  const saveCategoryOrder = async (list) => {
    if (!list || !list.length) return;
    setCatOrderSaving(true);
    const rows = list.map((c, i) => ({ category: c, sort_order: i }));
    const { error } = await supabase.from('category_order').upsert(rows, { onConflict: 'category' });
    setCatOrderSaving(false);
    if (notifyIfError('카테고리 순서 저장', error)) return;
    setCategoryOrder(list);
    setCatOrderDraft(null);
    window.alert('카테고리 순서를 저장했습니다.');
  };

  // ✅ NEW: "카테고리에 넣기 / 카테고리 만들기"로 추가된 커스텀 키워드 로드
  // 일반 유저의 카테고리 필터링에도 반영돼야 해서 어드민 여부와 무관하게 최초 1회 로드
  useEffect(() => {
    supabase.from('category_keywords').select('category, keyword').then(({ data, error }) => {
      if (error) { console.error('카테고리 키워드 불러오기 실패:', error); setCustomKeywordsLoaded(true); return; }
      if (data) setCustomKeywords(data);
      setCustomKeywordsLoaded(true);
    });
  }, []);

  useEffect(() => {
    supabase.from('product_category_overrides').select('product_id, category').then(({ data, error }) => {
      if (error) { console.error('Failed to load category overrides:', error); return; }
      if (data) {
        const map = {};
        data.forEach(r => { map[r.product_id] = r.category; });
        setCategoryOverrides(map);
      }
    });
  }, []);

  // ✅ NEW: 카카오 로그인 / 로그아웃
  const signInWithKakao = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'kakao',
      options: { redirectTo: window.location.origin }
    });
  };
  const signOutUser = async () => {
    await supabase.auth.signOut();
  };

  // ✅ NEW: 공유된 링크(?product=상품ID)로 들어왔을 때 해당 상품 모달을 자동으로 오픈 (최초 1회만)
  useEffect(() => {
    if (deepLinkHandledRef.current || products.length === 0) return;
    const params = new URLSearchParams(window.location.search);
    const pid = params.get('product');
    if (pid) {
      const found = products.find(p => p.product_id === pid);
      if (found) setSelectedProduct(found);
    }
    deepLinkHandledRef.current = true;
  }, [products]);

  // 🔥 수집된 전체 상품 데이터를 기반으로 브랜드별 상품 개수를 계산하여 실시간 정렬을 수행합니다.
  useEffect(() => {
    if (products.length > 0) {
      const counts = {};
      // 기본 브랜드들의 카운트를 0으로 초기화
      baseBrands.forEach(b => { counts[b] = 0; });
      
      // 실제 상품 데이터를 돌며 브랜드별 개수 집계
      products.forEach(p => {
        if (counts[p.brand_name] !== undefined) {
          counts[p.brand_name] += 1;
        }
      });

      // 상품 개수 기준 내림차순 정렬 (개수가 같으면 기존 배열 순서 유지)
      const sorted = [...baseBrands].sort((a, b) => counts[b] - counts[a]);
      setSortedBrands(sorted);
      
      // BRAND 탭을 처음 눌렀을 때 혹은 데이터 로드 시 개수가 가장 많은 브랜드가 기본 선택되도록 세팅
      if (view === 'BRAND' && !baseBrands.includes(selectedBrand)) {
        setSelectedBrand(sorted[0]);
      }
    }
  }, [products, view]);

  // ✅ FIX: 상세 모달을 브라우저 히스토리에 등록 — 뒤로가기 시 카카오 로그인 리다이렉트 이력 등
  // 엉뚱한 곳(카카오톡 앱)으로 튕기지 않고 모달만 닫히도록 함
  useEffect(() => {
    const handlePopState = () => setSelectedProduct(null);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const fetchProductsAndClicks = async () => {
    // 🔧 FIX(페이징): PostgREST는 한 요청당 최대 1000행만 반환함.
    // products가 3000행을 넘어가면서 뒤쪽 상품군이 화면에서 통째로 누락됐음.
    //
    // ⚡ PERF(병렬화): 기존에는 for 루프로 offset을 늘려가며 "앞 페이지 응답을 받아야
    // 다음 페이지를 요청"하는 순차 구조였음. 페이지가 4장이면 왕복 4번이 직렬로 쌓여
    // 초기 로딩이 그만큼 느려짐. 이제 1페이지만 count와 함께 먼저 받아 전체 행수를 알아낸 뒤,
    // 나머지 페이지를 Promise.all로 한꺼번에 요청함 → 왕복 N번이 실질 2번으로 줄어듦.
    // 동시에 clicks 쿼리도 products와 병렬로 시작.
    const PAGE_SIZE = 1000;

    const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
    // ===== LABEL_FRESH_CUTOFF 시작 =====
    // 내려간 상품이 지워지지 않고 영구히 남는 구조다.
    //   - 업로드 ③단계 삭제는 '이번 크롤에 있는' product_id/url 만 지운다
    //   - cleanup_ghost_products 는 store_links 가 0건인 행만 지운다
    // 그래서 크롤에서 빠진 상품은 링크 1건을 달고 계속 살아 있다(2026-09 기준 절반).
    // 지우지 않고 조회에서만 뺀다. 기준이 틀리면 FRESH_DAYS 숫자만 되돌리면 된다.
    //
    // now() 대신 DB의 최신 crawled_at 을 기준으로 삼는다.
    // now() 로 하면 크롤이 며칠 멈출 때 카탈로그가 통째로 비어버린다.
    const FRESH_DAYS = 3;
    let freshCutoff = '1970-01-01 00:00:00';
    {
      const { data: latestRows, error: latestErr } = await supabase
        .from('products')
        .select('crawled_at')
        .not('crawled_at', 'is', null)             // LABEL_FRESH_NULLS: NULL 이 기준일로 잡히면 컷오프가 꺼진다
        .order('crawled_at', { ascending: false })
        .limit(1);
      if (latestErr) {
        console.error('[LABEL_FRESH_CUTOFF] 최신 crawled_at 조회 실패 — 컷오프 없이 진행', latestErr);
      }
      const newest = latestRows && latestRows[0] && latestRows[0].crawled_at;
      if (newest) {
        // crawled_at 은 timestamp without time zone 이다.
        // toISOString() 을 쓰면 UTC 로 밀려 9시간 어긋나므로 로컬 값으로 직접 만든다.
        const d = new Date(String(newest).replace(' ', 'T'));
        d.setDate(d.getDate() - FRESH_DAYS);
        const pad = (n) => String(n).padStart(2, '0');
        freshCutoff = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())
                    + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
      }
    }
    // ===== LABEL_FRESH_CUTOFF 끝 =====
    // clicks는 products와 독립적이므로 기다리지 않고 지금 바로 발사
    const clicksPromise = supabase
      .from('clicks')
      .select('product_id')
      .gte('clicked_at', yesterday);

    // 1페이지 + 전체 행수(count)를 한 번에 조회
    const firstPage = await supabase
      .from('products')
      .select('*, store_links(id, product_id, store_id, store_name, price, product_url, custom_order)', { count: 'exact' })
      .gte('crawled_at', freshCutoff)                 // LABEL_FRESH_CUTOFF
      .order('crawled_at', { ascending: false })
      .order('id', { ascending: true })
      .range(0, PAGE_SIZE - 1);

    if (firstPage.error) {
      console.error('❌ products 1페이지 로드 실패:', firstPage.error);
      setProducts([]);
      return;
    }

    let prodData = firstPage.data || [];
    const total = firstPage.count ?? prodData.length;

    // 남은 페이지가 있으면 전부 동시에 요청
    if (total > PAGE_SIZE) {
      const restRanges = [];
      for (let offset = PAGE_SIZE; offset < total; offset += PAGE_SIZE) {
        restRanges.push(offset);
      }

      const restResults = await Promise.all(
        restRanges.map(offset =>
          supabase
            .from('products')
            .select('*, store_links(id, product_id, store_id, store_name, price, product_url, custom_order)')
            .gte('crawled_at', freshCutoff)           // LABEL_FRESH_CUTOFF
            .order('crawled_at', { ascending: false })
            .order('id', { ascending: true })
            .range(offset, offset + PAGE_SIZE - 1)
        )
      );

      restResults.forEach((res, i) => {
        if (res.error) {
          console.error('❌ products 페이지 로드 실패 (offset=' + restRanges[i] + '):', res.error);
          return;
        }
        if (res.data && res.data.length) prodData = prodData.concat(res.data);
      });
    }

    console.log('📦 products 로드 완료: ' + prodData.length + '건 (전체 ' + total + ')');
    setProducts(prodData);

    // 위에서 미리 발사해둔 clicks 결과 수거
    const { data: clickData } = await clicksPromise;
    if (clickData) {
      const counts = {};
      clickData.forEach(c => counts[c.product_id] = (counts[c.product_id] || 0) + 1);
      setRecentClicks(counts);
    }
  };

  // ✅ NEW: 그로브(내 스토어) 최저가 보호 — 같은 상품군에 그로브 링크가 있으면,
  // 그로브보다 가격이 낮은 다른 판매처 링크는 자동으로 영구삭제(블랙리스트 등록 포함).
  // 어드민 화면에서 상품 목록이 갱신될 때마다(최초 로드 포함) 조용히 실행됨 — 버튼/확인창 없음.
  const isCleaningRef = useRef(false);
  useEffect(() => {
    if (!isAdmin || products.length === 0 || isCleaningRef.current) return;

    const toDelete = [];
    products.forEach(p => {
      const links = getLinks(p);
      const grovePrices = links.filter(isMyStoreLink).map(l => Number(l.price)).filter(pr => pr > 0);
      if (grovePrices.length === 0) return; // 이 상품군엔 그로브가 없거나 가격을 모름
      const grovePrice = Math.min(...grovePrices);

      links.forEach(l => {
        if (isMyStoreLink(l)) return;
        const price = Number(l.price);
        if (price > 0 && price < grovePrice) toDelete.push(l);
      });
    });

    if (toDelete.length === 0) return;

    isCleaningRef.current = true;
    (async () => {
      await Promise.all(toDelete.map(l =>
        supabase.from('blacklist').insert([{ product_url: l.product_url.split("?")[0] }])
      ));
      await Promise.all(toDelete.map(l =>
        supabase.from('store_links').delete().eq('id', l.id)
      ));
      console.log(`🧹 그로브 최저가 보호: ${toDelete.length}건 자동 삭제 완료`);
      isCleaningRef.current = false;
      fetchProductsAndClicks();
    })();
  }, [products, isAdmin]);

  // ✅ NEW: 당일(재고보유) 슬롯 목록 로드
  const fetchDailySlots = async () => {
    const { data, error } = await supabase.from('daily_slots').select('*').order('created_at', { ascending: false });
    if (error) { console.error('당일 슬롯 로드 실패:', error); return; }
    setDailySlots(data || []);
  };

  // ===== LABEL_LEAN_FETCH 시작 =====
  // (1) 소비자: 모달이 열린 상품 하나만 받는다.
  useEffect(() => {
    const pid = selectedProduct && selectedProduct.product_id;
    if (!pid || linkExtras[pid]) return;
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase
        .from('store_links')
        .select('store_id, store_title, store_image')
        .eq('product_id', pid);
      if (cancelled) return;
      if (error) {
        console.error('[LABEL_LEAN_FETCH] 판매처 상세 조회 실패', error);
        return;   // 실패해도 모달은 뜬다. 썸네일/원제목만 대체 표시된다.
      }
      const map = {};
      (data || []).forEach(r => {
        map[r.store_id] = { store_title: r.store_title, store_image: r.store_image };
      });
      setLinkExtras(prev => ({ ...prev, [pid]: map }));
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct]);

  // (2) 어드민: 카드 하단 판매처 표가 썸네일과 원제목을 바로 쓰므로 전체를 받는다.
  //     isAdmin은 fetchProducts보다 늦게 확정될 수 있어 조회 시점 분기 대신 여기서 채운다.
  //     어드민은 1명이라 egress를 따지지 않는다.
  useEffect(() => {
    if (!isAdmin || adminExtrasDone) return;
    let cancelled = false;
    (async () => {
      const PAGE = 1000;
      let from = 0;
      const acc = {};
      for (;;) {
        const { data, error } = await supabase
          .from('store_links')
          .select('product_id, store_id, store_title, store_image')
          .range(from, from + PAGE - 1);
        if (cancelled) return;
        if (error) {
          console.error('[LABEL_LEAN_FETCH] 어드민 판매처 상세 조회 실패 (from=' + from + ')', error);
          alert('어드민 판매처 상세를 불러오지 못했어요.\n썸네일과 원제목이 비어 보일 수 있습니다.\n\n' + error.message);
          return;
        }
        const rows = data || [];
        rows.forEach(r => {
          if (!acc[r.product_id]) acc[r.product_id] = {};
          acc[r.product_id][r.store_id] = { store_title: r.store_title, store_image: r.store_image };
        });
        if (rows.length < PAGE) break;
        from += PAGE;
      }
      if (cancelled) return;
      setLinkExtras(prev => {
        const next = { ...prev };
        Object.keys(acc).forEach(pid => { next[pid] = { ...(next[pid] || {}), ...acc[pid] }; });
        return next;
      });
      setAdminExtrasDone(true);
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin, adminExtrasDone]);
  // ===== LABEL_LEAN_FETCH 끝 =====

  // ===== LABEL_FRESH_CUTOFF 시작 =====
  // 찜한 상품이 컷오프에 걸리면 MY 탭에서 조용히 사라진다.
  // 목록에 없는 찜만 골라 날짜 무관하게 따로 받아 붙인다. 회원당 한 번만 돈다.
  const [staleFavDone, setStaleFavDone] = useState(false);
  useEffect(() => {
    if (staleFavDone) return;
    if (!favorites || favorites.length === 0) return;
    if (!products || products.length === 0) return;   // 목록 로드 실패 시엔 판단 보류
    const have = new Set(products.map(p => p.product_id));
    const missing = favorites.filter(pid => pid && !have.has(pid));
    if (missing.length === 0) { setStaleFavDone(true); return; }
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase
        .from('products')
        .select('*, store_links(id, product_id, store_id, store_name, price, product_url, custom_order)')
        .in('product_id', missing);
      if (cancelled) return;
      if (error) {
        console.error('[LABEL_FRESH_CUTOFF] 찜한 옛 상품 보충 실패', error);
        setStaleFavDone(true);            // 무한 재시도를 막는다
        return;
      }
      if (data && data.length) {
        setProducts(prev => {
          const seen = new Set(prev.map(p => p.product_id));
          return prev.concat(data.filter(p => !seen.has(p.product_id)));
        });
      }
      setStaleFavDone(true);
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favorites, products, staleFavDone]);
  // ===== LABEL_FRESH_CUTOFF 끝 =====
  // ===== LABEL_FAV_DEAD 시작 =====
  // 상품이 내려가 products 에 행 자체가 없는 찜은 위 보충으로도 못 살린다.
  // 지우지 않고 '판매종료' 플레이스홀더로 세워 MY 탭에 남긴다. 회원당 한 번만 돈다.
  const [deadFavDone, setDeadFavDone] = useState(false);
  useEffect(() => {
    if (deadFavDone) return;
    if (!staleFavDone) return;                       // 보충이 끝난 뒤에 판단한다
    if (!favorites || favorites.length === 0) return;
    const have = new Set(products.map(p => p.product_id));
    const dead = favorites.filter(pid => pid && !have.has(pid));
    if (dead.length === 0) { setDeadFavDone(true); return; }
    console.info('[LABEL_FAV_DEAD] 확인 안 되는 찜 ' + dead.length + '건');   // LABEL_FAV_DEAD_LABEL
    setProducts(prev => prev.concat(dead.map(pid => ({
      id: 'dead:' + pid,
      product_id: pid,
      __dead: true,
      brand_name: (pid.split('|')[0] || ''),
      title: (pid.split('|')[1] || pid),
      clean_title: (pid.split('|')[1] || pid),
      image_url: null,
      store_links: []
    }))));
    setDeadFavDone(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favorites, products, staleFavDone, deadFavDone]);
  // ===== LABEL_FAV_DEAD 끝 =====

  const getLinks = (p) => {
    const rawData = p.store_links || [];
    const arr = Array.isArray(rawData) ? rawData : [];
    const uniqueLinks = [];
    const seen = new Set();
    arr.forEach(l => {
      if (!seen.has(l.store_id)) {
        seen.add(l.store_id);
        uniqueLinks.push(l);
      }
    });
    // ===== LABEL_LEAN_FETCH =====
    // 병합을 getLinks 한 곳에서만 한다. visibleLinks/sortLinks/모달/어드민 표가
    // 모두 getLinks를 거치므로, 읽는 쪽 코드는 하나도 건드리지 않는다.
    const extras = linkExtras[p.product_id];
    if (!extras) return uniqueLinks;
    return uniqueLinks.map(l => (extras[l.store_id] ? { ...l, ...extras[l.store_id] } : l));
    // ===== LABEL_LEAN_FETCH 끝 =====
  };

  const cleanTitleStr = (title) => title ? title.replace(/\[.*?\]/g, '').trim() : "";

  // ✅ NEW: 그로브(내 스토어) 판별 헬퍼 — 어드민 '그로브만 모아보기' 필터에서 사용
  const MY_STORE_KEYWORDS = ['samtandbyme', 'grove', '그로브', '샘트앤바이미'];
  const isMyStoreLink = (l) => MY_STORE_KEYWORDS.some(s => (l.store_id || "").toLowerCase().includes(s) || (l.store_name || "").toLowerCase().includes(s));

  // ✅ NEW(2026-08-22): 소비자에게 보여줄 판매처만 추린다.
  // 그로브가 있는 상품군이면 [그로브 전부 + 그로브 외 최고가 1곳]만 노출한다.
  // '그로브 최저가 보호'(위 537행)가 그로브보다 싼 링크를 이미 삭제하므로,
  // 남은 경쟁 링크는 모두 그로브보다 비싸다 -> 소비자 화면에서 그로브가 최저가로 보인다.
  // 어드민은 병합/분리 판단을 위해 항상 전체를 봐야 하므로 그대로 둔다.
  const visibleLinks = (p) => {
    const links = getLinks(p);
    if (isAdmin) return links;
    const mine = links.filter(isMyStoreLink);
    if (mine.length === 0) return links;          // 그로브가 없는 상품군은 기존과 동일
    const others = links.filter(l => !isMyStoreLink(l));
    if (others.length === 0) return mine;
    const top = others.reduce((a, b) => ((Number(b.price) || 0) > (Number(a.price) || 0) ? b : a));
    return [...mine, top];
  };

  // ✅ NEW: 상품의 판매처 중 최저가를 계산 (정렬 옵션 '최저가순'에서 사용)
  const getMinPrice = (p) => {
    const prices = getLinks(p).map(l => Number(l.price)).filter(pr => pr > 0);
    return prices.length > 0 ? Math.min(...prices) : Infinity;
  };

  // ✅ NEW: 공유하기 — 모바일은 네이티브 공유시트(카카오톡 포함) 호출, 미지원 브라우저는 링크 복사로 폴백
  // ✅ FIX: 카카오톡 공유 SDK를 우선 사용해서 버튼 누르면 바로 카카오톡 공유 화면이 뜨도록 함.
  // SDK가 아직 로드/초기화 안 됐거나 실패하면 기존 브라우저 공유창/링크복사로 폴백.
  const handleShare = async (p) => {
    // ✅ FIX: product_id에 한글/공백/| 가 있어 인코딩 없이 URL에 넣으면 카카오가 링크를 막음. encodeURIComponent 필수.

    const shareUrl = `${window.location.origin}${window.location.pathname}?product=${encodeURIComponent(p.product_id)}`;
    const shareText = `${p.brand_name} - ${cleanTitleStr(p.title)} | LABEL에서 최저가 확인하기`;

    if (window.Kakao && window.Kakao.isInitialized && window.Kakao.isInitialized() && window.Kakao.Share) {
      try {
        window.Kakao.Share.sendDefault({
          objectType: 'feed',
          content: {
            title: `${p.brand_name} - ${cleanTitleStr(p.title)}`,
            description: 'LABEL에서 최저가 확인하기',
            imageUrl: p.image_url,
            link: { mobileWebUrl: shareUrl, webUrl: shareUrl },
          },
        });
        return;
      } catch (e) {
        console.error('카카오 공유 실패:', e);
        // 실패 시 아래 폴백으로 계속 진행
      }
    }

    if (navigator.share) {
      try { await navigator.share({ title: 'LABEL', text: shareText, url: shareUrl }); } catch (e) { /* 사용자가 취소한 경우 무시 */ }
    } else {
      try {
        await navigator.clipboard.writeText(shareUrl);
        alert('📋 링크가 복사되었습니다! 친구에게 공유해보세요.');
      } catch (e) {
        alert('이 브라우저에서는 공유하기가 지원되지 않습니다.');
      }
    }
  };

  // ✅ NEW: 클릭1등-최신1등-클릭2등-최신2등 순으로 인기도와 최신성을 교차 배치하는 추천 정렬
  const buildInterleavedFeed = (items) => {
    const score = (p) => ((recentClicks[p.product_id] || 0) * 0.7) + ((p.click_count || 0) * 0.3);
    const byClicks = [...items].sort((a, b) => score(b) - score(a));
    const byRecency = [...items].sort((a, b) => new Date(b.crawled_at) - new Date(a.crawled_at));
    const result = [];
    const used = new Set();
    let ci = 0, ri = 0;
    while (result.length < items.length) {
      while (ci < byClicks.length && used.has(byClicks[ci].id)) ci++;
      if (ci < byClicks.length) { result.push(byClicks[ci]); used.add(byClicks[ci].id); ci++; }
      while (ri < byRecency.length && used.has(byRecency[ri].id)) ri++;
      if (ri < byRecency.length) { result.push(byRecency[ri]); used.add(byRecency[ri].id); ri++; }
    }
    return result;
  };

  const sortLinks = (links) => {
    return [...links].sort((a, b) => {
      if (a.custom_order && b.custom_order) return a.custom_order - b.custom_order;
      if (a.custom_order && !b.custom_order) return -1;
      if (!a.custom_order && b.custom_order) return 1;

      const targetStores = ['samtandbyme', 'grove', '그로브', '샘트앤바이미'];
      const isTargetA = targetStores.some(s => (a.store_id || "").toLowerCase().includes(s) || (a.store_name || "").toLowerCase().includes(s));
      const isTargetB = targetStores.some(s => (b.store_id || "").toLowerCase().includes(s) || (b.store_name || "").toLowerCase().includes(s));
      
      if (isTargetA && !isTargetB) return -1;
      if (!isTargetA && isTargetB) return 1;

      if (Number(a.price) !== Number(b.price)) return Number(a.price) - Number(b.price);
      return Math.random() - 0.5;
    });
  };

  const handleCardClick = async (p) => { 
    if (isAdmin) return;
    // ✅ FIX: 로그인한 유저는 비회원 5회 제한을 받지 않음
    if (!user && clickCount >= 5) { setShowLoginModal(true); return; }
    if (!user) {
      const newCount = clickCount + 1;
      setClickCount(newCount);
      localStorage.setItem('label_nonmember_clicks', newCount.toString());
    }

    setSelectedProduct(p);
    // ✅ FIX: 모달 오픈을 히스토리에 등록 (뒤로가기가 모달만 닫도록)
    window.history.pushState({ modal: true }, '', `${window.location.pathname}?product=${encodeURIComponent(p.product_id)}`);
    // ===== LABEL_TRACK_IDS (clicks session_id/user_id) =====
    let _lblTrackSid = null;
    try { _lblTrackSid = localStorage.getItem('lbl_session_id'); } catch (e) { /* 저장소 막힘 */ }
    const { error: _lblTrackErr } = await supabase.from('clicks').insert([{ product_id: p.product_id, session_id: _lblTrackSid, user_id: (user && user.id) || null }]);
    if (_lblTrackErr) console.error('[label_track_ids] clicks insert failed:', _lblTrackErr.message);
    // ===== LABEL_TRACK_IDS 끝 =====
    // ✅ FIX: products 테이블 직접 UPDATE 대신 좁은 권한의 RPC 함수 사용
    // (RLS로 products 직접 쓰기를 admin 전용으로 잠그면서, 클릭수 증가만 예외적으로 허용)
    await supabase.rpc('increment_click_count', { pid: p.product_id });
    // LABEL_PROMO_POPUP: 상세 열람 횟수(세션 단위). 3의 배수마다 팝업이 뜬다
    try {
      const _pv = parseInt(sessionStorage.getItem('label_promo_views') || '0', 10) + 1;
      sessionStorage.setItem('label_promo_views', String(_pv));
    } catch (e) { /* 사생활 보호 모드 등에서 sessionStorage가 막히면 무시 */ }
    const newClickCount = (p.click_count || 0) + 1;
    setRecentClicks(prev => ({...prev, [p.product_id]: (prev[p.product_id] || 0) + 1}));
    setProducts(products.map(prod => prod.id === p.id ? { ...prod, click_count: newClickCount } : prod));
  };

  // ✅ FIX: 로그인 안 했으면 로그인 유도, 로그인 했으면 실제로 찜하기 저장/취소
  // ✅ FIX: DB 저장 실패 시에도 하트가 채워진 것처럼 보이던 문제 — 에러 체크 + 실패하면 UI 롤백 + 콘솔 로그 추가
  const toggleFavorite = async (e, p) => {
    e.stopPropagation();
    if (!user) { setShowLoginModal(true); return; }
    const isFav = favorites.includes(p.product_id);
    if (isFav) {
      setFavorites(favorites.filter(id => id !== p.product_id));
      const { error } = await supabase.from('favorites').delete().eq('user_id', user.id).eq('product_id', p.product_id);
      if (error) {
        console.error('찜 삭제 실패:', error);
        setFavorites(prev => [...prev, p.product_id]); // 롤백
        alert('찜 취소에 실패했어요. (' + error.message + ')');
      }
    } else {
      setFavorites([...favorites, p.product_id]);
      // ✅ NEW(갈래2): 천을 그룹의 모든 store_links url과 함께 저장.
      // product_id(그룹명)는 크롤링마다 바날 수 있지만 url은 불변이므로,
      // 나중에 upload가 이 url로 product_id를 현재 그룹에 재연결해 천을 살린다.
      // 하나만 살아도 천 유지하려면 대표 1개가 아니라 '모든' url을 저장해야 함.
      const _favUrls = getLinks(p).map(l => (l.product_url || '').split('?')[0]).filter(Boolean).join(',');
      const { error } = await supabase.from('favorites').insert([{ user_id: user.id, product_id: p.product_id, product_url: _favUrls }]);
      if (error) {
        console.error('찜 저장 실패:', error);
        setFavorites(prev => prev.filter(id => id !== p.product_id)); // 롤백
        alert('찜 저장에 실패했어요.\n\n보낸 user.id: ' + user.id + '\n\n에러: ' + error.message);
      }
    }
  };
  const closeModal = () => {
    if (window.history.state && window.history.state.modal) {
      window.history.back();
    } else {
      setSelectedProduct(null);
    }
  };

  // ===== LABEL_PROMO_POPUP 시작 =====
  // 세션 식별자 (비회원의 노출과 클릭을 이어붙여 보기 위한 것)
  const getPromoSid = () => {
    try {
      let sid = sessionStorage.getItem('label_promo_sid');
      if (!sid) {
        sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem('label_promo_sid', sid);
      }
      return sid;
    } catch (e) { return 'nosession'; }
  };

  // 노출/클릭/닫기 기록. 실패해도 화면은 그대로 두되 콘솔에는 반드시 남긴다
  const logPromoEvent = async (kind, slot, viewIndex) => {
    const { error } = await supabase.from('promo_events').insert([{
      event_type: kind,
      slot_id: slot ? String(slot.id) : null,
      session_id: getPromoSid(),
      view_index: viewIndex || null,
      is_member: !!user
    }]);
    if (error) console.error('promo_events 기록 실패:', error.message);
  };

  // 클릭 -> utm 붙여 새 탭으로. URL이 깨져 있으면 원본 그대로 연다
  const handlePromoClick = (slot) => {
    logPromoEvent('click', slot, null);
    let dest = slot.product_url;
    try {
      const u = new URL(slot.product_url);
      u.searchParams.set('utm_source', 'label');
      u.searchParams.set('utm_medium', 'daily_popup');
      u.searchParams.set('utm_campaign', 'slot_' + slot.id);
      dest = u.toString();
    } catch (e) { console.error('슬롯 URL 파싱 실패:', slot.product_url); }
    window.open(dest, '_blank', 'noopener');
    setPromoSlot(null);
  };

  const closePromo = () => {
    if (promoSlot) logPromoEvent('close', promoSlot, null);
    setPromoSlot(null);
  };

  // 상세 모달이 '닫히는 순간'을 잡는다. closeModal 과 뒤로가기(popstate)가 모두 여기로 모인다
  const prevSelectedRef = useRef(null);
  const promoSeenRef = useRef([]);
  useEffect(() => {
    const prev = prevSelectedRef.current;
    prevSelectedRef.current = selectedProduct;
    if (isAdmin) return;
    if (!prev || selectedProduct) return;      // 열릴 때가 아니라 닫힐 때만
    let views = 0;
    try { views = parseInt(sessionStorage.getItem('label_promo_views') || '0', 10); } catch (e) {}
    if (views === 0 || views % 3 !== 0) return;
    const pool = dailySlots.filter(s => s.is_active && !s.is_banned && s.product_url);
    if (pool.length === 0) return;
    const unseen = pool.filter(s => !promoSeenRef.current.includes(s.id));
    const pick = (unseen.length > 0 ? unseen : pool)[0];
    if (!pick) return;
    promoSeenRef.current = promoSeenRef.current.concat([pick.id]);
    setPromoSlot(pick);
    logPromoEvent('impression', pick, views);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct]);
  // ===== LABEL_PROMO_POPUP 끝 =====

  const toggleAdminMode = () => {
    if (isAdmin) { setIsAdmin(false); setAdminSearch(''); }
    else { const pwd = prompt("관리자 비밀번호를 입력하세요:"); if (pwd === "1234") setIsAdmin(true); else if (pwd !== null) alert("비밀번호가 틀렸습니다."); }
  };

  // ✅ NEW: 어드민 쓰기 작업 공용 에러 체크 — RLS가 막았을 때(예: 카카오 로그인 안 된 상태) 조용히 실패하지 않고 알려줌
  const notifyIfError = (label, error) => {
    if (error) {
      alert(`❌ ${label} 실패: ${error.message}\n\n카카오 로그인이 되어있는지 확인해주세요 (로그인 세션이 없으면 저장이 막혀요).`);
      return true;
    }
    return false;
  };

  // ✅ NEW: '당일아님' 신고 — 로그인 필요, 같은 유저가 같은 슬롯 중복신고 불가(DB unique 제약이 막아줌).
  // 3회 누적되면 DB 트리거가 자동으로 슬롯을 비활성화 + 차단 처리함(프론트에서 카운트 관리 안 함).
  // ===== LABEL_DAILY_BIZ 시작 =====
  // [어드민] 신고자 확인. auth.users 는 앱에서 직접 못 읽으므로 RPC 를 쓴다.
  // 함수 안에 is_admin() 조건이 있어 소매상끼리는 서로의 신고자를 볼 수 없다.
  const showSlotReporters = async (slot) => {
    const { data, error } = await supabase.rpc('slot_reporters', { p_slot_id: slot.id });
    if (error) { alert('신고 내역 조회 실패: ' + error.message); return; }
    if (!data || data.length === 0) { alert('신고 내역이 없어요.'); return; }
    const rows = data.map((r, i) =>
      (i + 1) + '. ' + (r.reporter_email || '(이메일 없음)') +
      '   ' + String(r.reported_at || '').slice(0, 16).replace('T', ' ')
    );
    alert('신고 ' + data.length + '건\n\n' + rows.join('\n'));
  };
  // ===== LABEL_DAILY_BIZ 끝 =====
  // ===== LABEL_SLOT_STATS 시작 =====
  // 슬롯별 누적/오늘 노출·클릭. RPC 안에 is_admin() 조건이 있어 어드민만 받는다.
  const fetchSlotStats = async () => {
    const { data, error } = await supabase.rpc('slot_stats');
    if (error) { console.error('슬롯 통계 조회 실패:', error.message); return; }
    const map = {};
    (data || []).forEach(r => { map[String(r.slot_id)] = r; });
    setSlotStats(map);
  };

  // 어드민 슬롯 패널을 열 때마다 최신 수치를 가져온다
  useEffect(() => {
    if (!isAdmin || !showAdminSlotPanel) return;
    fetchSlotStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin, showAdminSlotPanel]);

  // 당일 탭 노출 기록 — 세션당 슬롯 1회만
  const tabSeenRef = useRef([]);
  useEffect(() => {
    if (isAdmin) return;
    if (view !== 'DAILY') return;
    dailySlots
      .filter(s => s.is_active && !s.is_banned && s.product_url)
      .forEach(s => {
        if (tabSeenRef.current.includes(s.id)) return;
        tabSeenRef.current = tabSeenRef.current.concat([s.id]);
        logPromoEvent('tab_impression', s, null);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view, dailySlots, isAdmin]);
  // ===== LABEL_SLOT_STATS 끝 =====
  // ===== LABEL_APPLY_ADMIN 시작 =====
  // 입점 신청 목록. applications의 select 정책이 is_admin()이라 어드민만 읽힌다.
  // select('*')로 두는 건 컬럼이 늘어도 이 패치를 다시 안 건드리려는 것.
  const fetchSlotApplications = async () => {
    setSlotApplyLoading(true);
    const { data, error } = await supabase
      .from('applications')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(30);
    setSlotApplyLoading(false);
    if (error) {
      console.error('[LABEL_APPLY_ADMIN] applications 조회 실패', error);
      alert('신청 목록을 불러오지 못했어요.\n\n' + error.message);
      return;
    }
    setSlotApplications(data || []);
  };

  useEffect(() => {
    if (!isAdmin || !showAdminSlotPanel) return;
    fetchSlotApplications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin, showAdminSlotPanel]);

  // 신청서 한 건을 발급 폼에 밀어넣는다.
  // 이름을 use~ 로 시작하면 React가 훅으로 오해하므로 쓰지 않는다.
  const applyToSlotForm = (a) => {
    setNewSlotForm(prev => ({
      ...prev,
      ownerId: a.user_id || prev.ownerId,
      storeName: (a.biz_name || prev.storeName || '').trim(),
      url: a.store_url || prev.url
    }));
    if (!a.user_id) {
      alert('이 신청자는 비회원 상태로 접수했어요.\n\n스토어명과 URL만 채웠습니다.\nLABEL 로그인을 안내한 뒤 아래 이메일 찾기로 회원을 지정해주세요.');
    }
  };
  // ===== LABEL_APPLY_ADMIN 끝 =====
  // ===== LABEL_APPLY 시작 =====
  const openApply = (kind, step) => {
    setApplyType(kind);
    setApplyStep(step);
    setShowApplyModal(true);
  };

  // 신청 접수. 비회원도 넣을 수 있어야 해서 insert 정책이 열려 있고, 조회는 어드민만 가능하다.
  const submitApplication = async () => {
    const phone = (applyForm.phone || '').trim();
    if (!phone) { alert('연락처를 입력해주세요.'); return; }
    if (!(applyForm.storeUrl || '').trim()) { alert('스토어 URL을 입력해주세요.'); return; }  // LABEL_APPLY_FIX2
    const { error } = await supabase.from('applications').insert([{
      apply_type: applyType,
      contact_name: applyForm.name.trim() || null,
      phone: phone,
      biz_name: applyForm.bizName.trim() || null,
      store_url: applyForm.storeUrl.trim() || null,
      memo: applyForm.memo.trim() || null,
      user_id: user ? user.id : null
    }]);
    if (error) { alert('신청 접수에 실패했어요.\n\n' + error.message); return; }
    alert('신청이 접수됐어요.\n확인 후 연락드릴게요.');
    setApplyForm({ name: '', phone: '', bizName: '', storeUrl: '', memo: '' });
    setShowApplyModal(false);
    setShowBizGuideModal(false);
  };
  // ===== LABEL_APPLY 끝 =====
  const handleReportSlot = async (slot) => {
    if (!user) { setShowLoginModal(true); return; }
    if (!window.confirm('이 판매처가 실제로는 재고가 없는 것 같으신가요?\n허위 신고 시 불이익이 있을 수 있어요.')) return;
    const { error } = await supabase.from('daily_slot_reports').insert([{ slot_id: slot.id, reporter_user_id: user.id }]);
    if (error) {
      if (error.code === '23505') { alert('이미 신고하신 슬롯이에요.'); return; }
      alert('신고 접수에 실패했어요: ' + error.message);
      return;
    }
    alert('신고가 접수됐어요. 감사합니다!');
    fetchDailySlots();
  };

  // ✅ NEW: 소매상 본인 슬롯의 상품 정보 교체 (재고 소진된 상품 → 새 상품으로 갈아끼우기)
  // ===== LABEL_SWAP_URLFILL 시작 =====
  // 소매상용: 구매 링크 한 줄로 상품명/이미지/가격을 자동으로 채운다.
  // 스토어명과 소유자는 소매상이 바꿀 수 없는 값이라 손대지 않는다.
  const lookupSwapByUrl = async () => {
    const rawUrl = (slotSwapForm.url || '').trim();
    if (!rawUrl) { alert('구매 링크를 먼저 붙여넣어 주세요.'); return; }
    const m = rawUrl.match(/products\/(\d+)/) || rawUrl.match(/(\d{8,})/);
    if (!m) { alert('주소에서 상품번호를 찾지 못했어요.\n\n스마트스토어 상품 주소가 맞는지 확인해주세요.'); return; }
    const pno = m[1];
    const { data, error } = await supabase
      .from('store_links')
      .select('product_id, store_title, store_image, price, product_url')
      .like('product_url', '%' + pno + '%')
      .limit(1);
    if (error) { alert('조회 실패: ' + error.message); return; }
    if (!data || data.length === 0) {
      alert('LABEL에 등록되지 않은 상품이에요.\n\n아래 칸에 직접 입력해서 저장해주세요.');
      return;
    }
    const sl = data[0];
    let title = sl.store_title || '';
    let image = sl.store_image || '';
    if (!title || !image) {
      const { data: pd } = await supabase
        .from('products').select('title, image_url').eq('product_id', sl.product_id).limit(1);
      if (pd && pd.length > 0) {
        title = title || pd[0].title || '';
        image = image || pd[0].image_url || '';
      }
    }
    setSlotSwapForm(prev => ({
      ...prev,
      url: sl.product_url || rawUrl,
      title: title || prev.title,
      image: image || prev.image,
      price: sl.price ? String(sl.price) : prev.price
    }));
  };
  // ===== LABEL_SWAP_URLFILL 끝 =====
  // ===== LABEL_SLOT_CLEAR 시작 =====
  // 소매상이 자기 슬롯의 상품을 내린다. 슬롯 자리는 그대로 두고 상품 정보만 비운다.
  // 삭제(슬롯 자체)는 어드민 전용이라 여기서 하지 않는다.
  const handleClearSlotProduct = async (slotId) => {
    if (!window.confirm('지금 올려둔 상품을 내릴까요?\n\n슬롯은 그대로 남고, 상품만 사라져요.\n나중에 다시 올릴 수 있어요.')) return;
    const { error } = await supabase.from('daily_slots').update({
      product_title: null,
      product_image: null,
      product_url: null,
      price: null,
      updated_at: new Date().toISOString(),
    }).eq('id', slotId);
    if (error) { alert('상품 내리기 실패: ' + error.message); return; }
    setSlotSwapForm({ title: '', image: '', url: '', price: '' });
    alert('상품을 내렸어요.');
    setShowSlotManageModal(false);
    fetchDailySlots();
  };
  // ===== LABEL_SLOT_CLEAR 끝 =====
  const handleSwapSlotProduct = async (slotId, formData) => {
    const { error } = await supabase.from('daily_slots').update({
      product_title: formData.title,
      product_image: formData.image,
      product_url: formData.url,
      price: formData.price ? parseInt(formData.price, 10) : null,
      updated_at: new Date().toISOString(),
    }).eq('id', slotId);
    if (error) { alert('상품 교체 실패: ' + error.message); return; }
    alert('✅ 슬롯 상품이 교체됐어요!');
    setShowSlotManageModal(false);
    fetchDailySlots();
  };

  // ✅ NEW: [어드민] 새 당일 슬롯 발급 — 소매상의 Supabase user_id를 알아야 함 (SQL로 미리 조회)
  // ===== LABEL_SLOT_URLFILL 시작 =====
  // 상품 URL 한 줄로 슬롯 정보를 자동으로 채운다.
  // 그로브 URL은 smartstore.naver.com/main/products/... 형태로 저장돼 있어
  // 스토어명이 아니라 '상품번호'로만 매칭해야 한다.
  const lookupSlotByUrl = async () => {
    const rawUrl = (newSlotForm.url || '').trim();
    if (!rawUrl) { alert('상품 URL을 붙여넣어 주세요.'); return; }
    const m = rawUrl.match(/products\/(\d+)/) || rawUrl.match(/(\d{8,})/);
    if (!m) { alert('URL에서 상품번호를 찾지 못했어요.\n\n주소가 맞는지 확인해주세요.'); return; }
    const pno = m[1];
    const { data, error } = await supabase
      .from('store_links')
      .select('product_id, store_name, store_title, store_image, price, product_url')
      .like('product_url', '%' + pno + '%')
      .limit(1);
    if (error) { alert('조회 실패: ' + error.message); return; }
    if (!data || data.length === 0) {
      alert('LABEL DB에 없는 상품이에요. (상품번호 ' + pno + ')\n\n아직 크롤링되지 않은 신상일 수 있어요.\n아래 칸에 직접 입력해서 발급하세요.');
      return;
    }
    const sl = data[0];
    let title = sl.store_title || '';
    let image = sl.store_image || '';
    if (!title || !image) {
      const { data: pd } = await supabase
        .from('products').select('title, image_url').eq('product_id', sl.product_id).limit(1);
      if (pd && pd.length > 0) {
        title = title || pd[0].title || '';
        image = image || pd[0].image_url || '';
      }
    }
    setNewSlotForm(prev => ({
      ...prev,
      url: sl.product_url || rawUrl,
      title: title || prev.title,
      image: image || prev.image,
      price: sl.price ? String(sl.price) : prev.price,
      ownerId: prev.ownerId || (user ? user.id : ''),
      storeName: prev.storeName || '그로브'
    }));
  };
  // ===== LABEL_SLOT_URLFILL 끝 =====
  // ===== LABEL_OWNER_EMAIL 시작 =====
  // 소매상 이메일 -> user_id. auth.users 는 앱에서 직접 못 읽으므로
  // 어드민 전용 RPC(find_user_id_by_email)를 쓴다. 함수 안에 is_admin() 조건이 들어있다.
  const lookupOwnerByEmail = async () => {
    const em = (slotOwnerEmail || '').trim();
    if (!em) { alert('소매상 이메일을 입력해주세요.'); return; }
    const { data, error } = await supabase.rpc('find_user_id_by_email', { p_email: em });
    if (error) { alert('조회 실패: ' + error.message); return; }
    if (!data || data.length === 0) {
      alert('LABEL에 가입된 계정이 없어요.\n\n소매상이 먼저 LABEL에서 카카오 로그인을 한 번 해야 슬롯을 줄 수 있어요.');
      return;
    }
    const found = data[0];
    const owned = dailySlots.filter(s => s.owner_user_id === found.user_id);
    if (owned.length > 0) {
      if (!window.confirm('이 회원은 이미 슬롯 ' + owned.length + '개를 갖고 있어요.\n\n관리 화면은 첫 슬롯 하나만 보여줘서, 추가 발급분은 소매상이 직접 교체할 수 없어요.\n\n그래도 진행할까요?')) return;
    }
    setNewSlotForm(prev => ({
      ...prev,
      ownerId: found.user_id,
      // LABEL_SLOT_CLEAR: 스토어명이 비어 있으면 이메일 아이디로 채워 발급이 막히지 않게 한다
      storeName: prev.storeName || (found.user_email || '').split('@')[0]
    }));
    alert('회원을 찾았어요.\n\n' + found.user_email + '\n가입일 ' + String(found.joined_at).slice(0, 10));
  };
  // ===== LABEL_OWNER_EMAIL 끝 =====
  const handleCreateSlot = async (formData) => {
    const { error } = await supabase.from('daily_slots').insert([{
      owner_user_id: formData.ownerId.trim(),
      store_name: formData.storeName.trim(),
      product_title: formData.title || null,
      product_image: formData.image || null,
      product_url: formData.url || null,
      price: formData.price ? parseInt(formData.price, 10) : null,
    }]);
    if (error) { alert('슬롯 생성 실패: ' + error.message); return; }
    alert('✅ 슬롯이 생성됐어요!');
    fetchDailySlots();
  };

  // ✅ NEW: [어드민] 차단된 슬롯 복구 (오신고 등으로 억울하게 차단된 경우)
  // ===== LABEL_SLOT_DELETE 시작 =====
  // [어드민] 슬롯 완전 삭제. 신고 기록을 먼저 지워야 한다 (복구 함수와 같은 순서).
  const handleDeleteSlot = async (slot) => {
    const label = (slot.store_name || '(스토어명 없음)') + ' / ' + (slot.product_title || '(상품 미등록)');
    if (!window.confirm('이 슬롯을 완전히 삭제할까요?\n\n' + label + '\n\n되돌릴 수 없어요.\n(노출/클릭 기록은 그대로 남습니다)')) return;
    const { error: repErr } = await supabase.from('daily_slot_reports').delete().eq('slot_id', slot.id);
    if (notifyIfError('신고 기록 삭제', repErr)) return;
    const { error } = await supabase.from('daily_slots').delete().eq('id', slot.id);
    if (notifyIfError('슬롯 삭제', error)) return;
    fetchDailySlots();
  };
  // ===== LABEL_SLOT_DELETE 끝 =====
  const handleReactivateSlot = async (slot) => {
    if (!window.confirm('이 슬롯을 다시 활성화하고 신고 카운트를 초기화할까요?')) return;
    const { error } = await supabase.from('daily_slots').update({ is_active: true, is_banned: false, report_count: 0 }).eq('id', slot.id);
    if (error) { alert('복구 실패: ' + error.message); return; }
    await supabase.from('daily_slot_reports').delete().eq('slot_id', slot.id);
    fetchDailySlots();
  };

  const handleSeparateProduct = async (link, originalProduct) => {
    // ✅ FIX: 분리 기본값을 '묶여있는 그룹 이름'이 아니라 '분리 대상인 이 링크의 실제 스토어 상품명'으로.
    // (예: 머리핀 그룹에 잘못 묶인 머플러를 분리할 때, 기본값이 머플러 상품명으로 떠야 맞음)
    // 괄호/당일 등 판매 노이즈와 한글 브랜드 중복만 가볍게 정리하고, 미세조정은 입력창에 맡김.
    const _makeSplitDefault = () => {
      let s = link.store_title || cleanTitleStr(originalProduct.title);
      s = s.replace(/\([^)]*\)/g, " ");
      ["당일출고","당일","무료배송","신상","재진행","오늘출발"].forEach(w => { s = s.split(w).join(" "); });
      const brandNs = (originalProduct.brand_name || "").replace(/\s/g, "").toLowerCase();
      s = s.split(/\s+/).filter(w => w && w.replace(/\s/g,"").toLowerCase() !== brandNs).join(" ");
      s = s.replace(/\s+/g, " ").trim();
      return `${originalProduct.brand_name},${s}`;
    };
    const defaultText = _makeSplitDefault();
    const input = window.prompt("독립시킬 진짜 '도매택,상품명'을 입력하세요.", defaultText);
    if (!input || !input.includes(',')) return;

    const [targetBrand, targetTitle] = input.split(',').map(s => s.trim());
    const dbValue = `${targetBrand}|${targetTitle}`;
    // ✅ FIX: split_rules.product_url에 유니크 제약이 있는데 onConflict 지정이 없으면
    // 충돌 시 새 INSERT를 시도하다 "duplicate key" 에러가 나서 실패함 (로그인 문제 아님).
    const { error: e1 } = await supabase.from('split_rules').upsert(
      [{ product_url: link.product_url.split("?")[0], correct_title: dbValue.trim() }],
      { onConflict: 'product_url' }
    );
    if (notifyIfError('분리', e1)) return;

    // ✅ FIX: 같은 링크에 예전 merge_rules(병합/이름수정 시 등록됨)가 남아 있으면,
    // 크롤러가 merge를 split보다 먼저 보기 때문에 분리가 영원히 무시됨.
    // (실제로 분리해둔 상품이 매 크롤링마다 옛 그룹으로 되돌아가던 원인)
    // -> 분리는 "이건 다른 상품이다"라는 더 나중/더 강한 의사표시이므로 기존 merge를 제거.
    const { error: eMergeDel } = await supabase.from('merge_rules')
      .delete().eq('product_url', link.product_url.split("?")[0]);
    if (eMergeDel) console.error('분리: 기존 병합규칙 삭제 실패(무시하고 진행):', eMergeDel);

    // ✅ FIX: 예전엔 링크를 그냥 삭제만 해서, 다음 크롤링 전까지 분리된 상품이
    // 화면에 아예 안 뜨거나(신규) 대표사진이 예전 그룹의 엉뚱한 사진으로 남아있었음(기존).
    // 이제 즉시 새 product_id로 옮기고, 대표사진도 방금 분리된 이 링크의 실제 사진으로 갱신.
    const targetProductId = dbValue.trim();
    const { error: eProd } = await supabase.from('products').upsert([{
      product_id: targetProductId,
      brand_name: targetBrand,
      title: targetTitle,
      clean_title: targetTitle,
      image_url: link.store_image || originalProduct.image_url,
    }], { onConflict: 'product_id' });
    if (notifyIfError('분리', eProd)) return;

    const { error: e2 } = await supabase.from('store_links').update({ product_id: targetProductId }).eq('id', link.id);
    if (notifyIfError('분리', e2)) return;

    fetchProductsAndClicks();
  };

  // ✅ NEW: product_id가 바뀔 때(이름수정/합치기) 찜(favorites)도 같이 새 product_id로 옮겨서
  // "고아 찜"(가리키는 상품이 사라져서 안 보이게 되는 것)이 생기지 않게 함.
  // 한 행씩 개별 처리하는 이유: 사용자가 이미 대상 상품도 찜해둔 경우 유니크 제약 충돌이 나는데,
  // 그 경우는 옛 찜 기록만 지우면 됨(대상 쪽엔 이미 찜이 있으므로).
  // ✅ NEW(2026-09-07): 병합 추천에서 "어느 쪽에 찜이 걸렸는지"를 화면에서 바로 보게 한다.
  // 찜이 걸린 쪽을 기준으로 합쳐야 회원 찜 목록이 안 깨진다.
  // 상품마다 조회하면 호출이 수십 번 나가므로 한 번만 통째로 받아 센다.
  const [favCounts, setFavCounts] = useState({});
  useEffect(() => {
    if (!isAdmin) { setFavCounts({}); return; }
    (async () => {
      const { data, error } = await supabase.from('favorites').select('product_id, user_id').limit(5000);
      if (error) { console.error('찜 집계 실패:', error); return; }
      const m = {};
      (data || []).forEach(r => {
        if (!r.product_id) return;
        (m[r.product_id] = m[r.product_id] || new Set()).add(r.user_id);
      });
      const c = {};
      Object.keys(m).forEach(k => { c[k] = m[k].size; });
      setFavCounts(c);
    })();
  }, [isAdmin]);

  const migrateFavorites = async (oldProductId, newProductId) => {
    if (!oldProductId || oldProductId === newProductId) return;
    const { data: rows } = await supabase.from('favorites').select('id').eq('product_id', oldProductId);
    if (!rows || rows.length === 0) return;
    for (const row of rows) {
      const { error } = await supabase.from('favorites').update({ product_id: newProductId }).eq('id', row.id);
      if (error) {
        await supabase.from('favorites').delete().eq('id', row.id);
      }
    }
  };

  const handleMergeProduct = async (link) => {
    const targetInput = window.prompt("이 링크를 합쳐서 집어넣을 대상 상품의 정확한 이름표를 입력하세요.\n형식: 도매택,상품명\n예시: 멜라운지,에이스프릴블라우스");
    if (!targetInput || !targetInput.includes(',')) {
      alert("❌ 형식이 올바르지 않습니다. '도매택,상품명' 구조로 쉼표를 넣어주세요.");
      return;
    }
    const targetDbValue = targetInput.replace(',', '|').trim();

    const { error: e1 } = await supabase.from('merge_rules').upsert([{
      product_url: link.product_url.split("?")[0],
      target_clean_title: targetDbValue
    }], { onConflict: 'product_url' });
    if (notifyIfError('합치기', e1)) return;

    const { error: e2 } = await supabase.from('store_links').delete().eq('id', link.id);
    if (notifyIfError('합치기', e2)) return;
    alert("🔗 합치기 규칙 저장 완료! 다음번 크롤링 시 해당 상품 묶음으로 자동 결합됩니다.");
    fetchProductsAndClicks();
  };

  // ✅ NEW: 상품군 전체(모든 판매처 링크)를 다른 상품군으로 한 번에 합치기
  // ✅ NEW: 상품군 전체 삭제 — 판매처 링크를 모두 blacklist에 넣고 상품 행까지 제거.
  // (미분류/분리추천 목록에서 "이 상품은 아예 필요 없다"고 판단했을 때 바로 정리)
  const handleDeleteWholeProduct = async (product) => {
    const links = getLinks(product);
    if (!window.confirm(`"${product.brand_name} · ${cleanTitleStr(product.title)}"을(를) 판매처 ${links.length}곳과 함께 영구 삭제할까요?\n(다음 크롤링에서도 다시 안 올라옵니다)`)) return;
    if (links.length > 0) {
      const bl = await Promise.all(links.map(l =>
        supabase.from('blacklist').insert([{ product_url: (l.product_url || '').split('?')[0] }])
      ));
      bl.forEach(r => { if (r.error) console.error('삭제(blacklist) 실패:', r.error); });
      const { error: eLinks } = await supabase.from('store_links').delete().eq('product_id', product.product_id);
      if (notifyIfError('상품 삭제', eLinks)) return;
    }
    await supabase.from('favorites').delete().eq('product_id', product.product_id);
    const { error: eProd } = await supabase.from('products').delete().eq('product_id', product.product_id);
    if (notifyIfError('상품 삭제', eProd)) return;
    fetchProductsAndClicks();
  };

  const handleMergeGroup = async (product) => {
    const targetInput = window.prompt(
      "이 상품 전체(모든 판매처)를 합쳐서 집어넣을 대상 상품의 정확한 이름표를 입력하세요.\n형식: 도매택,상품명\n예시: 멜라운지,에이스프릴블라우스"
    );
    if (!targetInput || !targetInput.includes(',')) {
      alert("❌ 형식이 올바르지 않습니다. '도매택,상품명' 구조로 쉼표를 넣어주세요.");
      return;
    }
    const targetDbValue = targetInput.replace(',', '|').trim();

    if (targetDbValue === product.clean_title) {
      alert("❌ 자기 자신에게는 합칠 수 없어요.");
      return;
    }

    const links = getLinks(product);
    if (links.length === 0) { alert("합칠 판매처 링크가 없어요."); return; }

    if (!window.confirm(`"${product.brand_name} · ${cleanTitleStr(product.title)}" 상품군 전체(판매처 ${links.length}곳)를\n"${targetInput}"(으)로 합칩니다.\n계속할까요?`)) return;

    // 이 상품군에 속한 모든 판매처 링크에 병합 규칙을 걸어둠 (다음 크롤링 때 target으로 재편입)
    const mergeResults = await Promise.all(links.map(l =>
      supabase.from('merge_rules').upsert([{
        product_url: l.product_url.split("?")[0],
        target_clean_title: targetDbValue
      }], { onConflict: 'product_url' })
    ));
    if (mergeResults.some(r => notifyIfError('통째로 합치기', r.error))) return;

    // ✅ NEW: 상품이 사라지기 전에 찜 목록부터 새 대상으로 이전
    await migrateFavorites(product.product_id, targetDbValue);

    // 지금 화면에서도 즉시 반영: 판매처 링크와 빈 상품군 삭제
    const { error: e1 } = await supabase.from('store_links').delete().eq('product_id', product.product_id);
    if (notifyIfError('통째로 합치기', e1)) return;
    const { error: e2 } = await supabase.from('products').delete().eq('id', product.id);
    if (notifyIfError('통째로 합치기', e2)) return;

    alert(`🔗 상품군 병합 완료! 판매처 ${links.length}곳이 다음 크롤링부터 "${targetInput}"(으)로 합쳐집니다.`);
    fetchProductsAndClicks();
  };

  // ✅ NEW: 병합 추천 클러스터(도매택+최저가 동일) 전체를 첫 번째 그룹 기준으로 한 번에 합치기
  const handleMergeSuggestionGroup = async (group) => {
    const target = group[0];
    const others = group.slice(1);
    const totalLinks = others.reduce((sum, p) => sum + getLinks(p).length, 0);

    if (!window.confirm(`"${target.brand_name} · ${cleanTitleStr(target.title)}"(을)를 기준으로\n나머지 ${others.length}개 그룹(판매처 ${totalLinks}곳)을 합칩니다.\n계속할까요?`)) return;

    for (const p of others) {
      const links = getLinks(p);
      const mergeResults = await Promise.all(links.map(l =>
        supabase.from('merge_rules').upsert([{
          product_url: l.product_url.split("?")[0],
          target_clean_title: target.clean_title
        }], { onConflict: 'product_url' })
      ));
      if (mergeResults.some(r => notifyIfError('병합 추천 합치기', r.error))) return;
      // ✅ NEW: 상품이 사라지기 전에 찜 목록부터 새 대상으로 이전
      await migrateFavorites(p.product_id, target.product_id);
      const { error: e1 } = await supabase.from('store_links').delete().eq('product_id', p.product_id);
      if (notifyIfError('병합 추천 합치기', e1)) return;
      const { error: e2 } = await supabase.from('products').delete().eq('id', p.id);
      if (notifyIfError('병합 추천 합치기', e2)) return;
    }

    alert(`🔗 ${others.length}개 그룹 병합 완료! 다음 크롤링부터 "${target.brand_name} · ${cleanTitleStr(target.title)}"(으)로 합쳐집니다.`);
    fetchProductsAndClicks();
  };

  const handleDeleteProduct = async (link) => {
    // ✅ NEW: 찜한 사람이 있는 상품의 "마지막 남은 링크"를 지우면 그 상품 자체가 사라짐 —
    // 이 경우 강하게 경고해서 실수로 찜한 상품이 조용히 없어지는 걸 방지
    const parentProduct = products.find(p => p.product_id === link.product_id);
    const remainingLinks = parentProduct ? getLinks(parentProduct).length : 99;
    if (remainingLinks <= 1) {
      const { count, error: favError } = await supabase
        .from('favorites')
        .select('user_id', { count: 'exact', head: true })
        .eq('product_id', link.product_id);
      if (!favError && count > 0) {
        if (!window.confirm(`⚠️ 이 상품은 ${count}명이 찜했는데, 이게 마지막 남은 판매처예요.\n지금 삭제하면 그 사람들 찜 목록에서 상품이 완전히 사라져요.\n그래도 삭제하시겠습니까?`)) return;
      } else {
        if (!window.confirm("이 링크를 영구 삭제하시겠습니까?")) return;
      }
    } else {
      if (!window.confirm("이 링크를 영구 삭제하시겠습니까?")) return;
    }
    const { error: e1 } = await supabase.from('blacklist').insert([{ product_url: link.product_url.split("?")[0] }]);
    if (notifyIfError('삭제', e1)) return;
    const { error: e2 } = await supabase.from('store_links').delete().eq('id', link.id);
    if (notifyIfError('삭제', e2)) return;
    // ✅ FIX: 마지막 남은 링크였으면 store_links만 지우고 products 행을 그대로 두면
    // "판매처 0곳"인 유령 상품이 피드에 계속 남게 됨 — 이 경우 상품 행 자체도 같이 삭제.
    if (remainingLinks <= 1) {
      await supabase.from('products').delete().eq('product_id', link.product_id);
    }
    fetchProductsAndClicks();
  };

  const handleRenameProduct = async (product) => {
    const newName = window.prompt("대표 상품명을 수정하세요:", cleanTitleStr(product.title));
    if (!newName || !newName.trim()) return;
    const newCorrectTitle = `${product.brand_name}|${newName.trim()}`;
    // ✅ FIX: 키와 표시명이 모두 목표값일 때만 '변경 없음'. clean_title만 보면
    // 키가 이미 바뀐 정상 상태를 걸러내지 못한다.
    if (newCorrectTitle === product.clean_title && newCorrectTitle === product.product_id) return;

    // ✅ FIX: 기존 rename_rules(그날 AI가 뽑은 dedup_key 기준)는 다음날 AI가 이름을 다르게 뽑으면
    // 매칭이 안 돼서 무력화됐음. 링크(URL) 단위로 merge_rules를 걸어두면 AI가 뭐라고 뽑든
    // 크롤러가 항상 이 이름으로 강제 배정하므로(merge 기능과 동일한 메커니즘), 훨씬 안정적임.
    const links = getLinks(product);
    const mergeResults = await Promise.all(links.map(l =>
      supabase.from('merge_rules').upsert([{
        product_url: l.product_url.split("?")[0],
        target_clean_title: newCorrectTitle
      }], { onConflict: 'product_url' })
    ));
    if (mergeResults.some(r => notifyIfError('이름 수정', r.error))) return;

    // 기존 rename_rules도 호환을 위해 같이 남겨둠 (해가 되진 않음)
    // ✅ FIX: onConflict 누락 시 같은 상품을 두 번째로 이름 수정할 때 "duplicate key" 에러 발생
    await supabase.from('rename_rules').upsert(
      [{ original_title: product.clean_title, correct_title: newCorrectTitle }],
      { onConflict: 'original_title' }
    );

    // ✅ FIX: store_links.product_id가 products.product_id를 FK로 참조하고 있어서,
    // products 행의 product_id를 그냥 update하면 "violates foreign key constraint" 에러가 남
    // (그 값을 참조 중인 store_links 행들이 순간적으로 고아가 되기 때문).
    // → 새 이름의 products 행을 먼저 만들고(이미 같은 이름이 있으면 그 행으로 합침),
    //    store_links를 새 행으로 옮긴 다음, 예전 행을 지우는 순서로 처리.
    // ✅ FIX(2026-08-21): 예전 코드는 아래 (a)를 구분하지 못해 자기 자신을 delete하다가
    // "violates foreign key constraint" 로 매번 실패했다.
    // product_id(키)와 clean_title(표시명)이 어긋난 상태는 이 시스템에서 정상이다.
    // (키는 URL 기반 계승, 표시명은 매일 AI가 다시 뽑음)
    const { data: existingTarget } = await supabase.from('products').select('id').eq('product_id', newCorrectTitle).maybeSingle();

    // (a) 키는 이미 목표값이고 표시명만 낡은 경우 -> 표시명만 갱신하고 끝낸다.
    if (existingTarget && existingTarget.id === product.id) {
      const { error: titleError } = await supabase.from('products')
        .update({ title: newName.trim(), clean_title: newCorrectTitle })
        .eq('id', product.id);
      if (notifyIfError('이름 수정', titleError)) return;
      fetchProductsAndClicks();
      return;
    }

    // (b) 목표 이름의 '다른' 행이 이미 있는 경우 -> 그 행으로 합친다.
    if (existingTarget) {
      await migrateFavorites(product.product_id, newCorrectTitle);
      const { error: relinkError } = await supabase.from('store_links').update({ product_id: newCorrectTitle }).eq('product_id', product.product_id);
      if (notifyIfError('이름 수정', relinkError)) return;
      const { error: reviewError } = await supabase.from('reviews').update({ product_id: newCorrectTitle }).eq('product_id', product.product_id);
      if (notifyIfError('이름 수정', reviewError)) return;
      const { error: deleteError } = await supabase.from('products').delete().eq('id', product.id);
      if (notifyIfError('이름 수정', deleteError)) return;
      fetchProductsAndClicks();
      return;
    }

    // (c) 새 이름 -> 키 자체를 update. FK의 ON UPDATE CASCADE가 store_links/reviews를 따라오게 한다.
    //     insert+delete 대신 update라서 id/click_count/생성일이 그대로 보존된다.
    await migrateFavorites(product.product_id, newCorrectTitle);
    const { error: updateError } = await supabase.from('products')
      .update({ title: newName.trim(), clean_title: newCorrectTitle, product_id: newCorrectTitle })
      .eq('id', product.id);
    if (notifyIfError('이름 수정', updateError)) return;

    fetchProductsAndClicks();
  };

  const handleRenameBrand = async (product) => {
    const newBrandName = window.prompt("도매택(브랜드명)을 수정하세요:", product.brand_name);
    if (!newBrandName || !newBrandName.trim()) return;
    const existingTitlePart = product.clean_title && product.clean_title.includes("|") ? product.clean_title.split("|").slice(1).join("|") : (product.title || "");
      const newCorrectTitle = `${newBrandName.trim()}|${existingTitlePart}`;
    if (newCorrectTitle === product.clean_title) return; // 변경 없음

    // ✅ FIX: 기존 rename_rules(그날 AI가 뽑은 dedup_key 기준)는 다음날 AI가 이름을 다르게 뽑으면
    // 매칭이 안 돼서 무력화됐음. 링크(URL) 단위로 merge_rules를 걸어두면 AI가 뭐라고 뽑든
    // 크롤러가 항상 이 이름으로 강제 배정하므로(merge 기능과 동일한 메커니즘), 훨씬 안정적임.
    const links = getLinks(product);
    const mergeResults = await Promise.all(links.map(l =>
      supabase.from('merge_rules').upsert([{
        product_url: l.product_url.split("?")[0],
        target_clean_title: newCorrectTitle
      }], { onConflict: 'product_url' })
    ));
    if (mergeResults.some(r => notifyIfError('이름 수정', r.error))) return;

    // 기존 rename_rules도 호환을 위해 같이 남겨둠 (해가 되진 않음)
    // ✅ FIX: onConflict 누락 시 같은 상품을 두 번째로 이름 수정할 때 "duplicate key" 에러 발생
    await supabase.from('rename_rules').upsert(
      [{ original_title: product.clean_title, correct_title: newCorrectTitle }],
      { onConflict: 'original_title' }
    );

    // ✅ FIX: store_links.product_id가 products.product_id를 FK로 참조하고 있어서,
    // products 행의 product_id를 그냥 update하면 "violates foreign key constraint" 에러가 남
    // (그 값을 참조 중인 store_links 행들이 순간적으로 고아가 되기 때문).
    // → 새 이름의 products 행을 먼저 만들고(이미 같은 이름이 있으면 그 행으로 합침),
    //    store_links를 새 행으로 옮긴 다음, 예전 행을 지우는 순서로 처리.
    // ✅ FIX(2026-08-21): 상품명 수정과 동일한 FK 위반 버그가 여기에도 있었다. 같은 방식으로 수정.
    const { data: existingTarget } = await supabase.from('products').select('id').eq('product_id', newCorrectTitle).maybeSingle();

    // (a) 키는 이미 목표값이고 표시명만 낡은 경우
    if (existingTarget && existingTarget.id === product.id) {
      const { error: titleError } = await supabase.from('products')
        .update({ brand_name: newBrandName.trim(), clean_title: newCorrectTitle })
        .eq('id', product.id);
      if (notifyIfError('이름 수정', titleError)) return;
      fetchProductsAndClicks();
      return;
    }

    // (b) 목표 이름의 '다른' 행이 이미 있는 경우 -> 합치기
    if (existingTarget) {
      await migrateFavorites(product.product_id, newCorrectTitle);
      const { error: relinkError } = await supabase.from('store_links').update({ product_id: newCorrectTitle }).eq('product_id', product.product_id);
      if (notifyIfError('이름 수정', relinkError)) return;
      const { error: reviewError } = await supabase.from('reviews').update({ product_id: newCorrectTitle }).eq('product_id', product.product_id);
      if (notifyIfError('이름 수정', reviewError)) return;
      const { error: deleteError } = await supabase.from('products').delete().eq('id', product.id);
      if (notifyIfError('이름 수정', deleteError)) return;
      fetchProductsAndClicks();
      return;
    }

    // (c) 새 이름 -> 키 자체를 update (ON UPDATE CASCADE가 자식들을 따라오게 함)
    await migrateFavorites(product.product_id, newCorrectTitle);
    const { error: updateError } = await supabase.from('products')
      .update({ brand_name: newBrandName.trim(), clean_title: newCorrectTitle, product_id: newCorrectTitle })
      .eq('id', product.id);
    if (notifyIfError('이름 수정', updateError)) return;

    fetchProductsAndClicks();
  };

  const handleReorder = async (product, sortedLinks, fromIndex, toIndex) => {
    if (toIndex < 0 || toIndex >= sortedLinks.length) return;
    const newLinks = [...sortedLinks];
    const [movedItem] = newLinks.splice(fromIndex, 1);
    newLinks.splice(toIndex, 0, movedItem);
    const updates = newLinks.map((l, idx) => supabase.from('store_links').update({ custom_order: idx + 1 }).eq('id', l.id));
    const results = await Promise.all(updates);
    if (results.some(r => notifyIfError('순서변경', r.error))) return;
    fetchProductsAndClicks(); 
  };

  // ✅ NEW: 검색 매칭 헬퍼 — "멜라운지 뷔스티에"처럼 중간에 다른 단어가 껴 있어도 잡히게.
  //  1) 검색어를 통째로 붙여 포함 검사 (기존 동작 유지: "스터닝치즈")
  //  2) 공백으로 쪼개 모든 조각이 포함되는지 ("멜라운지 뷔스티에")
  //  3) 검색어가 브랜드명으로 시작하면 브랜드를 떼고 나머지를 상품명에서 검사
  //     ("멜라운지뷔스티에" -> 브랜드"멜라운지" + 나머지"뷔스티에")
  const matchSearch = (query, p) => {
    const b = (p.brand_name || '').toLowerCase().replace(/\s+/g, '');
    const t = (p.title || '').toLowerCase().replace(/\s+/g, '');
    const c = (p.clean_title || '').toLowerCase().replace(/\s+/g, '');
    const combined = b + t + c;
    const q = query.toLowerCase().trim();
    const qn = q.replace(/\s+/g, '');
    if (!qn) return true;
    if (combined.includes(qn)) return true;
    const terms = q.split(/\s+/).filter(Boolean);
    if (terms.length > 1 && terms.every(x => combined.includes(x.replace(/\s+/g, '')))) return true;
    if (b && qn.startsWith(b)) {
      const rest = qn.slice(b.length);
      if (rest && (t.includes(rest) || c.includes(rest))) return true;
    }
    return false;
  };

  // ===== LABEL_NEW_RELATIVE 시작 =====
  // 신상 기준 = 불러온 상품의 first_seen_at 최댓값(마지막 크롤 시각). 크롤이 쉬어도 신상 탭이 비지 않는다.
  // 찜 보충·회색 카드는 최댓값을 끌어내리지 않는다. 값이 없으면 지금 시각으로 되돌아간다.
  const _newRef = products.reduce((m, p) => {
    const t = (p && p.first_seen_at) ? new Date(p.first_seen_at).getTime() : 0;
    return (t > m) ? t : m;
  }, 0) || Date.now();
  try { window.__LABEL_NEW_REF = new Date(_newRef).toISOString(); } catch (e) {}
  // ===== LABEL_NEW_RELATIVE 끝 =====
  let displayProducts = products.filter(p => {
    // ✅ FIX: '당일' 탭은 daily_slots만 별도로 보여주는 화면이라, 일반 상품 그리드는 아예 안 나와야 함
    if (view === 'DAILY') return false;

    if (view === 'NEWARRIVAL') {
      if (!p.first_seen_at) return false;
      if ((_newRef - new Date(p.first_seen_at).getTime()) >= 3 * 24 * 3600 * 1000) return false; // LABEL_NEW_RELATIVE
    }

    const categoryOverride = categoryOverrides[p.product_id];
    if (category === '기타') {
      if (categoryOverride) return false;
      const realCategories = allCategories.filter(c => c !== '전체' && c !== '기타');
      const matchTitle = p.title || "";
      const matchClean = p.clean_title || "";
      const matchesAny = realCategories.some(cat => {
        const keywords = getCategoryKeywords(cat);
        const excludes = getCategoryExcludes(cat);
        const matched = keywords.some(k => matchTitle.includes(k) || matchClean.includes(k));
        const excluded = excludes.some(k => matchTitle.includes(k) || matchClean.includes(k));
        return matched && !excluded;
      });
      if (matchesAny) return false;
    } else if (category !== '전체') {
      // ✅ FIX: 예전엔 탭 필터가 '키워드 포함'만 봐서, 화면에 표시되는 카테고리와 달랐음.
      // (예: "베스트 팬츠"는 조끼 키워드 '베스트'에 걸려 조끼 탭에 나오지만 표시는 '팬츠')
      // -> getProductCategory와 완전히 동일한 판정을 쓰도록 통일. 화면 표시 = 탭 소속.
      // (수동 카테고리 지정(categoryOverride)도 getProductCategory 안에서 최우선 처리됨)
      if (getProductCategory(p) !== category) return false;
    }
    
    if (isAdmin && adminSearch.trim() !== '') {
      if (!matchSearch(adminSearch, p)) return false;
    }

    // ✅ NEW: 그로브(내 스토어)만 모아보기 — 이 상품군에 내 스토어 링크가 하나라도 있어야 통과
    if (isAdmin && showMyStoreOnly) {
      const links = getLinks(p);
      if (!links.some(isMyStoreLink)) return false;
    }

    // ✅ NEW: 소비자 검색어 필터 (브랜드명/상품명)
    // ✅ FIX: admin 검색과 동일하게, 필드를 따로 검사하면 "브랜드+상품명"이 붙은
    // 검색어를 못 잡음. 합치고 공백도 지운 뒤 통째로 비교.
    if (!isAdmin && searchQuery.trim() !== '') {
      if (!matchSearch(searchQuery, p)) return false;
    }
    
    if (view === 'BRAND' && p.brand_name !== selectedBrand) return false;

    // ✅ NEW: '찜' 탭 - 내가 찜한 상품만
    if (p.__dead && view !== 'MY') return false;   // LABEL_FAV_DEAD: MY 탭 밖으로 새지 않게
    if (view === 'MY' && !favorites.includes(p.product_id)) return false;
    
    if (view === 'SALE') {
      const links = getLinks(p);
      if (links.length < 2) return false; 
      const prices = links.map(l => Number(l.price)).filter(pr => pr > 0);
      if (prices.length < 2) return false;
      const min = Math.min(...prices);
      const max = Math.max(...prices);
      return max >= min * 1.3; 
    }
    return true;
  });

  if (view === 'RANKING') {
    displayProducts = [...displayProducts].sort((a, b) => {
      const scoreA = ((recentClicks[a.product_id] || 0) * 0.7) + ((a.click_count || 0) * 0.3);
      const scoreB = ((recentClicks[b.product_id] || 0) * 0.7) + ((b.click_count || 0) * 0.3);
      if (scoreB !== scoreA) return scoreB - scoreA;

      // ✅ NEW(2026-08-22): 클릭 점수가 같으면 '판매처 수'가 많은 쪽을 위로.
      // 클릭이 아직 안 쌓인 초기 구간에서는 대량 동점이 나는데, 곧바로 최신순으로 가면
      // 방금 올라온 상품이 상위를 차지해 실제로 검증된 상품이 묻힌다.
      // 여러 소매점이 택했다는 것 자체가 시장 신호라 더 나은 대리 지표가 된다.
      const linksA = getLinks(a).length;
      const linksB = getLinks(b).length;
      if (linksB !== linksA) return linksB - linksA;

      // 그마저 같으면 최근 수집된 상품 우선 (최신성)
      return new Date(b.crawled_at) - new Date(a.crawled_at);
    }).slice(0, 10);
  } else if (sortBy === 'lowprice') {
    // ✅ NEW: 최저가순 정렬
    displayProducts = [...displayProducts].sort((a, b) => getMinPrice(a) - getMinPrice(b));
  } else {
    // ✅ FIX: 단순 최신순 대신 인기도(클릭)와 최신성을 교차 배치한 추천순이 기본값
    displayProducts = buildInterleavedFeed(displayProducts);
  }

  // ✅ FIX: "도매택+가격 완전 일치"만으로 묶으면 가격이 우연히 같은 완전히 다른 상품까지 병합 추천에 떴음.
  // ✅ FIX 2: "카테고리 일치"도 넣어봤는데, 카테고리 자체가 "스커트"/"나시"처럼 너무 넓은 단위라
  // 이름이 전혀 다른 상품들까지 수십 개씩 한 그룹으로 묶여버림. 카테고리 조건은 빼고,
  // 도매택이 같고 + 상품명이 실제로 비슷하고 + 가격도 "비슷한"(15% 이내) 경우에만 묶이도록 함.
  let mergeSuggestions = [];
  if (isAdmin) {
    // ✅ FIX: "스커트"처럼 스타일명 없이 카테고리 단어 하나뿐인 상품명이 있으면, 그게 다른 모든
    // "OO 스커트"류 상품명에 전부 포함되는 만능 허브가 돼서, union-find 특성상 서로 무관한
    // 상품들이 이 상품 하나를 매개로 줄줄이 다 하나로 묶여버리는 사고가 있었음.
    // (겉으로 보면 "카테고리로 묶인 것처럼" 보이지만, 실제로는 이 허브 하나 때문에 생긴 부작용)
    const BARE_CATEGORY_WORDS = new Set(['나시', '블라우스', '셔츠', '니트', '가디건', '원피스', '팬츠', '스커트', '자켓', '티셔츠']);
    const normName = (p) => cleanTitleStr(p.title).replace(/\s+/g, '');
    const isSimilarName = (a, b) => {
      const na = normName(a), nb = normName(b);
      if (na.length < 2 || nb.length < 2) return false;
      const shorter = na.length <= nb.length ? na : nb;
      const longer = na.length <= nb.length ? nb : na;
      if (BARE_CATEGORY_WORDS.has(shorter)) return false; // 카테고리 단어 하나뿐이면 "유사하다"고 보지 않음
      return longer.includes(shorter);
    };
    // ✅ NEW(2026-09-07): "엘리사 세트" vs "엘리사홀터 세트" 유형.
    // 상품명 중간에 단어가 끼어들면 공백 제거 후 통짜 includes 판정이 깨져서
    // 기존 isSimilarName 으로는 안 잡혔다. 카테고리(마지막 토큰)가 같고
    // 스타일명 한쪽이 다른 쪽으로 시작하면 후보로 올린다.
    // 가격 조건은 걸지 않는다 — 접두 일치는 가격보다 강한 신호라 사람이 보고 판단한다.
    const styleCatOf = (p) => {
      const parts = cleanTitleStr(p.title).split(/\s+/).filter(Boolean);
      if (parts.length < 2) return null;
      return { style: parts.slice(0, -1).join(''), cat: parts[parts.length - 1] };
    };
    const isPrefixStyle = (a, b) => {
      const sa = styleCatOf(a), sb = styleCatOf(b);
      if (!sa || !sb) return false;
      if (sa.cat !== sb.cat) return false;
      const s = sa.style.length <= sb.style.length ? sa.style : sb.style;
      const l = sa.style.length <= sb.style.length ? sb.style : sa.style;
      if (s.length < 2 || s === l) return false;
      if (BARE_CATEGORY_WORDS.has(s)) return false;
      return l.startsWith(s);
    };
    const isPriceSimilar = (a, b) => {
      const p1 = getMinPrice(a), p2 = getMinPrice(b);
      if (!isFinite(p1) || !isFinite(p2)) return false;
      return Math.abs(p1 - p2) / Math.max(p1, p2) <= 0.15; // 15% 이내면 "비슷한 가격"
    };

    const byBrand = {};
    // ✅ CHANGE(2026-09-07): displayProducts 는 탭·카테고리 필터를 탄 목록이라
    // 보는 화면에 따라 병합 추천 건수가 달라졌다. 어드민은 한 화면에서 전부 보아야 하므로 products 전체를 쓴다.
    products.forEach(p => {
      if (!byBrand[p.brand_name]) byBrand[p.brand_name] = [];
      byBrand[p.brand_name].push(p);
    });

    Object.values(byBrand).forEach(group => {
      if (group.length < 2) return;
      const parent = group.map((_, i) => i);
      const find = (i) => { while (parent[i] !== i) { parent[i] = parent[parent[i]]; i = parent[i]; } return i; };
      const union = (i, j) => { const ri = find(i), rj = find(j); if (ri !== rj) parent[ri] = rj; };

      for (let i = 0; i < group.length; i++) {
        for (let j = i + 1; j < group.length; j++) {
          if (isPrefixStyle(group[i], group[j])) { union(i, j); continue; }
          if (!isPriceSimilar(group[i], group[j])) continue;
          if (isSimilarName(group[i], group[j])) union(i, j);
        }
      }

      const clusters = {};
      group.forEach((p, i) => {
        const root = find(i);
        (clusters[root] = clusters[root] || []).push(p);
      });

      Object.values(clusters).forEach(cluster => {
        if (cluster.length < 2) return;
        const key = cluster.map(p => p.id).sort().join('_');
        if (dismissedSuggestions.includes(key)) return;
        mergeSuggestions.push({ key, items: cluster });
      });
    });
  }

  // ✅ NEW: 병합 추천 "확인" — 진짜 다른 상품이라고 판단했을 때, 그 클러스터를 목록에서 영구히 숨김
  const handleDismissSuggestion = async (key) => {
    setDismissedSuggestions(prev => [...prev, key]); // 낙관적 업데이트로 즉시 화면에서 숨김
    const { error } = await supabase.from('dismissed_merge_suggestions').insert([{ cluster_key: key }]);
    if (error) {
      console.error('병합 추천 확인 저장 실패:', error);
      setDismissedSuggestions(prev => prev.filter(k => k !== key)); // 롤백
      alert('확인 처리에 실패했어요. (' + error.message + ')');
    }
  };

  // ✅ NEW: 분리 추천 감지 — 묶음의 '스타일명'(상품명 첫 단어)이 그 판매처 원제목(store_title)에
  // 아예 없으면, 서로 다른 상품이 한 그룹에 묶인 것으로 보고 분리를 추천한다.
  // (예: 묶음 "온스|멀린 라운드 니트"인데 원제목은 "온스 OUNCE 노아 와이드 니트" -> 멀린 없음)
  // 붙여쓴 상품명("가든블라우스")은 첫 단어가 통째라 오탐이 많아 제외하고, 띄어쓴 것만 검사.
  // ✅ 그룹 단위로 모아서, 그룹 전체 판매처를 함께 보여줌(병합추천과 동일한 방식).
  //   같은 그룹에 문제 링크가 여러 개면 하나의 추천으로 묶인다.
  let splitSuggestions = [];
  if (isAdmin) {
    products.forEach(p => {
      const title = (p.title || '').trim();
      if (!title.includes(' ')) return;                    // 붙여쓴 이름은 오탐 많아 제외
      const style = title.split(/\s+/)[0];
      if (!style || style.length < 2) return;
      const styleNs = style.toLowerCase().replace(/\s+/g, '');
      const links = getLinks(p);
      if (links.length === 0) return;
      const bad = [], good = [];
      links.forEach(l => {
        const st = (l.store_title || '').toLowerCase().replace(/\s+/g, '');
        if (st && !st.includes(styleNs)) bad.push(l); else good.push(l);
      });
      // 문제 링크가 없거나, 모두 "확인" 처리됐으면 추천에서 제외
      const remaining = bad.filter(l => !dismissedSplitUrls.includes((l.product_url || '').split('?')[0]));
      if (remaining.length === 0) return;
      splitSuggestions.push({ product: p, style, bad, good, links });
    });
  }

  // ✅ NEW: 분리 추천 "확인" — 실제로는 같은 상품이라고 판단했을 때 목록에서 영구히 숨김
  const handleDismissSplitSuggestion = async (link) => {
    const url = (link.product_url || '').split('?')[0];
    if (!url) return;
    setDismissedSplitUrls(prev => [...prev, url]);
    const { error } = await supabase.from('dismissed_split_suggestions')
      .upsert([{ product_url: url }], { onConflict: 'product_url' });
    if (error) {
      console.error('분리 추천 확인 저장 실패:', error);
      setDismissedSplitUrls(prev => prev.filter(u => u !== url));
      alert('확인 처리에 실패했어요. (' + error.message + ')');
    }
  };

  // ✅ NEW: 미분류 상품 감지 — 지금 정의된 카테고리(전체 제외) 중 어느 키워드에도 안 걸리는 상품을 찾아냄.
  // 화면 필터와 무관하게 전체 상품(products) 기준으로 검사해서, 새 카테고리가 필요한 상품을 놓치지 않게 함.
  let uncategorizedProducts = [];
  if (isAdmin) {
    const realCategories = allCategories.filter(c => c !== '전체' && c !== '기타');
    uncategorizedProducts = products.filter(p => {
      // ✅ FIX: 판매처 0곳(유령 상품)은 화면에도 안 뜨는 죽은 데이터라 카테고리를 지정할 의미가 없음.
      // products는 upsert 전용이라 이름이 바뀐 옛 행이 남는데, 그게 미분류 목록을 채워서
      // 정작 손봐야 할 상품이 안 보이던 문제 방어.
      if (getLinks(p).length === 0) return false;
      if (dismissedUncategorized.includes(p.product_id)) return false;
      if (categoryOverrides[p.product_id]) return false;
      const matchTitle = p.title || "";
      const matchClean = p.clean_title || "";
      const matchesAny = realCategories.some(cat => {
        const keywords = getCategoryKeywords(cat);
        const excludes = getCategoryExcludes(cat);
        const matched = keywords.some(k => matchTitle.includes(k) || matchClean.includes(k));
        const excluded = excludes.some(k => matchTitle.includes(k) || matchClean.includes(k));
        return matched && !excluded;
      });
      return !matchesAny;
    });
  }

  // ✅ NEW: 미분류 상품 "확인" — 검토 완료 표시, 목록에서 영구히 숨김
  const handleDismissUncategorized = async (productId) => {
    setDismissedUncategorized(prev => [...prev, productId]);
    const { error } = await supabase.from('dismissed_uncategorized').insert([{ product_id: productId }]);
    if (error) {
      console.error('미분류 확인 저장 실패:', error);
      setDismissedUncategorized(prev => prev.filter(id => id !== productId));
      alert('확인 처리에 실패했어요. (' + error.message + ')');
    }
  };  // 상품 하나만 카테고리 수동 지정 (키워드 규칙 등록 없이, 다른 상품엔 영향 없음)
  const handleAssignSingleProduct = async (p, category) => {
    const { error } = await supabase.from('product_category_overrides').upsert([{ product_id: p.product_id, category }], { onConflict: 'product_id' });
    if (error) {
      alert('카테고리 지정에 실패했어요. (' + error.message + ')');
      return;
    }
    setCategoryOverrides(prev => ({ ...prev, [p.product_id]: category }));
    if (uncategorizedProducts.some(u => u.product_id === p.product_id)) {
      handleDismissUncategorized(p.product_id);
    }
    setCategoryPickerProduct(null);
  };

  // ✅ NEW: "카테고리 변경" 모달 열기 — 미분류 상품 배너뿐 아니라 어떤 상품에서도 호출 가능
  const openCategoryPicker = (p) => { setCategoryPickerProduct(p); setSingleProductMode(false); };

  // ✅ NEW: 카테고리 클릭 선택 후, 그 카테고리에서 이 상품을 잡아낼 키워드만 확인/수정해서 저장.
  // 저장된 키워드는 category_keywords 테이블에 쌓이고, 다음부터 같은 단어가 들어간 상품은 자동으로 그 탭에 분류됨.
  const handleAssignToCategory = async (p, category) => {
    const defaultKeyword = cleanTitleStr(p.title) || p.title || '';
    const keyword = window.prompt(`"${category}" 카테고리로 앞으로 자동 분류할 키워드를 확인하세요.\n(비슷한 상품명도 같이 잡고 싶으면 단어를 더 짧게 줄이세요)`, defaultKeyword);
    if (!keyword || !keyword.trim()) return;

    const row = { category, keyword: keyword.trim() };
    const { error } = await supabase.from('category_keywords').insert([row]);
    if (error) {
      alert('카테고리 등록에 실패했어요. (' + error.message + ')');
      return;
    }
    setCustomKeywords(prev => [...prev, row]);
    // 미분류 목록에 있던 상품이면 바로 사라지게
    if (uncategorizedProducts.some(u => u.product_id === p.product_id)) {
      handleDismissUncategorized(p.product_id);
    }
    setCategoryPickerProduct(null);
  };

  // ✅ NEW: "카테고리 만들기" — 아예 새로운 카테고리 탭을 만들고, 이 상품을 잡아낼 키워드로 시작 등록.
  // (새 카테고리 "이름"만은 클릭으로 고를 수 없어서 어쩔 수 없이 직접 입력)
  const handleCreateCategory = async (p) => {
    const newCategory = window.prompt('새 카테고리 이름을 입력하세요. (예: 원마일웨어)', '');
    if (!newCategory || !newCategory.trim()) return;
    if (allCategories.includes(newCategory.trim())) {
      alert('이미 있는 카테고리예요. 목록에서 클릭해서 선택해주세요.');
      return;
    }
    const defaultKeyword = cleanTitleStr(p.title) || p.title || '';
    const keyword = window.prompt(`"${newCategory.trim()}" 카테고리에서 앞으로 자동 분류할 키워드를 정하세요.\n(비슷한 상품명도 같이 잡고 싶으면 단어를 더 짧게 줄이세요)`, defaultKeyword);
    if (!keyword || !keyword.trim()) return;

    const row = { category: newCategory.trim(), keyword: keyword.trim() };
    const { error } = await supabase.from('category_keywords').insert([row]);
    if (error) {
      alert('카테고리 생성에 실패했어요. (' + error.message + ')');
      return;
    }
    setCustomKeywords(prev => [...prev, row]);
    if (uncategorizedProducts.some(u => u.product_id === p.product_id)) {
      handleDismissUncategorized(p.product_id);
    }
    setCategoryPickerProduct(null);
  };

  // ✅ NEW: 레퍼런스 스타일 헤더(데스크톱 3단 + 모바일 드로어)에서 공용으로 쓰는 탭 목록/라벨
  const TAB_LABELS = { NEWARRIVAL: '신상', FEED: '피드', RANKING: '랭킹', SALE: '세일', DAILY: '당일', BRAND: '브랜드', MY: 'MY ♥' };
  const navTabs = user ? ['NEWARRIVAL', 'RANKING', 'FEED', 'SALE', 'DAILY', 'BRAND', 'MY'] : ['NEWARRIVAL', 'RANKING', 'FEED', 'SALE', 'DAILY', 'BRAND'];

  return (
    <div className="App" style={{ background: isAdmin ? '#f8f9fa' : '#fff', minHeight: '100vh', padding: isAdmin ? '10px' : '0' }}>
      {/* ✅ NEW: 레퍼런스(부티크 편집샵) 스타일 디자인 시스템 — 타이포/헤더/내비/상품그리드/푸터 */}
      <style>{`
        .App, .App input, .App button { font-family: 'Hanken Grotesk', 'Nanum Gothic', -apple-system, sans-serif; }

        /* ✅ FIX: 가로 스크롤 방지를 .App(div)이 아니라 html/body에서 처리.
           .App에 overflow-x:hidden을 직접 걸면 이 div가 스크롤 컨테이너로 취급되면서
           .lb-sticky-header의 position:sticky 기준점이 뷰포트가 아니라 .App 내부로 바뀌어버려서
           스크롤해도 검색창/헤더가 고정되지 않던 문제의 원인이었음. */
        html { overflow-x: hidden; }
        body { margin: 0; }
        /* ✅ FIX: overflow-x:hidden을 html·body 둘 다에 걸면, html이 non-visible 값을 갖는 순간
           "body→viewport 오버플로우 전파 규칙"이 꺼지면서 body가 다시 독립된(그리고 자기 콘텐츠만큼
           늘어나서 절대 안 움직이는) 스크롤 컨테이너 취급을 받고, 그 안의 position:sticky는
           진짜 뷰포트가 아니라 이 움직이지 않는 body 기준으로 계산돼서 스크롤해도 안 붙어있던 것.
           html에만 걸면 이 문제가 없음(루트 요소라 별도 중첩 컨텍스트가 안 생김). */
        /* ✅ FIX: width:100% + padding/border 조합인 요소가 컨테이너보다 넓어져서
           페이지 전체가 옆으로 밀리던 문제(어드민 검색창 등)의 근본 원인 — 전역으로 한 번에 방지 */
        .App, .App *, .App *::before, .App *::after { box-sizing: border-box; }

        /* ── 데스크톱/모바일 헤더 전환 ── */
        .lb-desktop-row { display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; }
        .lb-mobile-row { display: none; }
        .lb-mobile-tabbar { display: none !important; }   /* LABEL_HEADER_MEDIA */

        /* ── 상단 텍스트 내비 (탭) ── */
        .lb-tab { position: relative; background: none; border: none; cursor: pointer; padding: 6px 2px; margin: 0 11px; font-size: 12.5px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: #999; white-space: nowrap; transition: color .15s ease; }
        .lb-tab:first-child { margin-left: 0; }
        .lb-tab::after { content: ''; position: absolute; left: 2px; right: 2px; bottom: 0; height: 1px; background: #111; transform: scaleX(0); transition: transform .2s ease; }
        .lb-tab.is-active { color: #111; }
        .lb-tab.is-active::after { transform: scaleX(1); }
        .lb-tab.is-accent.is-active { color: #c0392b; }
        .lb-tab.is-accent.is-active::after { background: #c0392b; }

        /* ── 아이콘 버튼 (검색/계정) ── */
        .lb-icon-btn { background: none; border: none; cursor: pointer; padding: 6px; display: inline-flex; align-items: center; justify-content: center; color: #111; }

        /* ── 카테고리 필터 (얇은 텍스트 링크) ── */
        .lb-filter-link { background: none; border: none; cursor: pointer; padding: 4px 0; font-size: 12px; font-weight: 500; letter-spacing: 0.02em; color: #aaa; border-bottom: 1px solid transparent; transition: color .15s ease, border-color .15s ease; }
        .lb-filter-link.is-active { color: #111; border-bottom: 1px solid #111; font-weight: 700; }

        /* ── 정렬 링크 ── */
        .lb-sort-link { background: none; border: none; cursor: pointer; font-size: 11.5px; letter-spacing: 0.03em; color: #bbb; padding: 0; }
        .lb-sort-link.is-active { color: #111; font-weight: 700; text-decoration: underline; text-underline-offset: 3px; }

        /* ── 상품 그리드 ── */
        .lb-product-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(230px, 1fr)); gap: 34px 22px; }
        /* ✅ FIX: grid item 기본값(min-width: auto) 때문에 이미지가 큰 카드가 자기 grid 칸보다
           넓게 밀려나면서 옆 카드를 짓누르던 문제 (모바일에서 카드 하나가 화면을 거의 다 채우고
           옆 카드는 얇은 조각만 보이던 증상) — CSS Grid의 잘 알려진 함정, min-width: 0으로 해결 */
        .lb-card { cursor: pointer; min-width: 0; }
        .lb-card-thumb { position: relative; overflow: hidden; background: #f4f4f4; aspect-ratio: 3 / 4; }
        .lb-card-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; transition: transform .5s cubic-bezier(.2,.8,.2,1); }
        .lb-card:hover .lb-card-thumb img { transform: scale(1.045); }
        .lb-card-badge { position: absolute; top: 10px; left: 10px; background: #111; color: #fff; font-size: 10px; font-weight: 700; letter-spacing: 0.03em; padding: 4px 8px; z-index: 2; }
        .lb-card-badge.is-discount { background: #c0392b; }
        .lb-card-heart { position: absolute; top: 8px; right: 8px; width: 30px; height: 30px; border-radius: 50%; background: rgba(255,255,255,.92); display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 14px; z-index: 2; }
        .lb-card-brand { display: block; font-size: 10.5px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: #999; margin-bottom: 6px; }
        .lb-card-title { font-size: 13px; font-weight: 600; color: #111; letter-spacing: 0.01em; line-height: 1.4; margin: 0 0 6px 0; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
        .lb-card-meta { font-size: 11px; color: #999; letter-spacing: 0.01em; }

        /* ── 푸터 ── */
        .lb-footer-link { color: #666; text-decoration: none; font-size: 12px; letter-spacing: 0.02em; }
        .lb-footer-link:hover { color: #111; text-decoration: underline; }

        @media (max-width: 860px) {
          .lb-product-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 10px 12px !important; }
          .lb-desktop-row { display: none !important; }
          .lb-mobile-row { display: flex !important; }
          .lb-mobile-tabbar { display: flex !important; }
          .lb-card-title { font-size: 12px; }

          /* ✅ 모바일 탭바(피드~MY): 스크롤 없이 한 줄에 다 들어가도록 데스크톱보다 촘촘하게 */
          .lb-mobile-tabbar .lb-tab { margin: 0 4px; padding: 6px 1px; font-size: 12px; }
          .lb-mobile-tabbar .lb-tab:first-child { margin-left: 0; }
          .lb-mobile-tabbar .lb-tab:last-child { margin-right: 0; }

          /* ✅ 카테고리 필터: 모바일에서 5줄로 줄바꿈되던 걸 한 줄 + 가로 스크롤로 변경 */
          .lb-category-scroll { flex-wrap: nowrap !important; overflow-x: auto !important; -webkit-overflow-scrolling: touch; justify-content: flex-start !important; gap: 18px !important; padding-left: 20px !important; padding-right: 20px !important; }
          .lb-category-scroll .lb-filter-link { flex-shrink: 0; white-space: nowrap; }

          /* ✅ 어드민 그리드뷰: 모바일에서 2열로 찌그러지면 버튼/스토어목록이 안 보여서 1열로 넓게 */
          .lb-admin-grid { grid-template-columns: 1fr !important; gap: 14px !important; }

          /* ✅ 어드민 테이블뷰: 모바일에서만 가로스크롤 안내 문구 노출 */
          .lb-table-mobile-hint { display: flex !important; }
        }
      `}</style>

      {/* ✅ NEW: 헤더 + 검색/정렬 + 카테고리를 하나로 묶어서 스크롤 시 상단 고정 (4번) */}
      <div className="lb-sticky-header" style={{ position: 'sticky', top: 0, zIndex: 50, background: isAdmin ? '#f8f9fa' : '#fff', borderBottom: isAdmin ? 'none' : '1px solid #f1f1f1' }}>
        <header style={isAdmin ? { background: '#fff', padding: '15px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', marginBottom: '20px', display: 'flex', flexDirection: 'column', width: '100%' } : { padding: 0, display: 'flex', flexDirection: 'column', width: '100%' }}>
          {isAdmin ? (
            /* ── 어드민 헤더 (모바일 대응: 로고+액션 1줄 / 탭은 가로 스크롤 2줄로 분리해서 겹침·찌그러짐 방지) ── */
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                <div className="logo lb-logo" onClick={() => {setView('NEWARRIVAL'); setIsAdmin(false);}} style={{cursor: 'pointer', color: '#000', fontWeight: '900', fontSize: '20px', letterSpacing: '-1px', whiteSpace: 'nowrap'}}>
                  LABEL <span style={{fontSize:'12px', color:'#d32f2f', marginLeft:'5px'}}>ADMIN</span>
                </div>
                <div className="actions" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                  {user && (
                    <button
                      onClick={() => { if (window.confirm('로그아웃 하시겠어요?')) signOutUser(); }}
                      title={`${user.user_metadata?.name || user.user_metadata?.nickname || user.email || '회원'}님`}
                      style={{ background: '#f1f3f5', border: 'none', borderRadius: '50%', width: '30px', height: '30px', fontSize: '14px', cursor: 'pointer', display:'flex', alignItems:'center', justifyContent:'center', flexShrink: 0 }}
                    >👤</button>
                  )}
                  <button onClick={toggleAdminMode} style={{background: '#111', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', cursor:'pointer', whiteSpace: 'nowrap', flexShrink: 0}}>일반 화면</button>
                </div>
              </div>
              <nav style={{ display: 'flex', gap: '6px', alignItems: 'center', overflowX: 'auto', WebkitOverflowScrolling: 'touch', paddingBottom: '2px' }}>
                {navTabs.map((v) => (
                   <button
                      key={v}
                      style={{
                        color: view === v ? '#fff' : '#999',
                        backgroundColor: view === v ? (v === 'SALE' ? '#e53935' : v === 'DAILY' ? '#ff9800' : '#111') : 'transparent',
                        padding: '6px 10px', borderRadius: '20px', fontWeight: 'bold', fontSize: '13px',
                        border: 'none', cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0
                      }}
                      onClick={() => setView(v)}
                    >
                      {TAB_LABELS[v]}
                    </button>
                ))}
              </nav>
            </div>
          ) : (
            <>
              {/* ── 데스크톱 헤더: 좌측 텍스트 내비 · 중앙 로고 · 우측 아이콘 (레퍼런스 3단 구성) ── */}
              <div className="lb-desktop-row" style={{ padding: '22px 32px 16px' }}>
                <nav style={{ display: 'flex', alignItems: 'center' }}>
                  {navTabs.map((v) => (
                    <button
                      key={v}
                      className={`lb-tab ${view === v ? 'is-active' : ''} ${(v === 'SALE' || v === 'DAILY') ? 'is-accent' : ''}`}
                      onClick={() => setView(v)}
                    >
                      {TAB_LABELS[v]}
                    </button>
                  ))}
                </nav>

                <div className="logo lb-logo" onClick={() => setView('NEWARRIVAL')} style={{ cursor: 'pointer', textAlign: 'center', fontWeight: 800, fontSize: '25px', letterSpacing: '0.14em', color: '#111' }}>
                  LABEL
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '16px' }}>
                  {/* ✅ 내가 소유한 당일 슬롯이 있으면 관리 버튼 노출 */}
                  {user && dailySlots.some(s => s.owner_user_id === user.id && !s.is_banned) && (
                    <button
                      onClick={() => {
                        const mySlot = dailySlots.find(s => s.owner_user_id === user.id && !s.is_banned);
                        if (mySlot) setSlotSwapForm({ title: mySlot.product_title || '', image: mySlot.product_image || '', url: mySlot.product_url || '', price: mySlot.price || '' });
                        setShowSlotManageModal(true);
                      }}
                      style={{ background: 'none', border: '1px solid #ddd', borderRadius: '20px', padding: '5px 12px', fontSize: '11px', fontWeight: 700, color: '#e65100', cursor: 'pointer', whiteSpace: 'nowrap' }}
                    >📦 내 슬롯 관리</button>
                  )}
                  <button className="lb-icon-btn" title="검색" onClick={() => searchInputRef.current?.focus()}>
                    <svg width="18" height="18" viewBox="0 0 22 22" fill="none"><circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="1.4"/><line x1="14.2" y1="14.2" x2="20" y2="20" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>
                  </button>
                  {user ? (
                    <button className="lb-icon-btn" title={`${user.user_metadata?.name || user.user_metadata?.nickname || '회원'}님`} onClick={() => { if (window.confirm('로그아웃 하시겠어요?')) signOutUser(); }}>
                      <svg width="18" height="18" viewBox="0 0 22 22" fill="none"><circle cx="11" cy="7.5" r="4" stroke="currentColor" strokeWidth="1.4"/><path d="M3 20c1.2-4 4.4-6 8-6s6.8 2 8 6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>
                    </button>
                  ) : (
                    <button onClick={signInWithKakao} style={{ background: 'none', border: 'none', fontSize: '11.5px', fontWeight: 700, letterSpacing: '0.05em', color: '#111', cursor: 'pointer' }}>LOGIN</button>
                  )}
                  {/* 어드민 진입(숨김 탭 영역) — 시각적으로는 안 보이지만 클릭은 넉넉하게 잡히도록 */}
                  {user && <div onClick={toggleAdminMode} style={{ width: '34px', height: '34px', cursor: 'default', background: 'transparent', flexShrink: 0 }} />}
                </div>
              </div>

              {/* ── 모바일 헤더: 중앙 로고 · 우측 아이콘 (햄버거 없이 바로 누르도록) ── */}
              <div className="lb-mobile-row" style={{ padding: '14px 16px', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="logo lb-logo" onClick={() => setView('NEWARRIVAL')} style={{ cursor: 'pointer', fontWeight: 800, fontSize: '19px', letterSpacing: '0.1em', color: '#111' }}>LABEL</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  {user && dailySlots.some(s => s.owner_user_id === user.id && !s.is_banned) && (
                    <button
                      onClick={() => {
                        const mySlot = dailySlots.find(s => s.owner_user_id === user.id && !s.is_banned);
                        if (mySlot) setSlotSwapForm({ title: mySlot.product_title || '', image: mySlot.product_image || '', url: mySlot.product_url || '', price: mySlot.price || '' });
                        setShowSlotManageModal(true);
                      }}
                      className="lb-icon-btn" title="내 슬롯 관리" aria-label="내 슬롯 관리"
                    >📦</button>
                  )}
                  <button className="lb-icon-btn" onClick={() => searchInputRef.current?.focus()} aria-label="검색">
                    <svg width="18" height="18" viewBox="0 0 22 22" fill="none"><circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="1.4"/><line x1="14.2" y1="14.2" x2="20" y2="20" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>
                  </button>
                  {user ? (
                    <button className="lb-icon-btn" title={`${user.user_metadata?.name || user.user_metadata?.nickname || '회원'}님`} onClick={() => { if (window.confirm('로그아웃 하시겠어요?')) signOutUser(); }} aria-label="로그아웃">
                      <svg width="18" height="18" viewBox="0 0 22 22" fill="none"><circle cx="11" cy="7.5" r="4" stroke="currentColor" strokeWidth="1.4"/><path d="M3 20c1.2-4 4.4-6 8-6s6.8 2 8 6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>
                    </button>
                  ) : (
                    <button onClick={signInWithKakao} style={{ background: 'none', border: 'none', fontSize: '11.5px', fontWeight: 700, letterSpacing: '0.05em', color: '#111', cursor: 'pointer' }}>LOGIN</button>
                  )}
                  {/* 어드민 진입(숨김 탭 영역) — 데스크톱과 동일하게 시각적으로 드러내지 않음 */}
                  {user && <div onClick={toggleAdminMode} style={{ width: '30px', height: '30px', cursor: 'default', background: 'transparent', flexShrink: 0 }} />}
                </div>
              </div>

              {/* ✅ NEW: 햄버거 안에만 숨어있던 탭(피드/랭킹/세일/당일/브랜드/MY)을 검색창 위에 항상 보이게 노출. lb-sticky-header 안이라 스크롤해도 같이 고정됨 */}
              <nav className="lb-mobile-tabbar" style={{ padding: '0 12px 12px', display: 'flex', justifyContent: 'space-between', overflowX: 'auto', WebkitOverflowScrolling: 'touch', borderTop: '1px solid #f4f4f4', paddingTop: '10px' }}>
                {navTabs.map((v) => (
                  <button
                    key={v}
                    className={`lb-tab ${view === v ? 'is-active' : ''} ${(v === 'SALE' || v === 'DAILY') ? 'is-accent' : ''}`}
                    style={{ flexShrink: 0 }}
                    onClick={() => setView(v)}
                  >
                    {TAB_LABELS[v]}
                  </button>
                ))}
              </nav>
            </>
          )}


          {isAdmin && (
            <div style={{ marginTop: '15px', display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
                <input 
                   type="text" 
                   placeholder="도매택이나 상품명을 검색하세요..." 
                   value={adminSearch}
                   onChange={(e) => setAdminSearch(e.target.value)}
                   style={{ width: '100%', maxWidth: '500px', padding: '12px 15px', borderRadius: '8px', border: '2px solid #d32f2f', outline: 'none', fontWeight: 'bold', boxSizing: 'border-box' }}
                />
                <button 
                  onClick={() => setAdminLayout(prev => prev === 'GRID' ? 'TABLE' : 'GRID')}
                  style={{ padding: '12px 15px', background: '#111', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', whiteSpace: 'nowrap' }}
                >
                  {adminLayout === 'GRID' ? '📄 리스트 뷰' : '🔲 그리드 뷰'}
                </button>
                {/* ✅ NEW: 그로브(내 스토어)만 모아보기 토글 */}
                <button
                  onClick={() => setShowMyStoreOnly(prev => !prev)}
                  style={{ padding: '12px 15px', background: showMyStoreOnly ? '#d32f2f' : '#111', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', whiteSpace: 'nowrap' }}
                >
                  {showMyStoreOnly ? '🏠 그로브만 보는 중' : '🏠 그로브만 모아보기'}
                </button>
                {/* ✅ NEW: 당일 슬롯 발급/관리 패널 열기 */}
                <button
                  onClick={() => setShowAdminSlotPanel(true)}
                  style={{ padding: '12px 15px', background: '#ff9800', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', whiteSpace: 'nowrap' }}
                >
                  📦 당일 슬롯 관리
                </button>
            </div>
          )}
        </header>

        {/* ✅ 소비자용 검색바 + 정렬 옵션 (당일 탭에서는 적용 대상이 없어서 숨김) */}
        {!isAdmin && view !== 'DAILY' && (
          <div style={{ padding: '2px 24px 16px', display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
            <input
              ref={searchInputRef}
              type="text"
              placeholder="브랜드나 상품명을 검색해보세요"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ flex: '1 1 240px', maxWidth: '360px', padding: '7px 2px', border: 'none', borderBottom: '1px solid #ddd', outline: 'none', fontSize: '13px', background: 'transparent' }}
            />
            {view !== 'RANKING' && (
              <div style={{ display: 'flex', gap: '16px' }}>
                <button className={`lb-sort-link ${sortBy === 'latest' ? 'is-active' : ''}`} onClick={() => setSortBy('latest')}>추천순</button>
                <button className={`lb-sort-link ${sortBy === 'lowprice' ? 'is-active' : ''}`} onClick={() => setSortBy('lowprice')}>최저가순</button>
              </div>
            )}
          </div>
        )}

      {/* ✅ FIX: 카테고리 필터를 스티키 헤더 '안'으로 옮겨서 스크롤해도 상단 고정되게 함
          (당일 탭에서는 숨김) */}
      {view !== 'DAILY' && (
        <div className="filter-bar lb-category-scroll" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px 20px', justifyContent: 'center', padding: '0 20px 12px', borderTop: '1px solid #f4f4f4' }}>
          {allCategories.map(c => (
            <button
              key={c}
              className={`lb-filter-link ${category === c ? 'is-active' : ''}`}
              onClick={() => setCategory(c)}
            >
              {c}
            </button>
          ))}
        </div>
      )}
      </div>

      {/* ✅ NEW(260826): 첫 화면 한 줄 소개 — 홍보 링크로 들어온 사람의 이탈 방지용 */}
      {!isAdmin && <Hero />}

      {/* ✅ NEW: 일별 방문자/회원 요약 위젯 — 어드민 화면 최상단 */}
      {isAdmin && <DailyVisitorSummary />}

      {/* ✅ NEW(2026-08-22): 카테고리 노출 순서 관리 — 시즌마다 바뀌므로 배포 없이 조정 */}
      {isAdmin && (
        <div style={{ margin: '10px auto', maxWidth: '900px', padding: '0 12px' }}>
          <button
            onClick={() => setCatOrderDraft(prev => prev ? null : allCategories.filter(c => c !== '전체' && c !== '기타'))}
            style={{ padding: '10px 14px', background: catOrderDraft ? '#d32f2f' : '#111', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}
          >
            {catOrderDraft ? '✕ 카테고리 순서 닫기' : '↕ 카테고리 순서 관리'}
          </button>

          {catOrderDraft && (
            <div style={{ marginTop: '10px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '12px', background: '#fafafa' }}>
              <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', lineHeight: 1.5 }}>
                ▲▼로 순서를 바꾼 뒤 <b>순서 저장</b>을 누르세요.<br />
                '전체'는 항상 맨 앞, '기타'는 항상 맨 뒤에 고정됩니다.
              </div>
              <div style={{ maxHeight: '420px', overflowY: 'auto', background: '#fff', borderRadius: '6px', border: '1px solid #eee' }}>
                {catOrderDraft.map((c, i) => (
                  <div key={c} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', borderBottom: '1px solid #f4f4f4' }}>
                    <span style={{ width: '26px', color: '#aaa', fontSize: '12px' }}>{i + 1}</span>
                    <span style={{ flex: 1, fontWeight: 'bold', fontSize: '14px' }}>{c}</span>
                    <button
                      onClick={() => moveCategory(i, -1)}
                      disabled={i === 0}
                      style={{ padding: '6px 12px', border: '1px solid #ddd', background: i === 0 ? '#f5f5f5' : '#fff', color: i === 0 ? '#ccc' : '#333', borderRadius: '4px', cursor: i === 0 ? 'default' : 'pointer' }}
                    >▲</button>
                    <button
                      onClick={() => moveCategory(i, 1)}
                      disabled={i === catOrderDraft.length - 1}
                      style={{ padding: '6px 12px', border: '1px solid #ddd', background: i === catOrderDraft.length - 1 ? '#f5f5f5' : '#fff', color: i === catOrderDraft.length - 1 ? '#ccc' : '#333', borderRadius: '4px', cursor: i === catOrderDraft.length - 1 ? 'default' : 'pointer' }}
                    >▼</button>
                  </div>
                ))}
              </div>
              <button
                onClick={() => saveCategoryOrder(catOrderDraft)}
                disabled={catOrderSaving}
                style={{ marginTop: '10px', width: '100%', padding: '12px', background: catOrderSaving ? '#999' : '#2e7d32', color: '#fff', border: 'none', borderRadius: '8px', cursor: catOrderSaving ? 'default' : 'pointer', fontWeight: 'bold', fontSize: '14px' }}
              >
                {catOrderSaving ? '저장 중...' : '💾 순서 저장'}
              </button>
            </div>
          )}
        </div>
      )}

      {/* BRAND 탭 전용 B2B 쇼룸 뷰 (스티키 영역 밖으로 이동 — 프로모 배너까지 고정될 필요는 없어서) */}
      {view === 'BRAND' && !isAdmin && (
        <div style={{ padding: '20px 20px 0 20px' }}>
          <div style={{ background: '#111', color: '#fff', padding: '40px 20px', borderRadius: '12px', marginBottom: '30px', textAlign: 'center' }}>
              <h2 style={{ fontSize: '28px', margin: '0 0 10px 0' }}>LABEL PREMIERE</h2>
              <p style={{ color: '#aaa', margin: '0 0 20px 0', fontSize: '15px' }}>동대문 상위 1% 도매 브랜드 공식 입점관</p>
              <button style={{ background: '#e53935', color: '#fff', padding: '12px 24px', borderRadius: '30px', fontWeight: 'bold', border: 'none', cursor: 'pointer', fontSize: '15px', boxShadow: '0 4px 10px rgba(229,57,53,0.3)' }} onClick={() => setShowBizGuideModal(true)}>
                  ✨ 지금은 무료로 우리 브랜드 입점하기
              </button>
          </div>        </div>
      )}

      {/* 새 브랜드별 보기 - 어드민 화면에서도 노출 (프로모 배너는 위에서 손님 전용으로 유지) */}
      {view === 'BRAND' && (
        <div style={{ padding: isAdmin ? '20px 20px 20px 20px' : '0 20px 20px 20px' }}>
          
          {/* 🔥 [실시간 개수순 자동 정제] 하드코딩 리스트 대신 sortedBrands 맵핑으로 변경 */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: '10px', marginBottom: '30px' }}>
            {sortedBrands.map(b => {
              const count = products.filter(p => p.brand_name === b).length;
              return (
                <div 
                  key={b} 
                  onClick={() => setSelectedBrand(b)} 
                  style={{ 
                    background: selectedBrand === b ? '#111' : '#f9f9f9', 
                    color: selectedBrand === b ? '#fff' : '#111', 
                    padding: '15px 10px', borderRadius: '12px', textAlign: 'center', cursor: 'pointer', 
                    border: selectedBrand === b ? 'none' : '1px solid #eee', transition: '0.2s', fontWeight: 'bold', fontSize: '14px' 
                  }}
                >
                  {b} <span style={{fontSize: '11px', color: selectedBrand === b ? '#ffeb3b' : '#888', marginLeft: '2px'}}>({count})</span>
                </div>
              );
            })}
          </div>
          
          {selectedBrand && (
             <h3 style={{ marginTop: '20px', borderBottom: '2px solid #111', paddingBottom: '10px', marginBottom: '20px', fontSize: '20px' }}>{selectedBrand} 👑</h3>
          )}
        </div>
      )}

      {/* ✅ NEW: '당일' 탭 — 소매상이 슬롯을 임대해 진짜 재고 보유 상품을 올리는 공간 */}
      {view === 'DAILY' && !isAdmin && (
        <div style={{ padding: '20px' }}>
          <div style={{ background: '#fff3e0', border: '1px solid #ffcc80', borderRadius: '10px', padding: '14px 16px', marginBottom: '20px', fontSize: '13px', color: '#795548' }}>
            📦 여기 뜨는 상품들은 소매상이 <b>실제 재고를 보유</b>하고 있다고 직접 등록한 상품이에요. 재고 없이 올라온 것 같으면 카드 하단의 신고 버튼을 눌러주세요.
          </div>
          {/* ===== LABEL_BIZ_UNIFY: 소매점용 당일발송 입점 배너 ===== */}
          <div style={{ background: '#111', color: '#fff', padding: '40px 20px', borderRadius: '12px', marginBottom: '30px', textAlign: 'center' }}>
              <h2 style={{ fontSize: '28px', margin: '0 0 10px 0' }}>당일발송</h2>
              <p style={{ color: '#aaa', margin: '0 0 20px 0', fontSize: '15px' }}>재고 보유 소매점 공식 입점관</p>
              <button onClick={() => openApply('daily', 'guide')} style={{ background: '#ff9800', color: '#fff', padding: '12px 24px', borderRadius: '30px', fontWeight: 'bold', border: 'none', cursor: 'pointer', fontSize: '15px', boxShadow: '0 4px 10px rgba(255,152,0,0.3)' }}>
                  ✨ 지금은 무료로 우리 매장 입점하기
              </button>
              <p style={{ color: '#888', fontSize: '13px', margin: '16px 0 0 0', lineHeight: 1.6 }}>
                상품은 직접 등록하고 매일 교체할 수 있어요
              </p>
          </div>
          <main className="product-grid lb-product-grid">
            {dailySlots.filter(s => s.is_active && !s.is_banned && s.product_url).map(slot => (
              <div key={slot.id} style={{ border: '1px solid #ffe0b2', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.03)' }}>
                <div style={{ position: 'relative' }}>
                  <div style={{ position: 'absolute', top: '10px', left: '10px', background: '#ff9800', color: '#fff', fontWeight: '900', fontSize: '11px', padding: '4px 10px', borderRadius: '20px', zIndex: 2 }}>📦 당일</div>
                  {slot.product_url ? (
                    <a href={slot.product_url} target="_blank" rel="noreferrer">
                      <img src={slot.product_image} alt={slot.product_title} loading="lazy" decoding="async" style={{ width: '100%', aspectRatio: '3 / 4', objectFit: 'cover', display: 'block' }} />
                    </a>
                  ) : (
                    <img src={slot.product_image} alt={slot.product_title} loading="lazy" decoding="async" style={{ width: '100%', aspectRatio: '3 / 4', objectFit: 'cover', display: 'block' }} />
                  )}
                </div>
                {/* ===== LABEL_DAILY_CARD: 카드 본문 전체를 눌러도 상품으로 이동 ===== */}
                <div style={{ padding: '12px', cursor: 'pointer' }} onClick={(e) => {
                  if (e.target.closest && e.target.closest('button')) return;  // 신고 버튼은 통과
                  if (!slot.product_url) return;
                  logPromoEvent('tab_click', slot, null);  // LABEL_SLOT_STATS
                  let dest = slot.product_url;
                  try {
                    const u = new URL(slot.product_url);
                    u.searchParams.set('utm_source', 'label');
                    u.searchParams.set('utm_medium', 'daily_tab');
                    u.searchParams.set('utm_campaign', 'slot_' + slot.id);
                    dest = u.toString();
                  } catch (err) { /* 주소가 깨져 있으면 원본 그대로 */ }
                  window.open(dest, '_blank', 'noopener');
                }}>
                  <p style={{ margin: '0 0 6px 0', fontWeight: 'bold', fontSize: '14px' }}>{slot.product_title || '상품명 미등록'}</p>
                  {slot.price && <p style={{ margin: '0 0 8px 0', fontWeight: '900', fontSize: '15px' }}>{slot.price.toLocaleString()}원</p>}
                  <button onClick={() => handleReportSlot(slot)} style={{ width: '100%', background: 'transparent', border: '1px solid #ddd', color: '#999', fontSize: '11px', padding: '6px', borderRadius: '6px', cursor: 'pointer' }}>
                    🚩 당일아님 신고
                  </button>
                </div>
              </div>
            ))}
          </main>
          {/* ===== LABEL_DAILY_BIZ: 소매점용 슬롯 입점 안내 ===== */}
          <div style={{ marginTop: '30px', background: '#fafafa', border: '1px solid #eee', borderRadius: '12px', padding: '20px' }}>
            <div style={{ fontWeight: '900', fontSize: '15px', marginBottom: '10px', color: '#111' }}>📦 당일 슬롯 입점 문의</div>
            <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#666', lineHeight: 1.6 }}>
              재고를 보유한 소매점이라면 이 자리에 상품을 직접 올리고 매일 교체할 수 있어요.
            </p>
            <p style={{ margin: '0 0 14px 0', fontSize: '12px', color: '#999', lineHeight: 1.6 }}>
              재고 없이 올라온 상품은 신고가 3건 쌓이면 자동으로 차단됩니다.
            </p>
            <a href="tel:01039299229" style={{ display: 'inline-block', background: '#111', color: '#fff', padding: '11px 20px', borderRadius: '8px', fontSize: '13px', fontWeight: 'bold', textDecoration: 'none' }}>
              010-3929-9229 문의하기
            </a>
          </div>
          {dailySlots.filter(s => s.is_active && !s.is_banned && s.product_url).length === 0 && (
            <div style={{ textAlign: 'center', padding: '80px 20px', color: '#999' }}>
              <div style={{ fontSize: '40px', marginBottom: '10px' }}>📦</div>
              <p style={{ fontSize: '15px', fontWeight: 'bold' }}>아직 등록된 당일 슬롯이 없어요</p>
            </div>
          )}
        </div>
      )}

      {/* ✅ NEW: 병합 추천 배너 (도매택 일치 + 상품명 유사 + 가격 비슷한 상품군 자동 감지) */}
            {isAdmin && (
        <button onClick={() => setShowMergeSuggestionsPanel(prev => !prev)} style={{ margin: '0 10px 10px', padding: '8px 14px', background: showMergeSuggestionsPanel ? '#795548' : '#fff8e1', color: showMergeSuggestionsPanel ? '#fff' : '#795548', border: '1px solid #ffe082', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}>
          🔀 병합 추천 {mergeSuggestions.length}건 {showMergeSuggestionsPanel ? '숨기기 ▲' : '보기 ▼'}
        </button>
      )}
      {isAdmin && showMergeSuggestionsPanel && (
        <div style={{ margin: '0 10px 15px', padding: '12px 16px', background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '8px' }}>
          <div style={{ fontWeight: 'bold', fontSize: '13px', color: '#795548', marginBottom: '8px' }}>
            🔀 병합 추천 — 도매택 일치 + 상품명 유사 + 가격 비슷한 상품군 {mergeSuggestions.length}건 발견
          </div>
          {mergeSuggestions.map(({ key, items: group }) => {
            // ✅ NEW: 이 그룹에서 사용자가 선택한 '기준 상품' 인덱스 (기본 0=첫번째)
            // ✅ NEW(2026-09-07): 기본 기준을 찜이 가장 많은 상품으로. 사람이 카드를 눌러 바꿀 수 있다.
            const favIdx = group.reduce((best, p, i) => ((favCounts[p.product_id] || 0) > (favCounts[group[best].product_id] || 0) ? i : best), 0);
            const baseIdx = mergeBaseKeys[key] ?? favIdx;
            const baseP = group[baseIdx] || group[0];
            // 선택된 기준을 맨 앞으로 재정렬해서 병합 함수에 넘김 (함수는 group[0]을 기준으로 씀)
            const reordered = [baseP, ...group.filter((_, i) => i !== baseIdx)];
            return (
            <div key={key} style={{ display: 'flex', flexDirection: 'column', padding: '8px 10px', background: '#fff', borderRadius: '6px', marginBottom: '6px', gap: '8px' }}>
              {/* 윗줄: 요약 정보 + 액션 버튼 */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
                <div style={{ fontSize: '12px', color: '#444' }}>
                  <b>{group[0].brand_name}</b> · {getMinPrice(group[0]).toLocaleString()}원 —{' '}
                  {group.map((p, i) => (
                    <span key={p.id}>{i > 0 && ' / '}{i === baseIdx ? <b style={{ color: '#2e7d32' }}>{cleanTitleStr(p.title)}</b> : cleanTitleStr(p.title)}</span>
                  ))}
                  {' '}({group.length}개 그룹)
                </div>
                <div style={{ display: 'flex', gap: '6px' }}>
                  <button onClick={() => handleMergeSuggestionGroup(reordered)} style={{ background: '#2e7d32', color: '#fff', border: 'none', padding: '5px 12px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                    🔗 "{cleanTitleStr(baseP.title)}" 기준으로 합치기
                  </button>
                  <button onClick={() => handleDismissSuggestion(key)} style={{ background: '#eee', color: '#555', border: '1px solid #ccc', padding: '5px 12px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                    ✔ 확인
                  </button>
                </div>
              </div>
              {/* ✅ NEW: 상품 미리보기 — 카드를 '클릭하면 그게 기준'이 됨. 🔍로 이미지 확대. */}
              <div style={{ fontSize: '10px', color: '#888', marginBottom: '-2px' }}>👇 어느 상품을 기준으로 합칠지 카드를 눌러 고르세요</div>
              <div style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '4px' }}>
                {group.map((p, i) => (
                  <div
                    key={p.id}
                    onClick={() => setMergeBaseKeys(prev => ({ ...prev, [key]: i }))}
                    style={{ position: 'relative', minWidth: '92px', maxWidth: '92px', textAlign: 'center', border: i === baseIdx ? '2px solid #2e7d32' : '1px solid #e0e0e0', borderRadius: '6px', padding: '4px', background: i === baseIdx ? '#e8f5e9' : '#fafafa', cursor: 'pointer' }}
                  >
                    <SmartImg
                      src={p.image_url}
                      width={200}
                      alt=""
                      loading="lazy"
                      decoding="async"
                      style={{ width: '82px', height: '82px', objectFit: 'cover', borderRadius: '4px' }}
                    />
                    {/* 🔍 확대: 카드 클릭(기준선택)과 겹치지 않게 stopPropagation */}
                    <div
                      onClick={(e) => { e.stopPropagation(); window.open(p.image_url, '_blank'); }}
                      style={{ position: 'absolute', top: '6px', right: '6px', background: 'rgba(0,0,0,0.55)', color: '#fff', borderRadius: '4px', fontSize: '11px', padding: '1px 4px', cursor: 'zoom-in' }}
                    >🔍</div>
                    {/* ✅ NEW: 찜 배지 — 이쪽을 지우면 그 회원들 찜 목록에서 상품이 사라진다 */}
                    {(favCounts[p.product_id] || 0) > 0 && (
                      <div style={{ position: 'absolute', top: '6px', left: '6px', background: '#e91e63', color: '#fff', borderRadius: '4px', fontSize: '10px', fontWeight: 'bold', padding: '1px 5px' }}>
                        ♥{favCounts[p.product_id]}
                      </div>
                    )}
                    <div style={{ fontSize: '10px', color: '#333', marginTop: '3px', lineHeight: '1.2', height: '24px', overflow: 'hidden' }}>
                      {cleanTitleStr(p.title)}
                    </div>
                    <div style={{ fontSize: '10px', color: '#2e7d32', fontWeight: 'bold', marginTop: '2px' }}>
                      판매처 {getLinks(p).length}곳
                    </div>
                    {i === baseIdx && (
                      <div style={{ fontSize: '9px', color: '#2e7d32', fontWeight: 'bold' }}>✓ 기준</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            );
          })}
        </div>
      )}

      {/* ✅ NEW: 분리 추천 배너 — 묶음 스타일명이 판매처 원제목에 없는 케이스 자동 감지 */}
      {isAdmin && (
        <button onClick={() => setShowSplitSuggestionsPanel(prev => !prev)} style={{ margin: '0 10px 10px', padding: '8px 14px', background: showSplitSuggestionsPanel ? '#00695c' : '#e0f2f1', color: showSplitSuggestionsPanel ? '#fff' : '#00695c', border: '1px solid #80cbc4', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}>
          ✂️ 분리 추천 {splitSuggestions.length}건 {showSplitSuggestionsPanel ? '숨기기 ▲' : '보기 ▼'}
        </button>
      )}
      {isAdmin && showSplitSuggestionsPanel && (
        <div style={{ margin: '0 10px 15px', padding: '12px 16px', background: '#e0f2f1', border: '1px solid #80cbc4', borderRadius: '8px' }}>
          <div style={{ fontWeight: 'bold', fontSize: '13px', color: '#00695c', marginBottom: '8px' }}>
            ✂️ 분리 추천 — 묶음 상품명이 판매처 원제목과 다른 상품군 {splitSuggestions.length}건 발견
          </div>
          {splitSuggestions.slice(0, 20).map(({ product: p, style, bad, good, links }) => (
            <div key={p.id} style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '10px', background: '#fff', borderRadius: '6px', marginBottom: '8px' }}>
              {/* 윗줄: 묶음 정보 */}
              <div style={{ fontSize: '12px', color: '#444' }}>
                <b>{p.brand_name} · {cleanTitleStr(p.title)}</b>
                <span style={{ color: '#c62828', fontWeight: 'bold' }}> — 원제목에 "{style}" 없는 판매처 {bad.length}곳</span>
                <span style={{ color: '#999' }}> (전체 {links.length}곳)</span>
              </div>
              {/* 아랫줄: 그룹 전체 판매처 썸네일 — 빨간 테두리=분리 대상 추천, 초록=일치.
                  ✅ 감지가 틀릴 수 있으므로 '모든' 카드에 분리 버튼을 둬서 admin이 직접 판단. */}
              <div style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '4px' }}>
                {links.map(l => {
                  const isBad = bad.some(b => b.id === l.id);
                  return (
                    <div key={l.id} style={{ minWidth: '104px', maxWidth: '104px', textAlign: 'center', border: isBad ? '2px solid #c62828' : '1px solid #a5d6a7', borderRadius: '6px', padding: '4px', background: isBad ? '#ffebee' : '#f1f8e9' }}>
                      <SmartImg src={l.store_image || p.image_url} width={200} alt="" loading="lazy" decoding="async" onClick={() => window.open(l.store_image || p.image_url, '_blank')}
                           style={{ width: '94px', height: '94px', objectFit: 'cover', borderRadius: '4px', cursor: 'zoom-in' }} />
                      <div style={{ fontSize: '10px', fontWeight: 'bold', color: isBad ? '#c62828' : '#2e7d32', marginTop: '3px' }}>
                        {isBad ? '✂️ 다른 상품?' : '✓ 일치'}
                      </div>
                      <div style={{ fontSize: '10px', color: '#555', marginTop: '2px' }}>{l.store_name}</div>
                      <div style={{ fontSize: '9px', color: '#888', marginTop: '2px', lineHeight: '1.25', maxHeight: '48px', overflow: 'hidden' }}>{l.store_title}</div>
                      <div style={{ display: 'flex', gap: '4px', marginTop: '4px', justifyContent: 'center' }}>
                        <button onClick={() => handleSeparateProduct(l, p)} style={{ background: isBad ? '#00695c' : '#eceff1', color: isBad ? '#fff' : '#455a64', border: isBad ? 'none' : '1px solid #cfd8dc', padding: '3px 6px', borderRadius: '4px', fontSize: '10px', fontWeight: 'bold', cursor: 'pointer' }}>✂️분리</button>
                        {isBad && (
                          <button onClick={() => handleDismissSplitSuggestion(l)} style={{ background: '#eee', color: '#555', border: '1px solid #ccc', padding: '3px 6px', borderRadius: '4px', fontSize: '10px', fontWeight: 'bold', cursor: 'pointer' }}>✔확인</button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
          {splitSuggestions.length > 30 && (
            <div style={{ fontSize: '11px', color: '#00695c' }}>… 외 {splitSuggestions.length - 30}건 (처리하면 계속 나타납니다)</div>
          )}
        </div>
      )}

      {/* ✅ NEW: 미분류 상품 알림 배너 (정의된 카테고리 어디에도 안 걸리는 상품 자동 감지) */}
      {isAdmin && dismissedUncategorizedLoaded && customKeywordsLoaded && (
        <button onClick={() => setShowUncategorizedPanel(prev => !prev)} style={{ margin: '0 10px 10px', padding: '8px 14px', background: showUncategorizedPanel ? '#c62828' : '#ffebee', color: showUncategorizedPanel ? '#fff' : '#c62828', border: '1px solid #ef9a9a', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}>
          🚨 미분류 상품 {uncategorizedProducts.length}건 {showUncategorizedPanel ? '숨기기 ▲' : '보기 ▼'}
        </button>
      )}
      {isAdmin && dismissedUncategorizedLoaded && customKeywordsLoaded && showUncategorizedPanel && (
        <div style={{ margin: '0 10px 15px', padding: '12px 16px', background: '#ffebee', border: '1px solid #ef9a9a', borderRadius: '8px' }}>
          <div style={{ fontWeight: 'bold', fontSize: '13px', color: '#c62828', marginBottom: '8px' }}>
            🚨 미분류 상품 — 어떤 카테고리에도 안 걸리는 상품 {uncategorizedProducts.length}건 발견 (새 카테고리/키워드 추가 검토 필요)
          </div>
          {uncategorizedProducts.slice(0, 20).map((p) => {
            const ucLinks = getLinks(p);
            return (
            <div key={p.product_id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 10px', background: '#fff', borderRadius: '6px', marginBottom: '6px', flexWrap: 'wrap' }}>
              {/* ✅ NEW: 썸네일 — 어떤 상품인지 바로 확인 */}
              <SmartImg src={p.image_url} width={150} alt="" loading="lazy" decoding="async"
                   onClick={() => window.open(p.image_url, '_blank')}
                   style={{ width: '52px', height: '52px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #ddd', flexShrink: 0, cursor: 'zoom-in' }} />
              <div style={{ flex: 1, minWidth: '180px', fontSize: '12px', color: '#444' }}>
                <div><b>{p.brand_name}</b> · {cleanTitleStr(p.title)}</div>
                {/* ✅ NEW: 판매처 정보 — 원제목까지 보여서 이름을 어떻게 고칠지 판단 가능 */}
                <div style={{ color: '#888', fontSize: '11px', marginTop: '2px' }}>
                  판매처 {ucLinks.length}곳{ucLinks[0] ? ` · ${ucLinks[0].store_name} — ${ucLinks[0].store_title || ''}` : ''}
                </div>
              </div>
              {/* ✅ NEW: 카테고리 외에 상품 자체를 고치는 버튼들 (어드민 테이블과 동일 기능) */}
              <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                <button onClick={() => openCategoryPicker(p)} style={{ background: '#e3f2fd', color: '#0d47a1', border: 'none', padding: '5px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}>📁 카테고리</button>
                <button onClick={() => handleCreateCategory(p)} style={{ background: '#e8f5e9', color: '#2e7d32', border: '1px solid #a5d6a7', padding: '5px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}>➕ 새 카테고리</button>
                <button onClick={() => handleRenameProduct(p)} style={{ background: '#fff8e1', color: '#795548', border: '1px solid #ffe082', padding: '5px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}>✏️ 이름수정</button>
                <button onClick={() => handleRenameBrand(p)} style={{ background: '#fce4ec', color: '#ad1457', border: '1px solid #f8bbd0', padding: '5px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}>🏭 도매택</button>
                <button onClick={() => handleMergeGroup(p)} style={{ background: '#e0f7fa', color: '#00695c', border: '1px solid #80deea', padding: '5px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}>🔗 합치기</button>
                <button onClick={() => handleDeleteWholeProduct(p)} style={{ background: '#ffebee', color: '#c62828', border: '1px solid #ef9a9a', padding: '5px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}>🗑 삭제</button>
              </div>
            </div>
            );
          })}
          {uncategorizedProducts.length > 20 && (
            <div style={{ fontSize: '11px', color: '#c62828', marginTop: '4px' }}>
              +{uncategorizedProducts.length - 20}건 더 있음 (상위 20건만 표시)
            </div>
          )}
        </div>
      )}

      {/* [어드민 전용] 엑셀(TABLE) 뷰 */}
      {isAdmin && adminLayout === 'TABLE' ? (
        <>
          <div className="lb-table-mobile-hint" style={{ display: 'none', margin: '0 10px 10px', padding: '10px 12px', background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '8px', fontSize: '12px', color: '#795548', alignItems: 'center', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap' }}>
            <span>👉 표가 넓어서 옆으로 스크롤하면 나머지 칸이 보여요. 폰에서는 그리드뷰가 더 편해요.</span>
            <button onClick={() => setAdminLayout('GRID')} style={{ background: '#111', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}>🔲 그리드뷰로 보기</button>
          </div>
          <div style={{ padding: '0 10px', overflowX: 'auto', paddingBottom: '50px' }}>
          <table style={{ width: '100%', minWidth: '980px', borderCollapse: 'collapse', background: '#fff', fontSize: '13px', textAlign: 'left', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 5px rgba(0,0,0,0.05)' }}>
            <thead style={{ background: '#111', color: '#fff' }}>
              <tr>
                <th style={{ padding: '12px', width: '120px', whiteSpace: 'nowrap' }}>묶음기준 도매택</th>
                <th style={{ padding: '12px', width: '180px' }}>묶음기준 상품명</th>
                <th style={{ padding: '12px', width: '110px' }}>카테고리</th>
                <th style={{ padding: '12px', width: '70px', textAlign: 'center' }}>묶음 사진</th>
                <th style={{ padding: '12px', width: '70px', textAlign: 'center' }}>스토어 썸네일</th>
                <th style={{ padding: '12px', width: '140px' }}>스토어명</th>
                <th style={{ padding: '12px', width: '200px' }}>스토어 상품명</th>
                <th style={{ padding: '12px', width: '100px' }}>스토어 판매가</th>
                <th style={{ padding: '12px', width: '120px', textAlign: 'center' }}>액션</th>
              </tr>
            </thead>
            <tbody>
              {/* ✅ PERF: 어드민 테이블은 상품마다 판매처 행까지 펼쳐 그리므로 전체(수천 건)를
                  한 번에 렌더링하면 DOM이 수만 개가 되어 매우 느려짐. visibleCount로 제한. */}
              {displayProducts.slice(0, visibleCount).map((p) => {
                const links = getLinks(p);
                if (links.length === 0) return null;
                
                const sortedLinks = sortLinks(links);
                
                return sortedLinks.map((l, idx) => (
                  <tr key={l.id || `${p.id}-${idx}`} style={{ borderBottom: idx === sortedLinks.length - 1 ? '2px solid #ccc' : '1px solid #eee' }}>
                    {idx === 0 && (
                      <>
                        <td rowSpan={sortedLinks.length} style={{ padding: '10px', borderRight: '1px solid #eee', fontWeight: 'bold', color: '#333', verticalAlign: 'middle', textAlign: 'center' }}>
                          <span style={{ display: 'block', fontSize: '14px', marginBottom: '8px' }}>{p.brand_name}</span>
                          {/* ✅ NEW: 클릭수 표시 (products.click_count — upsert 후 보존 여부 눈으로 확인 가능) */}
                          <span style={{ display: 'block', fontSize: '11px', color: '#888', marginBottom: '8px' }}>🖱️ 클릭 {p.click_count || 0}</span>
                          <button onClick={() => handleRenameProduct(p)} style={{ background: '#e3f2fd', color: '#0d47a1', border: 'none', padding: '4px 8px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer', fontWeight: 'bold', marginRight: '4px' }}>✏️ 일괄수정</button>
                          <button onClick={() => handleRenameBrand(p)} style={{ background: '#fce4ec', color: '#ad1457', border: 'none', padding: '4px 8px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer', fontWeight: 'bold', marginRight: '4px' }}>🏭 도매택 수정</button>
                          <button onClick={() => openCategoryPicker(p)} style={{ background: '#fff8e1', color: '#795548', border: '1px solid #ffe082', padding: '4px 8px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer', fontWeight: 'bold', marginRight: '4px' }}>🏷️ 카테고리 변경</button>
                          <button onClick={() => handleMergeGroup(p)} style={{ background: '#e8f5e9', color: '#2e7d32', border: '1px solid #a5d6a7', padding: '4px 8px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer', fontWeight: 'bold' }}>🔗 통째로 합치기</button>
                        </td>
                        <td rowSpan={sortedLinks.length} style={{ padding: '10px', borderRight: '1px solid #eee', verticalAlign: 'middle' }}>
                          <span style={{ fontWeight: 'bold', fontSize: '14px', color: '#111' }}>{cleanTitleStr(p.title)}</span>
                        </td>
                                                <td rowSpan={sortedLinks.length} style={{ padding: '10px', borderRight: '1px solid #eee', textAlign: 'center', verticalAlign: 'middle', fontSize: '11px' }}>
                          <span style={{ padding: '4px 8px', borderRadius: '10px', background: getProductCategory(p) === '미분류' ? '#ffebee' : '#e8f5e9', color: getProductCategory(p) === '미분류' ? '#c62828' : '#2e7d32', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                            {getProductCategory(p)}
                          </span>
                        </td>
<td rowSpan={sortedLinks.length} style={{ padding: '10px', borderRight: '1px solid #eee', textAlign: 'center', verticalAlign: 'middle' }}>
                          <SmartImg src={p.image_url} width={150} alt="" loading="lazy" decoding="async" style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '6px', cursor: 'pointer', border: '1px solid #ddd' }} onClick={() => window.open(p.image_url, '_blank')} />
                        </td>
                      </>
                    )}
                    
                    <td style={{ padding: '10px', textAlign: 'center' }}>
                      {l.store_image ? (
                        <SmartImg 
                          src={l.store_image} width={150} alt="" loading="lazy" decoding="async" style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ccc', cursor: 'pointer' }} 
                          onClick={() => window.open(l.store_image, '_blank')} 
                        />
                      ) : (
                        <div style={{ width: '50px', height: '50px', background: '#f5f5f5', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#aaa', border: '1px dashed #ccc', margin: '0 auto' }}>NO IMG</div>
                      )}
                    </td>
                    <td style={{ padding: '10px' }}>
                      <span style={{ cursor: 'pointer', color: '#1565c0', textDecoration: 'underline', fontWeight: 'bold' }} onClick={() => window.open(l.product_url, '_blank')}>{l.store_name}</span>
                    </td>
                    <td style={{ padding: '10px', fontSize: '11px', color: '#555' }}>{l.store_title || "정보 없음"}</td>
                    <td style={{ padding: '10px', fontWeight: 'bold', color: '#e53935' }}>{Number(l.price).toLocaleString()}원</td>
                    <td style={{ padding: '10px', textAlign: 'center' }}>
                      <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                        <button onClick={() => handleReorder(p, sortedLinks, idx, idx - 1)} disabled={idx === 0} style={{ cursor: idx === 0 ? 'not-allowed' : 'pointer', background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px', padding: '4px 6px', fontSize: '11px' }}>▲</button>
                        <button onClick={() => handleReorder(p, sortedLinks, idx, idx + 1)} disabled={idx === sortedLinks.length - 1} style={{ cursor: idx === sortedLinks.length - 1 ? 'not-allowed' : 'pointer', background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px', padding: '4px 6px', fontSize: '11px' }}>▼</button>
                        <button onClick={() => handleSeparateProduct(l, p)} style={{ background: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '4px 6px', cursor: 'pointer' }} title="분리하기">✂️</button>
                        <button onClick={() => handleMergeProduct(l)} style={{ background: '#e8f5e9', color: '#2e7d32', border: '1px solid #a5d6a7', borderRadius: '4px', padding: '4px 6px', cursor: 'pointer' }} title="다른 상품에 합치기">🔗</button>
                        <button onClick={() => handleDeleteProduct(l)} style={{ background: '#ffebee', color: '#c62828', border: 'none', borderRadius: '4px', padding: '4px 6px', cursor: 'pointer' }} title="삭제">🗑️</button>
                      </div>
                    </td>
                  </tr>
                ));
              })}
            </tbody>
          </table>
          {/* ✅ PERF: 어드민 '더 보기' — 30개씩 추가 렌더링 */}
          {visibleCount < displayProducts.length && (
            <div style={{ textAlign: 'center', padding: '16px' }}>
              <button onClick={() => setVisibleCount(v => v + 30)}
                style={{ background: '#111', color: '#fff', border: 'none', padding: '10px 24px', borderRadius: '20px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}>
                더 보기 ({visibleCount} / {displayProducts.length})
              </button>
            </div>
          )}
          </div>
        </>
      ) : (
        /* 일반 유저 및 그리드 뷰 화면 */
        <main className={`product-grid lb-product-grid ${isAdmin ? 'lb-admin-grid' : ''}`} style={{ padding: '0 20px 50px' }}>
          {/* ✅ NEW: '찜' 탭인데 찜한 상품이 없을 때 안내 문구 */}
          {/* ===== LABEL_NEW_EMPTY: 신상 0건일 때 빈 화면 대신 안내 ===== */}
          {view === 'NEWARRIVAL' && products.length > 0 && displayProducts.length === 0 && (
            <div data-label="new-empty" style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '80px 20px', color: '#999' }}>
              <div style={{ fontSize: '40px', marginBottom: '10px' }}>✨</div>
              <p style={{ fontSize: '15px', fontWeight: 'bold' }}>
                {(category !== '전체' || searchQuery.trim() !== '') ? '이 조건으로 새로 올라온 상품이 없어요' : '최근 3일 동안 새로 올라온 상품이 없어요'}
              </p>
              <p style={{ fontSize: '13px', marginTop: '5px' }}>지금 많이 보는 상품을 둘러보세요</p>
              <button
                onClick={() => { setView('RANKING'); try { window.scrollTo(0, 0); } catch (e) {} }}
                style={{ marginTop: '16px', padding: '10px 20px', background: '#111', color: '#fff', border: 'none', borderRadius: '999px', fontSize: '13px', fontWeight: 700, cursor: 'pointer' }}
              >랭킹 보기</button>
            </div>
          )}
          {view === 'MY' && displayProducts.length === 0 && (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '80px 20px', color: '#999' }}>
              <div style={{ fontSize: '40px', marginBottom: '10px' }}>🤍</div>
              <p style={{ fontSize: '15px', fontWeight: 'bold' }}>아직 찜한 상품이 없어요</p>
              <p style={{ fontSize: '13px', marginTop: '5px' }}>마음에 드는 상품의 하트를 눌러보세요!</p>
            </div>
          )}
          {displayProducts.slice(0, visibleCount).map((p, idx) => {
            // ✅ NEW: 레퍼런스의 discount-label처럼 판매처 최저가/최고가 차이로 할인율 배지를 계산
            const cardPrices = getLinks(p).map(l => Number(l.price)).filter(pr => pr > 0);
            const cardMinPrice = cardPrices.length > 0 ? Math.min(...cardPrices) : 0;
            const cardMaxPrice = cardPrices.length > 0 ? Math.max(...cardPrices) : 0;
            const discountRate = (cardMinPrice > 0 && cardMaxPrice > cardMinPrice) ? Math.round(((cardMaxPrice - cardMinPrice) / cardMaxPrice) * 100) : 0;
            // ===== LABEL_CARD_MINPRICE =====
            // 카드에 찍을 가격은 '소비자에게 실제로 보이는 판매처'의 최저가여야 한다.
            // cardMinPrice는 getLinks(전체) 기준이라, 그로브 최저가 보호가 아직 안 돈
            // 구간에서는 화면에 없는 판매처의 가격이 찍힐 수 있다.
            const cardShownPrices = visibleLinks(p).map(l => Number(l.price)).filter(pr => pr > 0);
            const cardShownPrice = cardShownPrices.length > 0 ? Math.min(...cardShownPrices) : 0;
            // ===== LABEL_CARD_MINPRICE 끝 =====
            const isNewProduct = !!p.first_seen_at && (_newRef - new Date(p.first_seen_at).getTime()) < 48 * 3600 * 1000; // LABEL_NEW_RELATIVE

            return (
            <div key={p.id} className="lb-card" style={{ border: isAdmin ? '2px solid #e3f2fd' : 'none', position: 'relative' }}>
              <div onClick={() => { if (p.__dead) return; /* LABEL_FAV_DEAD */ handleCardClick(p); }} style={{ cursor: (isAdmin || p.__dead) ? 'default' : 'pointer' }}>
                <div className="lb-card-thumb">
                  {/* ✅ PERF: lazy loading + 네이버 CDN 리사이즈(f500) */}
                  {/* LABEL_FAV_DEAD */}
                  {p.__dead
                    ? <div style={{ width: '100%', height: '100%', background: '#ececec', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa', fontSize: '12px', letterSpacing: '0.05em' }}>정보 확인 불가</div>
                    : <SmartImg src={p.image_url} width={500} alt={cleanTitleStr(p.title)} loading="lazy" decoding="async" />}

                  {/* ✅ 랭킹 순위 뱃지 (유저 화면, RANKING 탭 전용) */}
                  {view === 'RANKING' && !isAdmin && (
                    <div className="lb-card-badge">{idx === 0 ? '1위' : idx === 1 ? '2위' : idx === 2 ? '3위' : `${idx + 1}위`}</div>
                  )}

                  {/* ✅ 할인 배지 — 판매처간 가격차가 15% 이상이면 최저가 기준 할인율 표시 (RANKING 탭 제외) */}
                  {view !== 'RANKING' && !isAdmin && discountRate >= 15 && (
                    <div className="lb-card-badge is-discount">-{discountRate}%</div>
                  )}

                  {/* NEW 배지 — first_seen_at이 48시간 이내이고, 할인 배지가 없을 때만 표시 */}
                  {view !== 'RANKING' && !isAdmin && discountRate < 15 && isNewProduct && (
                    <div className="lb-card-badge">NEW</div>
                  )}

                  {/* 찜하기 하트 버튼 */}
                  {!isAdmin && (
                    <div
                      onClick={(e) => toggleFavorite(e, p)}
                      className="lb-card-heart"
                    >
                      {favorites.includes(p.product_id) ? '❤️' : '🤍'}
                    </div>
                  )}
                </div>

                <div className="info" style={{ padding: '13px 2px 4px' }}>
                  <span className="lb-card-brand">{p.brand_name}</span>
                  <p className="lb-card-title">{cleanTitleStr(p.title)}</p>
                  {!isAdmin && (
                    view === 'RANKING' ? (
                      <div className="lb-card-meta" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>누적 클릭 {(p.click_count || 0).toLocaleString()}회</span>
                        {recentClicks[p.product_id] > 0 && <span style={{ color: '#c0392b', fontWeight: 700 }}>+{recentClicks[p.product_id]}</span>}
                      </div>
                    ) : (
                      <div className="lb-card-meta">
                        {/* ===== LABEL_CARD_MINPRICE: 판매처 수 숨김, 최저가만 ===== */}
                        {cardShownPrice > 0
                          ? <b style={{ color: '#111', fontWeight: 700 }}>{cardShownPrice.toLocaleString()}원</b>
                          : <span style={{ color: '#bbb' }}>{p.__dead ? '상품 정보를 확인할 수 없어요' : '가격 확인 필요'}</span>}
                      </div>
                    )
                  )}
                </div>
              </div>
              {isAdmin && (
                <div style={{ padding: '0 10px 10px' }}>
                  <button onClick={() => handleRenameProduct(p)} style={{ width: '100%', background: '#e3f2fd', fontSize: '11px', border:'none', padding:'4px', cursor: 'pointer', marginBottom: '5px' }}>✏️ 일괄수정</button>
                  <button onClick={() => handleRenameBrand(p)} style={{ width: '100%', background: '#fce4ec', color: '#ad1457', fontSize: '11px', border:'none', padding:'4px', cursor: 'pointer', marginBottom: '5px' }}>🏭 도매택 수정</button>
                  <button onClick={() => openCategoryPicker(p)} style={{ width: '100%', background: '#fff8e1', color: '#795548', fontSize: '11px', border:'1px solid #ffe082', borderRadius: '4px', padding:'4px', cursor: 'pointer', marginBottom: '5px' }}>🏷️ 카테고리 변경</button>
                  <button onClick={() => handleMergeGroup(p)} style={{ width: '100%', background: '#e8f5e9', color: '#2e7d32', fontSize: '11px', border:'1px solid #a5d6a7', borderRadius: '4px', padding:'4px', cursor: 'pointer', marginBottom: '5px' }}>🔗 통째로 합치기</button>
                  {/* ✅ NEW: 판매처별 썸네일 + 원제목 + 가격 표시 (분리/병합 판단용) */}
                  {sortLinks(getLinks(p)).map((l, idx, arr) => (
                    <div key={l.id} style={{ display: 'flex', fontSize: '12px', gap: '8px', padding: '8px 0', alignItems: 'flex-start', borderTop: '1px solid #f1f1f1' }}>
                      {/* 판매처 썸네일 */}
                      {l.store_image ? (
                        <SmartImg
                          src={l.store_image} width={150} alt="" loading="lazy" decoding="async"
                          style={{ width: '46px', height: '46px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd', cursor: 'pointer', flexShrink: 0 }}
                          onClick={() => window.open(l.store_image, '_blank')}
                        />
                      ) : (
                        <div style={{ width: '46px', height: '46px', background: '#f5f5f5', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px', color: '#aaa', border: '1px dashed #ccc', flexShrink: 0 }}>NO IMG</div>
                      )}

                      {/* 스토어명 / 원제목 / 가격 */}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ cursor: 'pointer', color: '#1565c0', textDecoration: 'underline', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} onClick={() => window.open(l.product_url, '_blank')}>
                          {l.store_name}
                        </div>
                        <div style={{ fontSize: '11px', color: '#555', lineHeight: 1.35, marginTop: '2px', wordBreak: 'break-all' }}>
                          {l.store_title || '정보 없음'}
                        </div>
                        <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#e53935', marginTop: '2px' }}>
                          {l.price ? `${Number(l.price).toLocaleString()}원` : '-'}
                        </div>

                        {/* 순서변경 + 작업 버튼 */}
                        <div style={{ display: 'flex', gap: '3px', marginTop: '5px', flexWrap: 'wrap' }}>
                          <button onClick={() => handleReorder(p, arr, idx, idx - 1)} disabled={idx === 0} style={{ padding: '3px 5px', fontSize: '10px', border: '1px solid #ddd', borderRadius: '4px', background: '#fafafa', cursor: idx === 0 ? 'not-allowed' : 'pointer' }}>▲</button>
                          <button onClick={() => handleReorder(p, arr, idx, idx + 1)} disabled={idx === arr.length - 1} style={{ padding: '3px 5px', fontSize: '10px', border: '1px solid #ddd', borderRadius: '4px', background: '#fafafa', cursor: idx === arr.length - 1 ? 'not-allowed' : 'pointer' }}>▼</button>
                          <button onClick={() => handleSeparateProduct(l, p)} style={{ cursor: 'pointer', padding: '3px 5px', fontSize: '12px', border: '1px solid #ccc', borderRadius: '4px', background: '#fff' }} title="분리하기">✂️</button>
                          <button onClick={() => handleMergeProduct(l)} style={{ cursor: 'pointer', padding: '3px 5px', fontSize: '12px', border: '1px solid #a5d6a7', borderRadius: '4px', background: '#e8f5e9' }} title="다른 상품에 합치기">🔗</button>
                          <button onClick={() => handleDeleteProduct(l)} style={{ cursor: 'pointer', padding: '3px 5px', fontSize: '12px', border: 'none', borderRadius: '4px', background: '#ffebee' }} title="삭제">🗑️</button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            );
          })}
          {/* ✅ NEW: 무한스크롤 감지 sentinel - 화면에 보이면 30개씩 더 로드 */}
          {visibleCount < displayProducts.length && (
            <div ref={loadMoreRef} style={{ gridColumn: '1 / -1', height: '40px' }} />
          )}
        </main>
      )}

      {/* ✅ NEW: 레퍼런스 스타일 푸터 */}
      {!isAdmin && (
        <footer style={{ borderTop: '1px solid #f0f0f0', marginTop: '10px', padding: '40px 32px 30px' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '24px', maxWidth: '1200px', margin: '0 auto' }}>
            <div>
              <div style={{ fontWeight: 800, fontSize: '17px', letterSpacing: '-0.01em', marginBottom: '8px', color: '#111' }}>동대문 트렌드를 한눈에</div>
              <p style={{ fontSize: '12px', color: '#999', lineHeight: 1.6, maxWidth: '260px' }}>
                트렌드 아카이빙, LABEL
              </p>
            </div>
            <div style={{ display: 'flex', gap: '28px', flexWrap: 'wrap' }}>
              <button onClick={() => setView('FEED')} className="lb-footer-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>피드</button>
              <button onClick={() => setView('BRAND')} className="lb-footer-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>브랜드</button>
              <button onClick={() => setShowBizGuideModal(true)} className="lb-footer-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>브랜드 입점 문의</button>
            </div>
          </div>
          <div style={{ maxWidth: '1200px', margin: '28px auto 0', paddingTop: '18px', borderTop: '1px solid #f5f5f5', fontSize: '11px', color: '#bbb', letterSpacing: '0.02em' }}>
            © {new Date().getFullYear()} LABEL. All rights reserved.
          </div>
        </footer>
      )}

      {/* 모달 팝업 */}
      {/* ===== LABEL_PROMO_POPUP: 당일 슬롯 프로모 팝업 ===== */}
      {promoSlot && !isAdmin && (
        <div onClick={closePromo} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1200, padding: '20px' }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '330px', overflow: 'hidden', position: 'relative', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
            <button onClick={closePromo} aria-label="닫기" style={{ position: 'absolute', top: '10px', right: '10px', background: 'rgba(0,0,0,0.45)', color: '#fff', border: 'none', width: '34px', height: '34px', borderRadius: '50%', fontSize: '16px', cursor: 'pointer', zIndex: 2 }}>✕</button>
            <div style={{ position: 'absolute', top: '12px', left: '12px', background: '#ff9800', color: '#fff', fontWeight: '900', fontSize: '11px', padding: '4px 10px', borderRadius: '20px', zIndex: 2 }}>📦 오늘 바로 발송</div>
            <img src={promoSlot.product_image} alt={promoSlot.product_title || ''} style={{ width: '100%', aspectRatio: '3 / 4', objectFit: 'cover', display: 'block', cursor: 'pointer' }} onClick={() => handlePromoClick(promoSlot)} />
            <div style={{ padding: '14px 16px 16px 16px' }}>
              <span style={{ display: 'inline-block', fontSize: '11px', background: '#f1f3f5', padding: '3px 8px', borderRadius: '4px', marginBottom: '6px' }}>{promoSlot.store_name}</span>
              <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', fontSize: '15px', color: '#111' }}>{promoSlot.product_title || '상품명 미등록'}</p>
              {promoSlot.price ? <p style={{ margin: '0 0 12px 0', fontWeight: '900', fontSize: '17px' }}>{Number(promoSlot.price).toLocaleString()}원</p> : <div style={{ height: '12px' }} />}
              <button onClick={() => handlePromoClick(promoSlot)} style={{ width: '100%', background: '#111', color: '#fff', border: 'none', padding: '13px', borderRadius: '10px', fontSize: '15px', fontWeight: 'bold', cursor: 'pointer' }}>재고 있음 · 바로 보러가기</button>
              <button onClick={closePromo} style={{ width: '100%', background: 'none', border: 'none', color: '#aaa', fontSize: '12px', padding: '10px 0 0 0', cursor: 'pointer' }}>다음에 볼게요</button>
            </div>
          </div>
        </div>
      )}
      {selectedProduct && !isAdmin && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} onClick={closeModal}>
          <div style={{ background: '#fff', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '420px', maxHeight: '85vh', overflowY: 'auto', position: 'relative' }} onClick={e => e.stopPropagation()}>
            <button onClick={closeModal} style={{ position: 'absolute', top: '15px', right: '15px', background: '#eee', border: 'none', width: '32px', height: '32px', borderRadius: '50%', fontSize: '16px', cursor: 'pointer', zIndex: 2 }}>✕</button>
            {/* ✅ NEW: 찜하기(하트) 버튼 — 닫기 버튼 왼쪽, 우측 상단 */}
            {!isAdmin && (
              <button
                onClick={(e) => toggleFavorite(e, selectedProduct)}
                style={{ position: 'absolute', top: '15px', right: '55px', background: '#eee', border: 'none', width: '32px', height: '32px', borderRadius: '50%', fontSize: '16px', cursor: 'pointer', zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                {favorites.includes(selectedProduct.product_id) ? '❤️' : '🤍'}
              </button>
            )}
            {/* ✅ NEW: 공유하기 버튼 */}
            <button onClick={() => handleShare(selectedProduct)} style={{ position: 'absolute', top: '15px', left: '15px', background: '#111', color: '#fff', border: 'none', padding: '8px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', zIndex: 2 }}>
              🔗 공유하기
            </button>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <img src={selectedProduct.image_url} alt={cleanTitleStr(selectedProduct.title)} style={{ width: '100%', maxHeight: '260px', borderRadius: '12px', objectFit: 'cover' }} />
              <div style={{ marginTop: '15px', textAlign: 'left' }}>
                <span style={{ display: 'inline-block', border: '1px solid #111', color: '#111', padding: '3px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold', marginBottom: '8px' }}>
                  {selectedProduct.brand_name}
                </span>
                <h3 style={{ margin: '0 0 10px 0', fontSize: '20px', color: '#111' }}>{cleanTitleStr(selectedProduct.title)}</h3>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {(() => {
                const links = visibleLinks(selectedProduct);
                if (links.length === 0) return <div style={{textAlign:'center', padding:'20px', color:'#999'}}>판매처 정보가 없습니다.</div>;

                const sortedLinks = sortLinks(links);
                const prices = sortedLinks.map(l => Number(l.price)).filter(pr => pr > 0);
                const minPrice = prices.length > 0 ? Math.min(...prices) : 0;

                return sortedLinks.map((link, idx) => {
                  const isMyStore = (link.store_id || "").toLowerCase() === 'samtandbyme' || (link.store_name || "").toLowerCase() === '샘트앤바이미';
                  
                  return (
                    <div key={link.id || idx} style={{
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px',
                      padding: '12px', background: isMyStore ? '#e3f2fd' : (idx === 0 ? '#fff8e1' : '#f9f9f9'), 
                      borderRadius: '8px', border: isMyStore ? '2px solid #1976d2' : (idx === 0 ? '1px solid #ffe082' : '1px solid #eee')
                    }}>
                      {/* ✅ NEW: 스토어 썸네일 — 각 판매처가 실제 올린 상품 사진. 잘 묶였는지 눈으로 확인용 */}
                      {link.store_image ? (
                        <img
                          src={link.store_image} alt=""
                          onClick={() => window.open(link.store_image, '_blank')}
                          style={{ width: '54px', height: '54px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #ddd', flexShrink: 0, cursor: 'zoom-in' }}
                        />
                      ) : (
                        <div style={{ width: '54px', height: '54px', background: '#f0f0f0', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px', color: '#bbb', flexShrink: 0 }}>NO IMG</div>
                      )}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: '13px', fontWeight: 'bold', color: isMyStore ? '#1565c0' : '#555' }}>
                          {isMyStore && <span style={{color: '#1565c0', marginRight: '6px'}}>👑fast</span>}
                          {!isMyStore && Number(link.price) === minPrice && <span style={{color: '#e53935', marginRight: '6px'}}>🔥최저가</span>}
                          {link.store_name}
                        </div>
                        {/* ✅ NEW: 스토어가 올린 실제 상품명 — 같은 상품이 맞는지 확인 */}
                        {link.store_title && (
                          <div style={{ fontSize: '11px', color: '#999', marginTop: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '180px' }}>
                            {link.store_title}
                          </div>
                        )}
                        <div style={{ fontSize: '16px', fontWeight: '900', marginTop: '4px', color: '#111' }}>
                          {Number(link.price).toLocaleString()}원
                        </div>
                      </div>
                      <button 
                        onClick={() => window.open(link.product_url, '_blank')}
                        style={{ background: isMyStore ? '#1565c0' : '#111', color: '#fff', border: 'none', padding: '10px 16px', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: 'bold', flexShrink: 0 }}
                      >
                        이동
                      </button>
                    </div>
                  );
                });
              })()}
            </div>
          </div>
        </div>
      )}

      {/* ✅ NEW: 도매 브랜드 입점 안내 모달 (8번) - 실제 가격/비딩 방식 안내 */}
      {/* ===== LABEL_APPLY: 입점 신청 (도매/소매 공용) ===== */}
      {showApplyModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1100 }} onClick={() => setShowApplyModal(false)}>
          <div style={{ background: '#fff', padding: '28px 24px', borderRadius: '16px', width: '90%', maxWidth: '420px', maxHeight: '85vh', overflowY: 'auto', position: 'relative' }} onClick={e => e.stopPropagation()}>
            <button onClick={() => setShowApplyModal(false)} style={{ position: 'absolute', top: '15px', right: '15px', background: '#eee', border: 'none', width: '32px', height: '32px', borderRadius: '50%', fontSize: '16px', cursor: 'pointer' }}>✕</button>

            {applyStep === 'guide' ? (
              <div>
                <h2 style={{ margin: '0 0 4px 0', fontSize: '20px' }}>당일발송 입점 안내</h2>
                <p style={{ fontSize: '13px', color: '#888', marginBottom: '24px' }}>재고 보유 소매점 공식 입점관</p>

                <div style={{ background: '#f9f9f9', borderRadius: '10px', padding: '16px', marginBottom: '14px' }}>
                  <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '6px' }}>📌 입점비 — 무료 (오픈 기념)</div>
                  <p style={{ fontSize: '13px', color: '#555', lineHeight: '1.6', margin: 0 }}>
                    슬롯 1개를 드립니다. 당일 탭에 상품이 노출되고, 상품을 보는 손님에게 팝업으로도 한 번 더 보여드려요.
                  </p>
                </div>

                <div style={{ background: '#f9f9f9', borderRadius: '10px', padding: '16px', marginBottom: '14px' }}>
                  <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '6px' }}>📦 운영 방식</div>
                  <p style={{ fontSize: '13px', color: '#555', lineHeight: '1.6', margin: 0 }}>
                    상품 주소만 넣으면 사진과 가격이 자동으로 채워집니다. 매일 직접 교체하고, 재고가 떨어지면 바로 내릴 수 있어요.
                  </p>
                </div>

                <div style={{ background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '10px', padding: '16px', marginBottom: '20px' }}>
                  <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '6px' }}>🚩 지켜주셔야 할 것</div>
                  <p style={{ fontSize: '13px', color: '#555', lineHeight: '1.6', margin: 0 }}>
                    실제 재고가 있는 상품만 올려주세요. 재고 없이 올라온 상품은 신고 3건이 쌓이면 자동으로 차단됩니다.
                  </p>
                </div>

                <button onClick={() => setApplyStep('form')} style={{ width: '100%', background: '#ff9800', color: '#fff', padding: '14px', borderRadius: '10px', fontWeight: 'bold', border: 'none', cursor: 'pointer', fontSize: '15px' }}>
                  슬롯 신청하기
                </button>
              </div>
            ) : (
              <div>
                <h2 style={{ margin: '0 0 4px 0', fontSize: '20px' }}>{applyType === 'daily' ? '당일발송 슬롯 신청' : 'LABEL PREMIERE 입점 신청'}</h2>
                <p style={{ fontSize: '13px', color: '#888', marginBottom: '20px' }}>연락처만 남겨주시면 확인 후 연락드릴게요.</p>

                <input placeholder="연락처 (필수)" value={applyForm.phone} onChange={e => setApplyForm({ ...applyForm, phone: e.target.value })} style={{ width: '100%', padding: '11px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px', boxSizing: 'border-box', fontSize: '14px' }} />
                <input placeholder="담당자 성함" value={applyForm.name} onChange={e => setApplyForm({ ...applyForm, name: e.target.value })} style={{ width: '100%', padding: '11px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px', boxSizing: 'border-box', fontSize: '14px' }} />
                <input placeholder={applyType === 'daily' ? '스토어 이름' : '브랜드 이름'} value={applyForm.bizName} onChange={e => setApplyForm({ ...applyForm, bizName: e.target.value })} style={{ width: '100%', padding: '11px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px', boxSizing: 'border-box', fontSize: '14px' }} />
                <input placeholder="스토어 URL" value={applyForm.storeUrl} onChange={e => setApplyForm({ ...applyForm, storeUrl: e.target.value })} style={{ width: '100%', padding: '11px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px', boxSizing: 'border-box', fontSize: '14px' }} />
                <textarea placeholder="하고 싶은 말 (선택)" value={applyForm.memo} onChange={e => setApplyForm({ ...applyForm, memo: e.target.value })} rows={3} style={{ width: '100%', padding: '11px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '16px', boxSizing: 'border-box', fontSize: '14px', resize: 'vertical' }} />

                <button onClick={submitApplication} style={{ width: '100%', background: applyType === 'daily' ? '#ff9800' : '#e53935', color: '#fff', padding: '14px', borderRadius: '10px', fontWeight: 'bold', border: 'none', cursor: 'pointer', fontSize: '15px' }}>
                  신청서 보내기
                </button>
                <p style={{ fontSize: '12px', color: '#aaa', textAlign: 'center', margin: '12px 0 0 0' }}>전화 문의 010-3929-9229</p>
              </div>
            )}
          </div>
        </div>
      )}
      {showBizGuideModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} onClick={() => setShowBizGuideModal(false)}>
          <div style={{ background: '#fff', padding: '28px 24px', borderRadius: '16px', width: '90%', maxWidth: '420px', maxHeight: '85vh', overflowY: 'auto', position: 'relative' }} onClick={e => e.stopPropagation()}>
            <button onClick={() => setShowBizGuideModal(false)} style={{ position: 'absolute', top: '15px', right: '15px', background: '#eee', border: 'none', width: '32px', height: '32px', borderRadius: '50%', fontSize: '16px', cursor: 'pointer' }}>✕</button>
            <h2 style={{ margin: '0 0 4px 0', fontSize: '20px' }}>LABEL PREMIERE 입점 안내</h2>
            <p style={{ fontSize: '13px', color: '#888', marginBottom: '24px' }}>동대문 상위 1% 도매 브랜드 공식 입점관</p>

            <div style={{ background: '#f9f9f9', borderRadius: '10px', padding: '16px', marginBottom: '14px' }}>
              <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '6px' }}>📌 기본 입점 — 무료 (오픈 기념)</div>
              <p style={{ fontSize: '13px', color: '#555', lineHeight: '1.6', margin: 0 }}>
                BRAND 탭에 브랜드가 노출되며, 다른 입점 브랜드들과 함께 순서가 랜덤으로 로테이션됩니다.
              </p>
            </div>

            <div style={{ background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '10px', padding: '16px', marginBottom: '20px' }}>
              <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '6px' }}>🔥 상단 고정 — 실시간 입찰(비딩) 방식</div>
              <p style={{ fontSize: '13px', color: '#555', lineHeight: '1.6', margin: '0 0 10px 0' }}>
                1만원 단위로 추가 입찰하면 상단 고정 노출 순위가 정해집니다. 입찰가가 가장 높은 브랜드가 1등 자리에 고정 노출됩니다.
              </p>
              <div style={{ fontSize: '12px', color: '#795548', background: '#fff', borderRadius: '6px', padding: '10px', lineHeight: '1.7' }}>
                예) A 브랜드가 40,000원 입찰 → A가 1등 고정<br/>
                이후 B 브랜드가 50,000원 입찰 → B가 1등, A는 2등으로 밀림
              </div>
            </div>

            <button style={{ width: '100%', background: '#e53935', color: '#fff', padding: '14px', borderRadius: '10px', fontWeight: 'bold', border: 'none', cursor: 'pointer', fontSize: '15px' }} onClick={() => openApply('brand', 'form')}>
              입점 신청하기
            </button>
          </div>
        </div>
      )}

      {/* ✅ NEW: 카테고리 변경 — 타이핑 대신 클릭으로 카테고리를 고르는 모달 */}
      {categoryPickerProduct && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} onClick={() => setCategoryPickerProduct(null)}>
          <div style={{ background: '#fff', padding: '24px 20px', borderRadius: '16px', width: '90%', maxWidth: '420px', maxHeight: '80vh', overflowY: 'auto', position: 'relative' }} onClick={e => e.stopPropagation()}>
            <button onClick={() => setCategoryPickerProduct(null)} style={{ position: 'absolute', top: '15px', right: '15px', background: '#eee', border: 'none', width: '32px', height: '32px', borderRadius: '50%', fontSize: '16px', cursor: 'pointer' }}>✕</button>
            <h3 style={{ margin: '0 0 4px 0', fontSize: '17px' }}>🏷️ 카테고리 선택</h3>
            <p style={{ fontSize: '13px', color: '#888', marginBottom: '18px' }}>
              <b>{categoryPickerProduct.brand_name}</b> · {cleanTitleStr(categoryPickerProduct.title)}
            </p>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#555', marginBottom: '12px', cursor: 'pointer' }}>
              <input type="checkbox" checked={singleProductMode} onChange={e => setSingleProductMode(e.target.checked)} />
              이 상품만 지정 (키워드 등록 없이, 다른 상품엔 영향 없음)
            </label>
<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px' }}>
              {allCategories.filter(c => c !== '전체').map(c => (
                <button
                  key={c}
                  onClick={() => singleProductMode ? handleAssignSingleProduct(categoryPickerProduct, c) : handleAssignToCategory(categoryPickerProduct, c)}
                  style={{ padding: '9px 14px', borderRadius: '20px', border: '1px solid #ddd', background: '#f8f9fa', color: '#111', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}
                >
                  {c}
                </button>
              ))}
            </div>
            <button
              onClick={() => handleCreateCategory(categoryPickerProduct)}
              style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px dashed #aaa', background: '#fff', color: '#555', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}
            >
              ➕ 새 카테고리 만들기
            </button>
          </div>
        </div>
      )}

      {/* ✅ NEW: 소매상 본인 슬롯 상품 교체 모달 */}
      {showSlotManageModal && (() => {
        const mySlot = dailySlots.find(s => s.owner_user_id === user?.id && !s.is_banned);
        return (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} onClick={() => setShowSlotManageModal(false)}>
            <div style={{ background: '#fff', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '400px', maxHeight: '85vh', overflowY: 'auto', position: 'relative' }} onClick={e => e.stopPropagation()}>
              <button onClick={() => setShowSlotManageModal(false)} style={{ position: 'absolute', top: '15px', right: '15px', background: '#eee', border: 'none', width: '32px', height: '32px', borderRadius: '50%', fontSize: '16px', cursor: 'pointer' }}>✕</button>
              <h2 style={{ margin: '0 0 4px 0', fontSize: '18px' }}>📦 내 당일 슬롯 관리</h2>
              <p style={{ fontSize: '12px', color: '#888', marginBottom: '16px' }}>{mySlot?.store_name} · 신고 누적 {mySlot?.report_count || 0}/3</p>

              {/* ===== LABEL_SWAP_URLFILL: URL 한 줄 자동채우기 ===== */}
              <div style={{ border: '1px dashed #ff9800', background: '#fff8ee', borderRadius: '8px', padding: '12px', marginBottom: '16px' }}>
                <div style={{ fontWeight: 'bold', fontSize: '13px', marginBottom: '8px' }}>상품 주소로 한 번에 채우기</div>
                <input
                  placeholder="상품 주소 붙여넣기 (smartstore.naver.com/...)"
                  value={slotSwapForm.url}
                  onChange={e => setSlotSwapForm({ ...slotSwapForm, url: e.target.value })}
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box' }}
                />
                <button onClick={lookupSwapByUrl} style={{ width: '100%', background: '#111', color: '#fff', padding: '10px', borderRadius: '8px', fontWeight: 'bold', border: 'none', cursor: 'pointer', fontSize: '13px' }}>불러오기</button>
                {slotSwapForm.image && (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                    <img src={slotSwapForm.image} alt="" style={{ width: '54px', height: '72px', objectFit: 'cover', borderRadius: '6px', flexShrink: 0 }} />
                    <div style={{ fontSize: '12px', lineHeight: 1.5 }}>
                      <div style={{ fontWeight: 'bold' }}>{slotSwapForm.title || '(상품명 없음)'}</div>
                      <div>{slotSwapForm.price ? Number(slotSwapForm.price).toLocaleString() + '원' : '(가격 없음)'}</div>
                    </div>
                  </div>
                )}
                <div style={{ fontSize: '11px', color: '#999', marginTop: '8px' }}>못 찾으면 아래 칸에 직접 입력하세요.</div>
              </div>
              <label style={{ fontSize: '12px', fontWeight: 'bold', display: 'block', marginBottom: '4px' }}>상품명</label>
              <input value={slotSwapForm.title} onChange={e => setSlotSwapForm({ ...slotSwapForm, title: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px', boxSizing: 'border-box' }} />

              <label style={{ fontSize: '12px', fontWeight: 'bold', display: 'block', marginBottom: '4px' }}>이미지 URL</label>
              <input value={slotSwapForm.image} onChange={e => setSlotSwapForm({ ...slotSwapForm, image: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px', boxSizing: 'border-box' }} />

              <label style={{ fontSize: '12px', fontWeight: 'bold', display: 'block', marginBottom: '4px' }}>구매 링크</label>
              <input value={slotSwapForm.url} onChange={e => setSlotSwapForm({ ...slotSwapForm, url: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px', boxSizing: 'border-box' }} />

              <label style={{ fontSize: '12px', fontWeight: 'bold', display: 'block', marginBottom: '4px' }}>가격(원)</label>
              <input type="number" value={slotSwapForm.price} onChange={e => setSlotSwapForm({ ...slotSwapForm, price: e.target.value })} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '16px', boxSizing: 'border-box' }} />

              <button onClick={() => mySlot && handleSwapSlotProduct(mySlot.id, slotSwapForm)} style={{ width: '100%', background: '#ff9800', color: '#fff', padding: '12px', borderRadius: '10px', fontWeight: 'bold', border: 'none', cursor: 'pointer' }}>
                상품 교체 저장
              </button>
              {/* ===== LABEL_SLOT_CLEAR: 상품 내리기 ===== */}
              {mySlot && mySlot.product_url && (
                <button onClick={() => handleClearSlotProduct(mySlot.id)} style={{ width: '100%', marginTop: '8px', background: 'transparent', color: '#e53935', border: '1px solid #f3c9c7', padding: '11px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' }}>
                  상품 내리기
                </button>
              )}
            </div>
          </div>
        );
      })()}

      {/* ✅ NEW: [어드민] 당일 슬롯 발급/관리 패널 */}
      {showAdminSlotPanel && isAdmin && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} onClick={() => setShowAdminSlotPanel(false)}>
          <div style={{ background: '#fff', padding: '24px', borderRadius: '16px', width: '92%', maxWidth: '560px', maxHeight: '85vh', overflowY: 'auto', position: 'relative' }} onClick={e => e.stopPropagation()}>
            <button onClick={() => setShowAdminSlotPanel(false)} style={{ position: 'absolute', top: '15px', right: '15px', background: '#eee', border: 'none', width: '32px', height: '32px', borderRadius: '50%', fontSize: '16px', cursor: 'pointer' }}>✕</button>
            <h2 style={{ margin: '0 0 16px 0', fontSize: '18px' }}>📦 당일 슬롯 관리</h2>
            {/* ===== LABEL_APPLY_ADMIN: 입점 신청 목록 ===== */}
            <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontWeight: 'bold', fontSize: '13px' }}>입점 신청 ({slotApplications.length})</div>
                <div style={{ display: 'flex', gap: '6px' }}>
                  <button onClick={fetchSlotApplications} style={{ background: '#eee', border: 'none', borderRadius: '6px', padding: '5px 10px', fontSize: '11px', cursor: 'pointer' }}>새로고침</button>
                  <button onClick={() => setShowSlotApplyList(v => !v)} style={{ background: '#eee', border: 'none', borderRadius: '6px', padding: '5px 10px', fontSize: '11px', cursor: 'pointer' }}>{showSlotApplyList ? '접기' : '펼치기'}</button>
                </div>
              </div>
              {showSlotApplyList && (
                <div style={{ marginTop: '10px' }}>
                  {slotApplyLoading && (
                    <div style={{ fontSize: '12px', color: '#999' }}>불러오는 중…</div>
                  )}
                  {!slotApplyLoading && slotApplications.length === 0 && (
                    <div style={{ fontSize: '12px', color: '#999' }}>접수된 신청이 없어요.</div>
                  )}
                  {!slotApplyLoading && slotApplications.map((a, i) => (
                    <div key={a.id || (a.created_at + '_' + i)} style={{ border: '1px solid #f0f0f0', borderRadius: '8px', padding: '10px', marginBottom: '8px', fontSize: '12px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                        <b>{a.biz_name || '(상호 없음)'}</b>
                        <span style={{ fontSize: '11px', color: '#888' }}>
                          {a.apply_type === 'retail' ? '소매' : a.apply_type === 'wholesale' ? '도매' : (a.apply_type || '-')}
                          {a.user_id ? ' · 회원' : ' · 비회원'}
                        </span>
                      </div>
                      <div style={{ color: '#555', lineHeight: 1.6 }}>
                        <div>{a.contact_name || '(이름 없음)'} · {a.phone || '(연락처 없음)'}</div>
                        {a.store_url && (
                          <div style={{ wordBreak: 'break-all' }}>
                            <a href={a.store_url} target="_blank" rel="noreferrer" style={{ color: '#1565c0' }}>{a.store_url}</a>
                          </div>
                        )}
                        {a.memo && <div style={{ color: '#888' }}>{a.memo}</div>}
                        <div style={{ fontSize: '11px', color: '#aaa' }}>
                          {a.created_at ? new Date(a.created_at).toLocaleString('ko-KR') : ''}
                        </div>
                      </div>
                      <button
                        onClick={() => applyToSlotForm(a)}
                        style={{ width: '100%', marginTop: '8px', background: '#111', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}
                      >
                        이 신청으로 발급
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div style={{ background: '#f9f9f9', borderRadius: '10px', padding: '16px', marginBottom: '20px' }}>
              {/* ===== LABEL_SLOT_URLFILL: URL 한 줄 자동채우기 ===== */}
              <div style={{ border: '1px dashed #ff9800', background: '#fff8ee', borderRadius: '8px', padding: '12px', marginBottom: '14px' }}>
                <div style={{ fontWeight: 'bold', fontSize: '13px', marginBottom: '8px' }}>상품 URL로 자동 채우기</div>
                <input
                  placeholder="상품 주소 붙여넣기 (smartstore.naver.com/...)"
                  value={newSlotForm.url}
                  onChange={e => setNewSlotForm({ ...newSlotForm, url: e.target.value })}
                  style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box', fontSize: '12px' }}
                />
                <button onClick={lookupSlotByUrl} style={{ width: '100%', background: '#111', color: '#fff', padding: '9px', borderRadius: '6px', fontWeight: 'bold', border: 'none', cursor: 'pointer', fontSize: '13px' }}>불러오기</button>
                {newSlotForm.image && (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '10px' }}>
                    <img src={newSlotForm.image} alt="" style={{ width: '54px', height: '72px', objectFit: 'cover', borderRadius: '6px', flexShrink: 0 }} />
                    <div style={{ fontSize: '12px', lineHeight: 1.5 }}>
                      <div style={{ fontWeight: 'bold' }}>{newSlotForm.title || '(상품명 없음)'}</div>
                      <div>{newSlotForm.price ? Number(newSlotForm.price).toLocaleString() + '원' : '(가격 없음)'}</div>
                    </div>
                  </div>
                )}
              </div>
              <div style={{ fontWeight: 'bold', fontSize: '13px', marginBottom: '10px' }}>새 슬롯 발급</div>
              <input placeholder="소매상 user_id (SQL로 조회한 UUID)" value={newSlotForm.ownerId} onChange={e => setNewSlotForm({ ...newSlotForm, ownerId: e.target.value })} style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box', fontSize: '12px' }} />
              <input placeholder="소매상 스토어명" value={newSlotForm.storeName} onChange={e => setNewSlotForm({ ...newSlotForm, storeName: e.target.value })} style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box', fontSize: '12px' }} />
              <input placeholder="상품명 (선택, 나중에 소매상이 직접 입력 가능)" value={newSlotForm.title} onChange={e => setNewSlotForm({ ...newSlotForm, title: e.target.value })} style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box', fontSize: '12px' }} />
              {/* ===== LABEL_SLOT_MANUAL: DB에 없는 상품용 직접 입력 ===== */}
              <input
                placeholder="이미지 주소 (상품 사진 우클릭 → 이미지 주소 복사)"
                value={newSlotForm.image}
                onChange={e => setNewSlotForm({ ...newSlotForm, image: e.target.value })}
                style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box', fontSize: '12px' }}
              />
              <input
                type="number"
                placeholder="가격(원)"
                value={newSlotForm.price}
                onChange={e => setNewSlotForm({ ...newSlotForm, price: e.target.value })}
                style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box', fontSize: '12px' }}
              />
              {/* ===== LABEL_OWNER_EMAIL: 이메일로 user_id 찾기 ===== */}
              <div style={{ border: '1px dashed #90caf9', background: '#f3f9ff', borderRadius: '8px', padding: '10px', marginBottom: '10px' }}>
                <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '6px' }}>소매상 이메일로 찾기</div>
                <input
                  placeholder="소매상 이메일 (LABEL 로그인 계정)"
                  value={slotOwnerEmail}
                  onChange={e => setSlotOwnerEmail(e.target.value)}
                  style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ddd', marginBottom: '6px', boxSizing: 'border-box', fontSize: '12px' }}
                />
                <button onClick={lookupOwnerByEmail} style={{ width: '100%', background: '#1565c0', color: '#fff', padding: '8px', borderRadius: '6px', fontWeight: 'bold', border: 'none', cursor: 'pointer', fontSize: '12px' }}>회원 찾기</button>
                <div style={{ fontSize: '11px', color: '#999', marginTop: '6px' }}>소매상이 LABEL에 카카오 로그인을 한 번 해야 찾을 수 있어요.</div>
              </div>
              <button
                onClick={async () => {
                  if (!newSlotForm.ownerId.trim() || !newSlotForm.storeName.trim()) { alert('user_id와 스토어명은 필수예요.'); return; }
                  await handleCreateSlot(newSlotForm);
                  setNewSlotForm({ ownerId: '', storeName: '', title: '', image: '', url: '', price: '' });
                }}
                style={{ width: '100%', background: '#ff9800', color: '#fff', padding: '10px', borderRadius: '8px', fontWeight: 'bold', border: 'none', cursor: 'pointer', fontSize: '13px' }}
              >
                슬롯 발급
              </button>
            </div>

            <div style={{ fontWeight: 'bold', fontSize: '13px', marginBottom: '10px' }}>전체 슬롯 목록 ({dailySlots.length})</div>
            {dailySlots.map(slot => (
              <div key={slot.id} style={{ border: '1px solid #eee', borderRadius: '8px', padding: '10px', marginBottom: '8px', fontSize: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <b>{slot.store_name}</b>
                  <span style={{ color: slot.is_banned ? '#e53935' : slot.is_active ? '#2e7d32' : '#999' }}>
                    {slot.is_banned ? '🚫 차단됨' : slot.is_active ? '✅ 활성' : '⏸ 비활성'} · 신고 {slot.report_count || 0}/3
                  </span>
                </div>
                <div style={{ color: '#666', marginTop: '4px' }}>{slot.product_title || '(상품 미등록)'} {slot.price ? `· ${slot.price.toLocaleString()}원` : ''}</div>
                {/* ===== LABEL_SLOT_STATS: 슬롯별 노출/클릭 ===== */}
                {(() => {
                  const st = slotStats[String(slot.id)] || {};
                  const n = (v) => Number(v || 0).toLocaleString();
                  return (
                    <div style={{ marginTop: '6px', fontSize: '11px', color: '#555', background: '#f7f7f7', borderRadius: '6px', padding: '6px 8px' }}>
                      누적 노출 <b>{n(st.imp_total)}</b> · 클릭 <b>{n(st.click_total)}</b>
                      <span style={{ color: '#f57c00', marginLeft: '8px' }}>오늘 노출 <b>{n(st.imp_today)}</b> · 클릭 <b>{n(st.click_today)}</b></span>
                    </div>
                  );
                })()}
                {(slot.report_count || 0) > 0 && (
                  <button onClick={() => showSlotReporters(slot)} style={{ marginTop: '6px', marginRight: '6px', background: 'transparent', color: '#f57c00', border: '1px solid #ffcc80', padding: '5px 10px', borderRadius: '6px', fontSize: '11px', cursor: 'pointer' }}>🚩 신고 내역</button>
                )}
                {/* ===== LABEL_SLOT_DELETE ===== */}
                <button onClick={() => handleDeleteSlot(slot)} style={{ marginTop: '6px', marginRight: '6px', background: 'transparent', color: '#e53935', border: '1px solid #f3c9c7', padding: '5px 10px', borderRadius: '6px', fontSize: '11px', cursor: 'pointer' }}>🗑 삭제</button>
                {slot.is_banned && (
                  <button onClick={() => handleReactivateSlot(slot)} style={{ marginTop: '6px', background: '#111', color: '#fff', border: 'none', padding: '5px 10px', borderRadius: '6px', fontSize: '11px', cursor: 'pointer' }}>
                    복구(신고 초기화)
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 카카오 로그인 락인 유도 팝업 */}
      {showLoginModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}>
            <div style={{ background: '#fff', padding: '40px 30px', borderRadius: '20px', textAlign: 'center', maxWidth: '320px', width: '90%' }}>
                <div style={{ fontSize: '40px', marginBottom: '10px' }}>🔒</div>
                <h2 style={{ margin: '0 0 15px 0', fontSize: '22px' }}>더 많은 트렌드 보기</h2>
                <p style={{ fontSize: '14px', color: '#666', marginBottom: '30px', lineHeight: '1.6' }}>
                    비회원은 하루 5개의 상품만<br/>상세 확인이 가능합니다.<br/><br/>
                    <b>1초 카카오 로그인</b>하시고<br/>도매택 최신 트렌드를<br/>무제한으로 훔쳐보세요!
                </p>
                <button onClick={signInWithKakao} style={{ width: '100%', padding: '16px', background: '#FEE500', color: '#000000', border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', marginBottom: '10px' }}>
                    카카오로 1초 만에 시작하기
                </button>
                <button onClick={() => setShowLoginModal(false)} style={{ background: 'transparent', border: 'none', color: '#999', fontSize: '14px', cursor: 'pointer', textDecoration: 'underline' }}>닫기</button>
            </div>
        </div>
      )}

      {/* ✅ NEW: 홈 화면에 추가(PWA 설치) 배너 */}
      <InstallPrompt />
    </div>
  );
}

export default App;
